/* eslint-disable */
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = T | null | undefined;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string };
  String: { input: string; output: string };
  Boolean: { input: boolean; output: boolean };
  Int: { input: number; output: number };
  Float: { input: number; output: number };
  /** The `DateTime` scalar represents an ISO-8601 compliant date time type. */
  DateTime: { input: any; output: any };
  /** Custom scalar that behaves like a long. */
  GraphQLLong: { input: any; output: any };
  JSON: { input: any; output: any };
  /** The `Long` scalar type represents non-fractional signed whole 64-bit numeric values. Long can represent values between -(2^63) and 2^63 - 1. */
  Long: { input: any; output: any };
  SafeString: { input: any; output: any };
  /** The `TimeSpan` scalar represents an ISO-8601 compliant duration type. */
  TimeSpan: { input: any; output: any };
  URL: { input: any; output: any };
  /** The `Upload` scalar type represents a file upload. */
  Upload: { input: any; output: any };
};

export type AddressInput = {
  city: Scalars['String']['input'];
  country?: InputMaybe<Scalars['String']['input']>;
  latitude?: InputMaybe<Scalars['Float']['input']>;
  longitude?: InputMaybe<Scalars['Float']['input']>;
  number: Scalars['String']['input'];
  state?: InputMaybe<Scalars['String']['input']>;
  street: Scalars['String']['input'];
  zipCode: Scalars['String']['input'];
};

export type AddressPayloadModel = {
  __typename?: 'AddressPayloadModel';
  /** Contains the name of the city or null if not set. */
  city?: Maybe<Scalars['String']['output']>;
  /** Contains the geo-location of the address or null if not set. */
  coordinates?: Maybe<Coordinates>;
  /** Contains the name of the country or null if not set. */
  country?: Maybe<Scalars['String']['output']>;
  /** Determines the unique identifier for this object. */
  id: Scalars['Int']['output'];
  /** If true, this address object cannot be modified. */
  isReadOnly: Scalars['Boolean']['output'];
  /** Contains the house number or null if not set. */
  number?: Maybe<Scalars['String']['output']>;
  /** Contains the name of the state or null if not set. */
  state?: Maybe<Scalars['String']['output']>;
  /** Contains the street name or null if not set. */
  street?: Maybe<Scalars['String']['output']>;
  /** Contains the zip-code or null if not set. */
  zipCode?: Maybe<Scalars['String']['output']>;
};

/** Defines when a policy shall be executed. */
export enum ApplyPolicy {
  /** After the resolver was executed. */
  AfterResolver = 'AFTER_RESOLVER',
  /** Before the resolver was executed. */
  BeforeResolver = 'BEFORE_RESOLVER',
  /** The policy is applied in the validation step before the execution. */
  Validation = 'VALIDATION',
}

export type AppointmentCalendarItemPayloadModel = {
  __typename?: 'AppointmentCalendarItemPayloadModel';
  branchOffice?: Maybe<BranchOfficePayloadModel>;
  endAtUtc?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['Int']['output'];
  isBinding?: Maybe<Scalars['Boolean']['output']>;
  partnerCompanies?: Maybe<Array<PartnerCompanyPayloadModel>>;
  startAtUtc?: Maybe<Scalars['DateTime']['output']>;
  teams?: Maybe<Array<TeamPayloadModel>>;
  users?: Maybe<Array<UserPayloadModel>>;
  workOrder?: Maybe<WorkOrderPayloadModel>;
  workflowDefinition?: Maybe<WorkflowDefinitionPayloadModel>;
};

export type AppointmentConstructionCraftsmenPayloadModel = {
  __typename?: 'AppointmentConstructionCraftsmenPayloadModel';
  /** The info for the craftman assigned to the appointment. */
  craftsman?: Maybe<UserPayloadModel>;
  /** Determines the unique identifier for this object. */
  id: Scalars['Int']['output'];
};

export type AppointmentConstructionTeamPayloadModel = {
  __typename?: 'AppointmentConstructionTeamPayloadModel';
  /** Determines the unique identifier for this object. */
  id: Scalars['Int']['output'];
  /** The info for the team assigned to the appointment. */
  team?: Maybe<TeamPayloadModel>;
};

export enum AppointmentErrorType {
  BranchOfficeNotFound = 'BRANCH_OFFICE_NOT_FOUND',
  Failed = 'FAILED',
  FieldNotFound = 'FIELD_NOT_FOUND',
  InvalidInput = 'INVALID_INPUT',
  InvalidStatus = 'INVALID_STATUS',
  InvalidStatusAborted = 'INVALID_STATUS_ABORTED',
  InvalidStatusDeleted = 'INVALID_STATUS_DELETED',
  InvalidStatusDone = 'INVALID_STATUS_DONE',
  InvalidStatusOpen = 'INVALID_STATUS_OPEN',
  InvalidStatusStarted = 'INVALID_STATUS_STARTED',
  InvalidStatusTransition = 'INVALID_STATUS_TRANSITION',
  InvalidTeam = 'INVALID_TEAM',
  InvalidTerminatorField = 'INVALID_TERMINATOR_FIELD',
  InvalidUserStatus = 'INVALID_USER_STATUS',
  None = 'NONE',
  NotFound = 'NOT_FOUND',
  NoTeam = 'NO_TEAM',
  PartnerCompanyNotFound = 'PARTNER_COMPANY_NOT_FOUND',
  TeamNotFound = 'TEAM_NOT_FOUND',
  UserNotFound = 'USER_NOT_FOUND',
  ValidationError = 'VALIDATION_ERROR',
  WorkflowDefinitionNotFound = 'WORKFLOW_DEFINITION_NOT_FOUND',
  WorkflowNotReady = 'WORKFLOW_NOT_READY',
  WorkflowSyntaxError = 'WORKFLOW_SYNTAX_ERROR',
  WorkOrderDeleted = 'WORK_ORDER_DELETED',
  WorkOrderNotFound = 'WORK_ORDER_NOT_FOUND',
}

export type AppointmentPayloadModel = {
  __typename?: 'AppointmentPayloadModel';
  /** The end date of the appointment. */
  endDateUtc?: Maybe<Scalars['DateTime']['output']>;
  /** The expected duration of this appointment. */
  expectedDuration?: Maybe<Scalars['TimeSpan']['output']>;
  /** Determines the unique identifier for this object. */
  id: Scalars['Int']['output'];
  /** The start date of the appointment. */
  startDateUtc?: Maybe<Scalars['DateTime']['output']>;
  /** Contains a text that is supposed to be displayed on the start-screen of the appointment before it is started. */
  startScreenInformation?: Maybe<Scalars['String']['output']>;
  /** The status of this appointment. */
  status?: Maybe<AppointmentStatus>;
  /** The type of this appointment. */
  type?: Maybe<Scalars['String']['output']>;
};

export enum AppointmentStatus {
  Aborted = 'ABORTED',
  Deleted = 'DELETED',
  Done = 'DONE',
  Open = 'OPEN',
  Paused = 'PAUSED',
  Scheduled = 'SCHEDULED',
  Started = 'STARTED',
}

export type AppointmentTypePayloadModel = {
  __typename?: 'AppointmentTypePayloadModel';
  /** Determines the unique identifier for this appointment type. */
  id: Scalars['Int']['output'];
  /** The name of the appointment type. */
  name?: Maybe<Scalars['String']['output']>;
};

export enum ApprovalState {
  ClientApproved = 'CLIENT_APPROVED',
  Open = 'OPEN',
  Pending = 'PENDING',
  Rejected = 'REJECTED',
  Resubmitted = 'RESUBMITTED',
  ServerApproved = 'SERVER_APPROVED',
  Undoed = 'UNDOED',
}

export type AssignCraftCompanyToAppointmentInput = {
  appointmentId: Scalars['Int']['input'];
  partnerCompanyIds: Array<Scalars['Long']['input']>;
};

/** This input receives the id of the user and one team id. */
export type AssignUserToTeamInput = {
  /** Property that indicates the ID of the team. */
  teamId?: InputMaybe<Scalars['Int']['input']>;
  /** Property that indicates the ID of the user. */
  userId: Scalars['Int']['input'];
};

/** This input receives the ID of the appointment and the ID of the team id. */
export type AttachTeamToAppointmentInput = {
  /** Property that indicates the ID of the appointment. */
  appointmentId: Scalars['Int']['input'];
  /** Property that indicates the ID of the team. */
  teamId: Scalars['Int']['input'];
};

export type AttachTeamToAppointmentPayloadModel = {
  __typename?: 'AttachTeamToAppointmentPayloadModel';
  /** Property that indicates all the users that were assigned to the appointment. */
  users?: Maybe<Array<UserPayloadModel>>;
};

export type AttachUserToAppointmentAssignmentPayloadModel = {
  __typename?: 'AttachUserToAppointmentAssignmentPayloadModel';
  assignment: Scalars['Boolean']['output'];
  userId: Scalars['Int']['output'];
};

/** This input receives the ID of the appointment and one or more user ids. */
export type AttachUserToAppointmentInput = {
  /** Property that indicates the ID of the appointment. */
  appointmentId: Scalars['Int']['input'];
  /** Property that indicates the users IDs of the user. */
  userIds: Array<Scalars['Int']['input']>;
};

export type AttachUserToAppointmentPayloadModel = {
  __typename?: 'AttachUserToAppointmentPayloadModel';
  /** Property that indicates for all the input user ids if the assignment was sucessful or not. */
  assignments: Array<AttachUserToAppointmentAssignmentPayloadModel>;
};

export type BlockerCalendarItemPayloadModel = {
  __typename?: 'BlockerCalendarItemPayloadModel';
  branchOffice?: Maybe<BranchOfficePayloadModel>;
  comment?: Maybe<Scalars['String']['output']>;
  endAtUtc?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['Int']['output'];
  partnerCompanies?: Maybe<Array<PartnerCompanyPayloadModel>>;
  reason?: Maybe<BlockerReasonPayloadModel>;
  startAtUtc?: Maybe<Scalars['DateTime']['output']>;
  teams?: Maybe<Array<TeamPayloadModel>>;
  users?: Maybe<Array<UserPayloadModel>>;
};

export enum BlockerErrorType {
  BlockerNotFound = 'BLOCKER_NOT_FOUND',
  BranchOfficeNotFound = 'BRANCH_OFFICE_NOT_FOUND',
  CraftCompanyNotFound = 'CRAFT_COMPANY_NOT_FOUND',
  None = 'NONE',
  ReasonNotFound = 'REASON_NOT_FOUND',
  TeamNotFound = 'TEAM_NOT_FOUND',
  UserNotFound = 'USER_NOT_FOUND',
  ValidationError = 'VALIDATION_ERROR',
}

export type BlockerReasonPayloadModel = {
  __typename?: 'BlockerReasonPayloadModel';
  /** Determines the unique identifier for this object. */
  id: Scalars['Int']['output'];
  /** Contains the title of the reason. */
  title?: Maybe<Scalars['String']['output']>;
};

export enum BranchOfficeErrorType {
  Failed = 'FAILED',
  None = 'NONE',
  NotFound = 'NOT_FOUND',
  ValidationError = 'VALIDATION_ERROR',
}

export type BranchOfficePayloadModel = {
  __typename?: 'BranchOfficePayloadModel';
  /** Determines the unique identifier for this object. */
  id: Scalars['Int']['output'];
  /** Whether this entity is deleted or not. */
  isDeleted?: Maybe<Scalars['Boolean']['output']>;
  /** Contains the name of the branch office or null if not set. */
  name?: Maybe<Scalars['String']['output']>;
};

export enum CalendarItemErrorType {
  None = 'NONE',
  ValidationError = 'VALIDATION_ERROR',
}

export type CalendarItemPayloadModel = AppointmentCalendarItemPayloadModel | BlockerCalendarItemPayloadModel;

export type CloseAppointmentInput = {
  appointmentId: Scalars['Int']['input'];
  autoApproveWorkItems: Scalars['Boolean']['input'];
};

export type Coordinates = {
  __typename?: 'Coordinates';
  latitude: Scalars['Float']['output'];
  longitude: Scalars['Float']['output'];
};

export enum CraftCompanyErrorType {
  None = 'NONE',
  ValidationError = 'VALIDATION_ERROR',
}

export type CraftCompanyPayloadModel = {
  __typename?: 'CraftCompanyPayloadModel';
  /** Determines the unique identifier for this object. */
  id: Scalars['Int']['output'];
  /** Contains the name of the craft company. */
  name?: Maybe<Scalars['String']['output']>;
};

export type CreateDeviceSubscriptionInput = {
  /** Sets the device identifier. Must not be null or empty. */
  deviceIdentifier?: InputMaybe<Scalars['String']['input']>;
  /** Sets the token for the device. Must not be null or empty. */
  deviceToken?: InputMaybe<Scalars['String']['input']>;
  /** Sets the device platform. */
  platform?: InputMaybe<MobilePlatform>;
};

export type CreateTeamInput = {
  /** The branch office id related with this entity. */
  branchOfficeId: Scalars['Int']['input'];
  /** The members ids related with this entity. */
  memberIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** The name of this team. */
  name: Scalars['String']['input'];
  /** The workflow definitions ids related with this entity. */
  workflowDefinitionIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type CreateTeamPayloadModel = {
  __typename?: 'CreateTeamPayloadModel';
  /** Determines the branch office related to this entity, if any. */
  branchOffice: BranchOfficePayloadModel;
  /** Determines the unique identifier for this object. */
  id: Scalars['Int']['output'];
  /** Whether this entity is deleted or not. */
  isDeleted: Scalars['Boolean']['output'];
  /** Determines the members related to this entity, if any. */
  members?: Maybe<Array<UserPayloadModel>>;
  /** Contains the name of the team. */
  name?: Maybe<Scalars['String']['output']>;
  /** Determines the skills related to this entity, if any. */
  skills?: Maybe<Array<SkillPayloadModel>>;
};

export enum CustomerErrorType {
  CustomerNotFound = 'CUSTOMER_NOT_FOUND',
  Failed = 'FAILED',
  None = 'NONE',
  ValidationError = 'VALIDATION_ERROR',
}

export type CustomerPayloadModel = {
  __typename?: 'CustomerPayloadModel';
  /** Contains the email of the customer or null if not set. */
  eMail?: Maybe<Scalars['String']['output']>;
  /** Contains the firstname of the customer or null if not set. Most likely null if customer is a company. */
  firstName?: Maybe<Scalars['String']['output']>;
  /** Determines the unique identifier for this object. */
  id: Scalars['Int']['output'];
  /** Contains the lastname of the customer or null if not set. Most likely null if customer is a company. */
  lastName?: Maybe<Scalars['String']['output']>;
  /** Contains the mobile phone number of the customer or null if not set. */
  mobilePhoneNumber?: Maybe<Scalars['String']['output']>;
  /** Contains the name of the customer or null if not set. Can be a company name or firstname + lastname if private person. */
  name?: Maybe<Scalars['String']['output']>;
  /** Contains the phone number of the customer or null if not set. */
  phoneNumber?: Maybe<Scalars['String']['output']>;
  /** Contains the powercloud id of the customer or null if not set. */
  powerCloudId?: Maybe<Scalars['String']['output']>;
};

export enum DecideFieldValueEntryErrorType {
  AlreadyDecided = 'ALREADY_DECIDED',
  AppointmentNotRunning = 'APPOINTMENT_NOT_RUNNING',
  ConcurrencyFailure = 'CONCURRENCY_FAILURE',
  Failed = 'FAILED',
  None = 'NONE',
  NotFound = 'NOT_FOUND',
  Unauthorized = 'UNAUTHORIZED',
  ValidationError = 'VALIDATION_ERROR',
}

/** This input receives the ID of the field value entry, the decision (approval state), the Submitted in UTC time and the Rejected Reason. */
export type DecideFieldValueEntryInput = {
  /** Property that indicates the decision type. */
  decision: ApprovalState;
  /** Property that indicates the ID of the field value entry. */
  fieldValueEntryId?: InputMaybe<Scalars['GraphQLLong']['input']>;
  /** Property that indicates the rejected reason. */
  rejectReason?: InputMaybe<Scalars['String']['input']>;
  /** Property that indicates the submitted date in UTC. */
  submittedAtUtc: Scalars['DateTime']['input'];
};

/** Decide one or more photos inside an image-array FieldValueEntry. */
export type DecideFieldValueItemsInput = {
  decisions: Array<DecideItemInput>;
};

export type DecideItemInput = {
  arrayIndex: Scalars['Int']['input'];
  decision: ApprovalState;
  fieldValueEntryId?: InputMaybe<Scalars['GraphQLLong']['input']>;
  mediaId?: InputMaybe<Scalars['Int']['input']>;
  rejectReason?: InputMaybe<Scalars['String']['input']>;
  submittedAtUtc: Scalars['DateTime']['input'];
};

export type DeleteAppointmentInput = {
  /** The unique identifier of the appointment to be deleted. */
  appointmentId: Scalars['Int']['input'];
};

export type DeleteBlockerInput = {
  /** The unique identifier of the blocker. */
  blockerId: Scalars['Int']['input'];
};

export type DeleteDeviceSubscriptionInput = {
  /** Sets the device identifier. Must not be null or empty. */
  deviceIdentifier?: InputMaybe<Scalars['String']['input']>;
  /** Sets the token for the device. Must not be null or empty. */
  deviceToken?: InputMaybe<Scalars['String']['input']>;
};

export enum DeviceErrorType {
  None = 'NONE',
  ValidationError = 'VALIDATION_ERROR',
}

export type ExampleImagePayloadModel = {
  __typename?: 'ExampleImagePayloadModel';
  contentType?: Maybe<Scalars['String']['output']>;
  imageUrl?: Maybe<Scalars['String']['output']>;
  length?: Maybe<Scalars['Long']['output']>;
  mediaId?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type FieldAcceptanceCriteriaPayloadModel = {
  __typename?: 'FieldAcceptanceCriteriaPayloadModel';
  bulletPoints?: Maybe<Array<Scalars['String']['output']>>;
  description?: Maybe<Scalars['String']['output']>;
  exampleImages?: Maybe<Array<ExampleImagePayloadModel>>;
  headline?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type FieldValueEntryItemDecisionPayload = {
  __typename?: 'FieldValueEntryItemDecisionPayload';
  approvalState: ApprovalState;
  arrayIndex: Scalars['Int']['output'];
  decisionMadeAtUtc?: Maybe<Scalars['DateTime']['output']>;
  decisionMadeById?: Maybe<Scalars['Int']['output']>;
  mediaId?: Maybe<Scalars['Int']['output']>;
  rejectReason?: Maybe<Scalars['String']['output']>;
};

export type FieldValueEntryPayloadModel = {
  __typename?: 'FieldValueEntryPayloadModel';
  /** Contains the current state of this value. */
  approvalState: ApprovalState;
  /** Optional note/comment provided with this submission. */
  comment?: Maybe<Scalars['String']['output']>;
  /** Determines the point in time when this object has been created. This is in UTC. */
  createdAtUtc?: Maybe<Scalars['DateTime']['output']>;
  /** Contains the user that has initially submitted the value. */
  createdBy?: Maybe<UserPayloadModel>;
  /** Contains the point in time (in UTC) when an approval or rejection decision has been made or null, if no decision has been made yet. */
  decisionMadeAtUtc?: Maybe<Scalars['DateTime']['output']>;
  /** Contains the user that made the approval or rejection decision or null, if it has not yet been decided upon. */
  decisionMadeBy?: Maybe<UserPayloadModel>;
  /** Determines the unique identifier for this object. */
  id: Scalars['GraphQLLong']['output'];
  /** Determines fields of this type are array fields. */
  isArray: Scalars['Boolean']['output'];
  itemDecisions?: Maybe<Array<FieldValueEntryItemDecisionPayload>>;
  /** Contains the value of last submition at UTC. */
  lastSubmitAtUtc: Scalars['DateTime']['output'];
  /** Contains the user that has last submitted a value. */
  lastSubmitBy?: Maybe<UserPayloadModel>;
  /** If this value has been rejected, this field contains the reason in human readable text. Null in all other cases. */
  rejectReason?: Maybe<Scalars['String']['output']>;
  /** Determines the type of values that can be stored by fields following this definition have. */
  type: ValueType;
  value?: Maybe<Scalars['String']['output']>;
};

export enum FieldValueErrorType {
  Failed = 'FAILED',
  FieldDoesNotExistInWorkflow = 'FIELD_DOES_NOT_EXIST_IN_WORKFLOW',
  InvalidAppointmentStatus = 'INVALID_APPOINTMENT_STATUS',
  InvalidJson = 'INVALID_JSON',
  None = 'NONE',
  NotFound = 'NOT_FOUND',
  TooManyValuesForNonArrayField = 'TOO_MANY_VALUES_FOR_NON_ARRAY_FIELD',
  Validation = 'VALIDATION',
  ValidationError = 'VALIDATION_ERROR',
  WorkflowHasNoFields = 'WORKFLOW_HAS_NO_FIELDS',
}

export enum FileErrorType {
  FolderNotFound = 'FOLDER_NOT_FOUND',
  FolderWorkOrderMismatch = 'FOLDER_WORK_ORDER_MISMATCH',
  IncorrectFieldType = 'INCORRECT_FIELD_TYPE',
  InternalError = 'INTERNAL_ERROR',
  None = 'NONE',
  NotFound = 'NOT_FOUND',
  PermissionDenied = 'PERMISSION_DENIED',
  Unsafe = 'UNSAFE',
  ValidationError = 'VALIDATION_ERROR',
  WorkOrderNotFound = 'WORK_ORDER_NOT_FOUND',
}

export type FileUploadRequestInput = {
  fileName: Scalars['String']['input'];
  mimeType: Scalars['String']['input'];
};

export type GenerateAppointmentReportInput = {
  appointmentId: Scalars['Int']['input'];
};

export enum GenerateSignedUrlForFileErrorType {
  InternalError = 'INTERNAL_ERROR',
  None = 'NONE',
  ValidationError = 'VALIDATION_ERROR',
}

export type GenerateSignedUrlForFilePayloadModel = {
  __typename?: 'GenerateSignedUrlForFilePayloadModel';
  /** Contains signed url to chosen file from Azure container. */
  signedUrl?: Maybe<Scalars['URL']['output']>;
};

export type GenerateSingedUrlForFileInput = {
  fileName: Scalars['String']['input'];
  filePath: Scalars['String']['input'];
  mimeType?: InputMaybe<Scalars['String']['input']>;
};

export enum GenerateUploadSignedUrlsForWorkOrderErrorType {
  InternalError = 'INTERNAL_ERROR',
  None = 'NONE',
  ValidationError = 'VALIDATION_ERROR',
  WorkOrderNotFound = 'WORK_ORDER_NOT_FOUND',
}

export type GenerateUploadSignedUrlsForWorkOrderInput = {
  desiredFiles: Array<FileUploadRequestInput>;
  workOrderId: Scalars['Int']['input'];
};

export type GenerateUploadSignedUrlsForWorkOrderPayloadModel = {
  __typename?: 'GenerateUploadSignedUrlsForWorkOrderPayloadModel';
  /** Contains signed url to upload file to Azure container. */
  signedUrl?: Maybe<Scalars['URL']['output']>;
  uploadId: Scalars['Int']['output'];
};

export type GenerateWorkOrderReportInput = {
  workOrderId: Scalars['Int']['input'];
};

export type GenerateZipAppointmentPicturesInput = {
  appointmentId: Scalars['Int']['input'];
};

export type GetAppointmentAppointmentPayloadModel = {
  __typename?: 'GetAppointmentAppointmentPayloadModel';
  /** Contains the branch office responsible for this appointment. Must be activated in the request. */
  branchOffice?: Maybe<BranchOfficePayloadModel>;
  /** May contain a free-text comment regarding this appointment. */
  comment?: Maybe<Scalars['String']['output']>;
  /** Contains the info for the craftsmen assigned to the appointment. */
  constructedByCraftsmen?: Maybe<Array<AppointmentConstructionCraftsmenPayloadModel>>;
  /** Contains the info for the teams assigned to the appointment. */
  constructedByTeams?: Maybe<Array<AppointmentConstructionTeamPayloadModel>>;
  /** The end date of the appointment. */
  endDateUtc?: Maybe<Scalars['DateTime']['output']>;
  /** The expected duration of this appointment. */
  expectedDuration?: Maybe<Scalars['TimeSpan']['output']>;
  /** Determines the unique identifier for this object. */
  id: Scalars['Int']['output'];
  /** Contains the info, if this appointment is fixed and all parties have agreed to it. */
  isBinding: Scalars['Boolean']['output'];
  /** Contains the branch office responsible for this appointment. Must be activated in the request. */
  partnerCompanies?: Maybe<Array<PartnerCompanyPayloadModel>>;
  /** The start date of the appointment. */
  startDateUtc?: Maybe<Scalars['DateTime']['output']>;
  /** Contains a text that is supposed to be displayed on the start-screen of the appointment before it is started. */
  startScreenInformation?: Maybe<Scalars['String']['output']>;
  /** The status of this appointment. */
  status?: Maybe<AppointmentStatus>;
  /** The type of this appointment. */
  type?: Maybe<Scalars['String']['output']>;
  /** Contains the work order this appointment is assigned to. */
  workOrder?: Maybe<GetAppointmentWorkOrderPayloadModel>;
  /** Contains the workflow definition for this appointment. This cannot change. Is only set after the appointment has started. */
  workflowDefinition?: Maybe<WorkflowDefinitionPayloadModel>;
  /** Contains the workflow definition version for this appointment. Is NULL for not-yet-started appointments. */
  workflowDefinitionVersion?: Maybe<WorkflowDefinitionVersionPayloadModel>;
};

export type GetAppointmentInput = {
  /** Identifies the appointment to be retrieved. */
  appointmentId: Scalars['Int']['input'];
  includeBranchOffice?: InputMaybe<Scalars['Boolean']['input']>;
  includeMaterials?: InputMaybe<Scalars['Boolean']['input']>;
  includeMedia?: InputMaybe<Scalars['Boolean']['input']>;
  includePartnerCompanies?: InputMaybe<Scalars['Boolean']['input']>;
};

export type GetAppointmentMediaPayloadModel = {
  __typename?: 'GetAppointmentMediaPayloadModel';
  /** The creation date of the file. */
  createdAtUtc?: Maybe<Scalars['DateTime']['output']>;
  /** Contains the user that has initially submitted the file. */
  createdBy?: Maybe<UserPayloadModel>;
  /** Contains the original filename the file had when it was uploaded. */
  fileName?: Maybe<Scalars['String']['output']>;
  /** Contains the size of the file in bytes. */
  fileSize?: Maybe<Scalars['Long']['output']>;
  /** Contains the folder name of the file. */
  folderName?: Maybe<Scalars['String']['output']>;
  /** Determines the unique identifier for this object. */
  id: Scalars['Int']['output'];
  /** Is true if the file can be downloaded, is false if the file cannot be downloaded due to security constraints. */
  isSafe: Scalars['Boolean']['output'];
  /** Contains the mimetype of the file. */
  mimeType?: Maybe<Scalars['String']['output']>;
  /** Contains the URL at which this blob can be downloaded. */
  uri?: Maybe<Scalars['String']['output']>;
  /** Contains text that describes the result of a virus scan. Is empty if the file has not yet been scanned. */
  virusScanResult?: Maybe<Scalars['String']['output']>;
};

export type GetAppointmentPayloadModel = {
  __typename?: 'GetAppointmentPayloadModel';
  /** Contains the metadata of the requested appointment. */
  appointment?: Maybe<GetAppointmentAppointmentPayloadModel>;
  /** If requested, contains all files associated with the work order the requested appointment is associated with. */
  media?: Maybe<Array<GetAppointmentMediaPayloadModel>>;
};

export type GetAppointmentUserPayloadModel = {
  __typename?: 'GetAppointmentUserPayloadModel';
  /** Determines the e-mail address of the user. */
  eMail?: Maybe<Scalars['String']['output']>;
  /** Determines the firstname of the user. */
  firstName?: Maybe<Scalars['String']['output']>;
  /** Determines the unique identifier for this object. */
  id: Scalars['Int']['output'];
  /** Whether this entity is deleted or not. */
  isDeleted: Scalars['Boolean']['output'];
  /** Determines the lastname of the user. */
  lastName?: Maybe<Scalars['String']['output']>;
  /** Determines the mobile phone of the user. */
  mobilePhone?: Maybe<Scalars['String']['output']>;
  /** Determines the phone of the user. */
  phone?: Maybe<Scalars['String']['output']>;
};

export type GetAppointmentWorkOrderMaterialPayloadModel = {
  __typename?: 'GetAppointmentWorkOrderMaterialPayloadModel';
  /** Gets or sets the number of times the associated material is required. */
  amount: Scalars['Int']['output'];
  /** Determines the unique identifier for this object. */
  id: Scalars['Int']['output'];
  /** Contains the actual material that has been used for this appointment. */
  material?: Maybe<MaterialPayloadModel>;
};

export type GetAppointmentWorkOrderPayloadModel = {
  __typename?: 'GetAppointmentWorkOrderPayloadModel';
  /** Contains the name of the customer or null if not set. Can be a company name or firstname + lastname if private person. */
  approvalState: ApprovalState;
  /** Contains the point in time when this tuple has been created. */
  createdAtUtc?: Maybe<Scalars['DateTime']['output']>;
  /** Contains all the customers of this appointment. */
  customers?: Maybe<Array<WorkOrderCustomerPayloadModelOfCustomerPayloadModel>>;
  /** Determines the eaasId for this object. */
  eaasId?: Maybe<Scalars['String']['output']>;
  /** Determines the unique identifier for this object. */
  id: Scalars['Int']['output'];
  /** Contains the data for the documents related to the work order. */
  locationImage?: Maybe<MediaPayloadModel>;
  /** Contains a list of materials. Is only populated when the corresponding request flag has been set. */
  materials?: Maybe<Array<GetAppointmentWorkOrderMaterialPayloadModel>>;
  /** Contains the point in time when this tuple has been modified last or null if it has never been modified. */
  modifiedAtUtc?: Maybe<Scalars['DateTime']['output']>;
  /** Contains the name of the work order. */
  name?: Maybe<Scalars['String']['output']>;
  /** Gets the number of blocking values that have been submitted below this node. Blocking values prevent craftspeople from continuing their work. */
  numberOfBlockedFields: Scalars['Int']['output'];
  /** Contains the number of solar panel module fields to be constructed during the job. This is only used for Solor jobs, not for heat pump jobs, for example. */
  numberOfModuleFields?: Maybe<Scalars['Int']['output']>;
  /** Contains the number of solar panel modules to be constructed during the job. This is only used for Solor jobs, not for heat pump jobs, for example. */
  numberOfModules?: Maybe<Scalars['Int']['output']>;
  /** Contains the number of re-submitted field values entries within this work order. */
  numberOfResubmitted: Scalars['Int']['output'];
  /** Contains the number of planar rectangles to cover with solar panels. This is only used for Solor jobs, not for heat pump jobs, for example. */
  numberOfRoofs?: Maybe<Scalars['Int']['output']>;
  /** Contains the number of newly submitted field values entries within this work order. */
  numberOfSubmitted: Scalars['Int']['output'];
  /** Determines the product being sold in this work order. Known as 'Contract Package' in CRM. */
  product?: Maybe<ProductPayloadModel>;
  /** Determines the project manager associated to the work order. */
  projectManager?: Maybe<GetAppointmentUserPayloadModel>;
  /** Determines the quality manager associated to the work order. */
  qualityManager?: Maybe<GetAppointmentUserPayloadModel>;
  /** Contains the Address associated to the work order. */
  readOnlyAddress?: Maybe<AddressPayloadModel>;
};

export type GetAppointmentWorkforceInput = {
  /** Identifies the appointment to be retrieved. */
  appointmentId: Scalars['Int']['input'];
};

export type GetAppointmentWorkforcePayloadModel = {
  __typename?: 'GetAppointmentWorkforcePayloadModel';
  /** Contains the craftsmen related with this appointment. */
  craftsmen?: Maybe<Array<GetAppointmentWorkforceUserPayloadModel>>;
  /** The end date of the appointment. */
  endDateUtc?: Maybe<Scalars['DateTime']['output']>;
  /** The expected duration of this appointment. */
  expectedDuration?: Maybe<Scalars['TimeSpan']['output']>;
  /** Determines the unique identifier for this object. */
  id: Scalars['Int']['output'];
  /** The start date of the appointment. */
  startDateUtc?: Maybe<Scalars['DateTime']['output']>;
  /** Contains a text that is supposed to be displayed on the start-screen of the appointment before it is started. */
  startScreenInformation?: Maybe<Scalars['String']['output']>;
  /** The status of this appointment. */
  status?: Maybe<AppointmentStatus>;
  /** Contains the teams related with this appointment. */
  teams?: Maybe<Array<GetAppointmentWorkforceTeamPayloadModel>>;
  /** The type of this appointment. */
  type?: Maybe<Scalars['String']['output']>;
};

export type GetAppointmentWorkforceTeamPayloadModel = {
  __typename?: 'GetAppointmentWorkforceTeamPayloadModel';
  /** Contains the Branch office assigned to the Team. */
  branchOffice?: Maybe<BranchOfficePayloadModel>;
  /** Determines the unique identifier for this object. */
  id: Scalars['Int']['output'];
  /** Whether this entity is deleted or not. */
  isDeleted?: Maybe<Scalars['Boolean']['output']>;
  /** Contains the name of the team. */
  name?: Maybe<Scalars['String']['output']>;
};

export type GetAppointmentWorkforceUserPayloadModel = {
  __typename?: 'GetAppointmentWorkforceUserPayloadModel';
  /** Determines the unique identifier for the Team. */
  defaultTeamId?: Maybe<Scalars['Int']['output']>;
  /** Determines the e-mail address of the user. */
  eMail?: Maybe<Scalars['String']['output']>;
  /** Determines the firstname of the user. */
  firstName?: Maybe<Scalars['String']['output']>;
  /** Determines the unique identifier for this object. */
  id: Scalars['Int']['output'];
  /** Whether this entity is deleted or not. */
  isDeleted?: Maybe<Scalars['Boolean']['output']>;
  /** Determines the lastname of the user. */
  lastName?: Maybe<Scalars['String']['output']>;
  /** Determines the mobile phone of the user. */
  mobilePhone?: Maybe<Scalars['String']['output']>;
  /** Determines the phone of the user. */
  phone?: Maybe<Scalars['String']['output']>;
};

export type GetAppointmentsAppointmentPayloadModel = {
  __typename?: 'GetAppointmentsAppointmentPayloadModel';
  /** Contains the info for the craftmen assigned to the appointment. */
  constructedByCraftsmen?: Maybe<Array<AppointmentConstructionCraftsmenPayloadModel>>;
  /** Contains the info for the teams assigned to the appointment. */
  constructedByTeams?: Maybe<Array<AppointmentConstructionTeamPayloadModel>>;
  /** The end date of the appointment. */
  endDateUtc?: Maybe<Scalars['DateTime']['output']>;
  /** The expected duration of this appointment. */
  expectedDuration?: Maybe<Scalars['TimeSpan']['output']>;
  /** Determines the unique identifier for this object. */
  id: Scalars['Int']['output'];
  /** Contains the info, if this appointment is fixed and all parties have agreed to it. */
  isBinding: Scalars['Boolean']['output'];
  /** The start date of the appointment. */
  startDateUtc?: Maybe<Scalars['DateTime']['output']>;
  /** Contains a text that is supposed to be displayed on the start-screen of the appointment before it is started. */
  startScreenInformation?: Maybe<Scalars['String']['output']>;
  /** The status of this appointment. */
  status?: Maybe<AppointmentStatus>;
  /** The type of this appointment. */
  type?: Maybe<Scalars['String']['output']>;
  /** Contains data relating to the Work Order the Appointment pertains to. */
  workOrder?: Maybe<GetAppointmentsWorkOrderPayloadModel>;
  /** Contains the workflow definition for this appointment. This cannot change. */
  workflowDefinition?: Maybe<WorkflowDefinitionPayloadModel>;
};

export type GetAppointmentsInput = {
  /** If set, the endpoint will only return appointments related with this Branch. */
  branchOfficeId?: InputMaybe<Scalars['Int']['input']>;
  /** If set, the endpoint will only return fixed appointments when all the parties have agreed to it. */
  isBinding?: InputMaybe<Scalars['Boolean']['input']>;
  /** If set, the endpoint will only return appointments before this point in time. */
  notAfterUtc?: InputMaybe<Scalars['DateTime']['input']>;
  /** If set, the endpoint will only return appointments after this point in time. */
  notBeforeUtc?: InputMaybe<Scalars['DateTime']['input']>;
  /** If false, the caller can see all appointments, if true the caller can only see their own appointments. If the caller is not a branch manager, this flag is always true. */
  onlyReturnMyAssginedAppointments?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * Sets the sorting. By default, the response will be sorted by first name (asc), then last name (asc).
   *
   * Valid columns to sort by are: id, firstName, lastName
   */
  orderBy?: InputMaybe<Array<SortDescriptionInput>>;
  /** Sets the page number and size of elements to return. */
  page?: InputMaybe<PageInput>;
  /** If set, we will search for the properties Name,FirstName,LastName,City,Street,Number,ZipCode */
  search?: InputMaybe<Scalars['String']['input']>;
  /** Supply the states by which to filter. If null, no state filter will be applied. */
  states?: InputMaybe<Array<AppointmentStatus>>;
  /** If set, the endpoint will only return appointments related with this Team. */
  teamId?: InputMaybe<Scalars['Int']['input']>;
  /**
   * An optional array of workflow definition names. If set, the endpoint
   * only returns appointments that are assigned to one of the specified workflow definitions.
   * Possible values are:
   *
   * AC-Montagetermin
   * AC-Montagetermin (verlängert)
   * AC-Nachbesserungstermin (AG-verschuldet)
   * AC-Nachbesserungstermin (InSe-verschuldet)
   * AC-Nachbesserungstermin (Kunde-verschuldet)
   * Bürotag
   * DC-Montagetermin
   * DC-Montagetermin (verlängert)
   * DC-Nachbesserungstermin (AG-verschuldet)
   * DC-Nachbesserungstermin (InSe-verschuldet)
   * DC-Nachbesserungstermin (Kunde-verschuldet)
   * Feiertag
   * Gerüstabbau
   * Gerüstaufbau
   * Kickoff Call
   * Krank
   * Puffertag
   * Schulung
   * Urlaub
   * Vor-Ort-Termin
   * Warenlieferung
   * WP - Montage
   * WP - Nachbesserung
   * WP - Vor-Ort-Termin
   * WP - Vorarbeit Montage
   * WP - Warenanlieferung
   * Zählersetzungstermin
   * Online-Begehung
   */
  workflowDefinitions?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type GetAppointmentsWorkOrderPayloadModel = {
  __typename?: 'GetAppointmentsWorkOrderPayloadModel';
  /** Contains the name of the customer or null if not set. Can be a company name or firstname + lastname if private person. */
  approvalState: ApprovalState;
  /** Contains the point in time when this tuple has been created. */
  createdAtUtc?: Maybe<Scalars['DateTime']['output']>;
  /** Contains all the customers of this appointment. */
  customers?: Maybe<Array<WorkOrderCustomerPayloadModelOfCustomerPayloadModel>>;
  /** Determines the eaasId for this object. */
  eaasId?: Maybe<Scalars['String']['output']>;
  /** Determines the unique identifier for this object. */
  id: Scalars['Int']['output'];
  /** Contains the point in time when this tuple has been modified last or null if it has never been modified. */
  modifiedAtUtc?: Maybe<Scalars['DateTime']['output']>;
  /** Contains the name of the work order. */
  name?: Maybe<Scalars['String']['output']>;
  /** Gets the number of blocking values that have been submitted below this node. Blocking values prevent craftspeople from continuing their work. */
  numberOfBlockedFields: Scalars['Int']['output'];
  /** Contains the number of re-submitted field values entries within this work order. */
  numberOfResubmitted: Scalars['Int']['output'];
  /** Contains the number of newly submitted field values entries within this work order. */
  numberOfSubmitted: Scalars['Int']['output'];
  /** Contains the Address asociated to the work order. */
  readOnlyAddress?: Maybe<AddressPayloadModel>;
};

export type GetBlockerInput = {
  /** Identifies the blocker to be retrieved. */
  blockerId: Scalars['Int']['input'];
};

export type GetBranchOfficesInput = {
  /** Show the deleted Branch Offices */
  includeDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  /** If set, only returns branch offices containing this value in their name. */
  name?: InputMaybe<Scalars['String']['input']>;
  /**
   * Sets the sorting. By default, the response will be sorted by the name of the branch office (asc).
   * Valid columns to sort by are: Id, Name, ServiceProvider.
   */
  orderBy?: InputMaybe<Array<SortDescriptionInput>>;
  /** Sets the page number and size of elements to return. */
  page?: InputMaybe<PageInput>;
};

export type GetBranchOfficesPayloadModel = {
  __typename?: 'GetBranchOfficesPayloadModel';
  /** Determines the address related to this branch office, if any. */
  address?: Maybe<AddressPayloadModel>;
  /** Determines the project manager related to this branch office, if any. */
  defaultProjectManager?: Maybe<UserPayloadModel>;
  /** Determines the unique identifier for this object. */
  id: Scalars['Int']['output'];
  /** Whether this entity is deleted or not. */
  isDeleted: Scalars['Boolean']['output'];
  /** Contains the name of the branch office or null if not set. */
  name?: Maybe<Scalars['String']['output']>;
  /** Determines the service provider related to this branch office, if any. */
  serviceProvider?: Maybe<ServiceProviderPayloadModel>;
};

export type GetCalendarItemsInput = {
  /**
   * Filter returned appointments by their state. Only appointments will be returned that
   * are in one of the specified states. Does not affect other calendar items. If null, only non-deleted appointments are returned.
   * Default: null
   */
  appointmentStates?: InputMaybe<Array<AppointmentStatus>>;
  /**
   * Filter returned blockers. Only blockers will be returned that have one of the
   * specified blocker reasons assigned. Does not affect other calendar items. If not set, all blockers are returned.
   * Default: null
   */
  blockerReasons?: InputMaybe<Array<Scalars['Int']['input']>>;
  /**
   * If set, the endpoint will only return calendar items that are assigned to any of the specified
   * branch offices. If not set, no filtering by branch offices occurs. Default: null
   */
  branchOffices?: InputMaybe<Array<Scalars['Int']['input']>>;
  /**
   * If set, this endpoint will only return calendar items that start before this date. If
   * not set, the backend will return all remaining calendar items (up to 'ChunkSize').
   */
  endAtUtc?: InputMaybe<Scalars['DateTime']['input']>;
  /**
   * If set to 'true', the endpoint will only return fixed appointments when all the
   * parties have agreed to. If 'false' the endpoint will only return appointments that are non-binding. If null, no filtering
   * according to binding occurs. Only applies to appointment calendar items. Default: null
   */
  isBinding?: InputMaybe<Scalars['Boolean']['input']>;
  page?: InputMaybe<PageInput>;
  /**
   * If set, the endpoint will only return calendar items assigned to one of the specified
   * partner companies. If not set, no filtering by users occurs. Default: null
   */
  partnerCompanies?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** If set, we will search for the properties Name,FirstName,LastName,City,Street,Number,ZipCode */
  search?: InputMaybe<Scalars['String']['input']>;
  /**
   * If set, this endpoint will only return calendar items that begin at this day or after. If
   * not set, the backend will assume 'today'.
   */
  startAtUtc?: InputMaybe<Scalars['DateTime']['input']>;
  /**
   * If set, the endpoint will only return calendar items assigned to one of the specified
   * teams. If not set, no filtering by teams occurs. Default: null
   */
  teams?: InputMaybe<Array<Scalars['Int']['input']>>;
  /**
   * If set, the endpoint will only return calendar items assigned to one of the specified
   * users. If not set, no filtering by users occurs. Default: null
   */
  users?: InputMaybe<Array<Scalars['Int']['input']>>;
  /**
   * Filter returned appointments. Only appointments will be returned that have one of the
   * specified workflow definitions assigned. Does not affect other calendar items. If not set, all appointments are returned.
   * Default: null
   */
  workflowDefinitions?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type GetCraftCompaniesInput = {
  /**
   * Sets the sorting. By default, the response will be sorted by id (asc).
   *
   * Valid columns to sort by are: id, name
   */
  orderBy?: InputMaybe<Array<SortDescriptionInput>>;
  /** Sets the page number and size of elements to return. */
  page?: InputMaybe<PageInput>;
  /** If set, we will search for the properties Name */
  search?: InputMaybe<Scalars['String']['input']>;
};

export type GetFieldValuesByAppointmentFieldDefinitionPayloadModel = {
  __typename?: 'GetFieldValuesByAppointmentFieldDefinitionPayloadModel';
  /** Determines the unique identifier for this object. */
  id: Scalars['Int']['output'];
  /** Determines the name of this field definition. */
  name?: Maybe<Scalars['String']['output']>;
};

export type GetFieldValuesByAppointmentFieldValuePayloadModel = {
  __typename?: 'GetFieldValuesByAppointmentFieldValuePayloadModel';
  /**
   * Gets the FieldDefinition for this field value.
   * @deprecated Please use 'FieldName'.
   */
  fieldDefinition?: Maybe<GetFieldValuesByAppointmentFieldDefinitionPayloadModel>;
  fieldName?: Maybe<Scalars['String']['output']>;
  /** Determines the unique identifier for this object. */
  id: Scalars['GraphQLLong']['output'];
  /** Determines the point in time when this object has been created. This is in UTC. */
  isApprovalRequired?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Contains the full list of all values for this field or
   *  only the last entry, depending on the request parameters.
   */
  values?: Maybe<Array<FieldValueEntryPayloadModel>>;
  /** Contains some information about the work item. */
  workItemInfo?: Maybe<GetFieldValuesByAppointmentWorkItemPayloadModel>;
};

export type GetFieldValuesByAppointmentInput = {
  /**
   * Determines the appointment to get values for. It must be in
   * either STARTED, DONE or ABORTED state. The caller must be a member of the appointment.
   */
  appointmentId: Scalars['Int']['input'];
  /**
   * If true, loads per-media decisions (image/video arrays) for each FieldValueEntry.
   *      Defaults to false to keep payloads light and fully backward compatible.
   */
  includeItemDecisions?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * If true, only returns the latest FieldValueEntry for each FieldValue.
   * If false returns the full history or FieldValueEntries for each FieldValue. Default: true
   */
  onlyLatestValue?: InputMaybe<Scalars['Boolean']['input']>;
};

export type GetFieldValuesByAppointmentWorkItemPayloadModel = {
  __typename?: 'GetFieldValuesByAppointmentWorkItemPayloadModel';
  /** Determines if this node has any children that are blocking craftspeople from continuing their work. */
  hasBlockingChildren: Scalars['Boolean']['output'];
  /** Determines the unique identifier for the work Item. */
  id?: Maybe<Scalars['GraphQLLong']['output']>;
  /** Contains the name of the work item. */
  name?: Maybe<Scalars['String']['output']>;
  /** Determines the unique identifier for the work Group. */
  workGroupId?: Maybe<Scalars['GraphQLLong']['output']>;
  /** Contains the name of the work group. */
  workGroupName?: Maybe<Scalars['String']['output']>;
};

export type GetFieldValuesByWorkOrderFieldValuePayloadModel = {
  __typename?: 'GetFieldValuesByWorkOrderFieldValuePayloadModel';
  /**
   * Gets the FieldDefinition for this field value.
   * @deprecated Please use 'FieldName'.
   */
  fieldDefinition?: Maybe<GetWorkItemFieldValuesFieldDefinitionPayloadModel>;
  fieldName?: Maybe<Scalars['String']['output']>;
  /** Determines the unique identifier for this object. */
  id: Scalars['GraphQLLong']['output'];
  /** Determines the point in time when this object has been created. This is in UTC. */
  isApprovalRequired?: Maybe<Scalars['Boolean']['output']>;
  modifiedAtUtc?: Maybe<Scalars['DateTime']['output']>;
  modifiedBy?: Maybe<UserPayloadModel>;
  /**
   * Contains the full list of all values for this field or
   *  only the last entry, depending on the request parameters.
   */
  values?: Maybe<Array<FieldValueEntryPayloadModel>>;
  /** Contains some information about the work item this field value belongs to. */
  workItemInfo?: Maybe<GetFieldValuesByWorkOrderWorkItemPayloadModel>;
};

export type GetFieldValuesByWorkOrderInput = {
  appointmentType?: InputMaybe<Scalars['String']['input']>;
  workOrderId: Scalars['Long']['input'];
};

export type GetFieldValuesByWorkOrderPayloadModel = {
  __typename?: 'GetFieldValuesByWorkOrderPayloadModel';
  /** Contains the name of the appointment type, eg.: Vor-Ort-Termin. */
  type: Scalars['String']['output'];
  /** Contains work groups' basic details alongside with their field values */
  workGroups?: Maybe<Array<WorkGroupWithFieldValuesPayloadModel>>;
};

export type GetFieldValuesByWorkOrderWorkItemPayloadModel = {
  __typename?: 'GetFieldValuesByWorkOrderWorkItemPayloadModel';
  /** Determines the unique identifier for the work item. */
  id?: Maybe<Scalars['GraphQLLong']['output']>;
  /** Contains the name of the work item. */
  name?: Maybe<Scalars['String']['output']>;
};

export type GetJobInput = {
  /** Identifies the job of which the endpoint should return the status. */
  jobId: Scalars['String']['input'];
};

export type GetManyPagedNodeResponsePayloadOfGetWorkCategoryWorkCategoryPayloadModelAndWorkCategoryErrorType = {
  __typename?: 'GetManyPagedNodeResponsePayloadOfGetWorkCategoryWorkCategoryPayloadModelAndWorkCategoryErrorType';
  /** The result field contains what we want to return in the payload. */
  data?: Maybe<Array<GetWorkCategoryWorkCategoryPayloadModel>>;
  /**
   * The error field contains one Enum with the error related with the payload.
   * @deprecated This property is deprecated. Use the ErrorDetails property instead.
   */
  error: WorkCategoryErrorType;
  /** The errorDetails field contains additional error information following RFC 7807. */
  errorDetails?: Maybe<ProblemDetailsOfWorkCategoryErrorType>;
  /** The errors field contains validation errors. */
  errors?: Maybe<Array<ValidationError>>;
  /** The total number of items that exist in our system. */
  totalItems: Scalars['Int']['output'];
  totalNumberOfResubmitted?: Maybe<Scalars['Int']['output']>;
  totalNumberOfSubmitted?: Maybe<Scalars['Int']['output']>;
};

export type GetManyPagedNodeResponsePayloadOfGetWorkItemsWorkItemPayloadModelAndWorkItemErrorType = {
  __typename?: 'GetManyPagedNodeResponsePayloadOfGetWorkItemsWorkItemPayloadModelAndWorkItemErrorType';
  /** The result field contains what we want to return in the payload. */
  data?: Maybe<Array<GetWorkItemsWorkItemPayloadModel>>;
  /**
   * The error field contains one Enum with the error related with the payload.
   * @deprecated This property is deprecated. Use the ErrorDetails property instead.
   */
  error: WorkItemErrorType;
  /** The errorDetails field contains additional error information following RFC 7807. */
  errorDetails?: Maybe<ProblemDetailsOfWorkItemErrorType>;
  /** The errors field contains validation errors. */
  errors?: Maybe<Array<ValidationError>>;
  /** The total number of items that exist in our system. */
  totalItems: Scalars['Int']['output'];
  totalNumberOfResubmitted?: Maybe<Scalars['Int']['output']>;
  totalNumberOfSubmitted?: Maybe<Scalars['Int']['output']>;
};

export type GetManyPagedNodeResponsePayloadOfGetWorkOrdersWorkOrderPayloadModelAndWorkOrderErrorType = {
  __typename?: 'GetManyPagedNodeResponsePayloadOfGetWorkOrdersWorkOrderPayloadModelAndWorkOrderErrorType';
  /** The result field contains what we want to return in the payload. */
  data?: Maybe<Array<GetWorkOrdersWorkOrderPayloadModel>>;
  /**
   * The error field contains one Enum with the error related with the payload.
   * @deprecated This property is deprecated. Use the ErrorDetails property instead.
   */
  error: WorkOrderErrorType;
  /** The errorDetails field contains additional error information following RFC 7807. */
  errorDetails?: Maybe<ProblemDetailsOfWorkOrderErrorType>;
  /** The errors field contains validation errors. */
  errors?: Maybe<Array<ValidationError>>;
  /** The total number of items that exist in our system. */
  totalItems: Scalars['Int']['output'];
  totalNumberOfResubmitted?: Maybe<Scalars['Int']['output']>;
  totalNumberOfSubmitted?: Maybe<Scalars['Int']['output']>;
};

export type GetManyPagedResponsePayloadOfCraftCompanyPayloadModelAndCraftCompanyErrorType = {
  __typename?: 'GetManyPagedResponsePayloadOfCraftCompanyPayloadModelAndCraftCompanyErrorType';
  /** The result field contains what we want to return in the payload. */
  data?: Maybe<Array<CraftCompanyPayloadModel>>;
  /**
   * The error field contains one Enum with the error related with the payload.
   * @deprecated This property is deprecated. Use the ErrorDetails property instead.
   */
  error: CraftCompanyErrorType;
  /** The errorDetails field contains additional error information following RFC 7807. */
  errorDetails?: Maybe<ProblemDetailsOfCraftCompanyErrorType>;
  /** The errors field contains validation errors. */
  errors?: Maybe<Array<ValidationError>>;
  /** The total number of items that exist in our system. */
  totalItems: Scalars['Int']['output'];
};

export type GetManyPagedResponsePayloadOfGetAppointmentsAppointmentPayloadModelAndAppointmentErrorType = {
  __typename?: 'GetManyPagedResponsePayloadOfGetAppointmentsAppointmentPayloadModelAndAppointmentErrorType';
  /** The result field contains what we want to return in the payload. */
  data?: Maybe<Array<GetAppointmentsAppointmentPayloadModel>>;
  /**
   * The error field contains one Enum with the error related with the payload.
   * @deprecated This property is deprecated. Use the ErrorDetails property instead.
   */
  error: AppointmentErrorType;
  /** The errorDetails field contains additional error information following RFC 7807. */
  errorDetails?: Maybe<ProblemDetailsOfAppointmentErrorType>;
  /** The errors field contains validation errors. */
  errors?: Maybe<Array<ValidationError>>;
  /** The total number of items that exist in our system. */
  totalItems: Scalars['Int']['output'];
};

export type GetManyPagedResponsePayloadOfGetBranchOfficesPayloadModelAndBranchOfficeErrorType = {
  __typename?: 'GetManyPagedResponsePayloadOfGetBranchOfficesPayloadModelAndBranchOfficeErrorType';
  /** The result field contains what we want to return in the payload. */
  data?: Maybe<Array<GetBranchOfficesPayloadModel>>;
  /**
   * The error field contains one Enum with the error related with the payload.
   * @deprecated This property is deprecated. Use the ErrorDetails property instead.
   */
  error: BranchOfficeErrorType;
  /** The errorDetails field contains additional error information following RFC 7807. */
  errorDetails?: Maybe<ProblemDetailsOfBranchOfficeErrorType>;
  /** The errors field contains validation errors. */
  errors?: Maybe<Array<ValidationError>>;
  /** The total number of items that exist in our system. */
  totalItems: Scalars['Int']['output'];
};

export type GetManyPagedResponsePayloadOfGetRolesRolePayloadModelAndRoleErrorType = {
  __typename?: 'GetManyPagedResponsePayloadOfGetRolesRolePayloadModelAndRoleErrorType';
  /** The result field contains what we want to return in the payload. */
  data?: Maybe<Array<GetRolesRolePayloadModel>>;
  /**
   * The error field contains one Enum with the error related with the payload.
   * @deprecated This property is deprecated. Use the ErrorDetails property instead.
   */
  error: RoleErrorType;
  /** The errorDetails field contains additional error information following RFC 7807. */
  errorDetails?: Maybe<ProblemDetailsOfRoleErrorType>;
  /** The errors field contains validation errors. */
  errors?: Maybe<Array<ValidationError>>;
  /** The total number of items that exist in our system. */
  totalItems: Scalars['Int']['output'];
};

export type GetManyPagedResponsePayloadOfGetTeamsPayloadModelAndTeamErrorType = {
  __typename?: 'GetManyPagedResponsePayloadOfGetTeamsPayloadModelAndTeamErrorType';
  /** The result field contains what we want to return in the payload. */
  data?: Maybe<Array<GetTeamsPayloadModel>>;
  /**
   * The error field contains one Enum with the error related with the payload.
   * @deprecated This property is deprecated. Use the ErrorDetails property instead.
   */
  error: TeamErrorType;
  /** The errorDetails field contains additional error information following RFC 7807. */
  errorDetails?: Maybe<ProblemDetailsOfTeamErrorType>;
  /** The errors field contains validation errors. */
  errors?: Maybe<Array<ValidationError>>;
  /** The total number of items that exist in our system. */
  totalItems: Scalars['Int']['output'];
};

export type GetManyPagedResponsePayloadOfGetWorkOrderAppointmentsPayloadModelAndAppointmentErrorType = {
  __typename?: 'GetManyPagedResponsePayloadOfGetWorkOrderAppointmentsPayloadModelAndAppointmentErrorType';
  /** The result field contains what we want to return in the payload. */
  data?: Maybe<Array<GetWorkOrderAppointmentsPayloadModel>>;
  /**
   * The error field contains one Enum with the error related with the payload.
   * @deprecated This property is deprecated. Use the ErrorDetails property instead.
   */
  error: AppointmentErrorType;
  /** The errorDetails field contains additional error information following RFC 7807. */
  errorDetails?: Maybe<ProblemDetailsOfAppointmentErrorType>;
  /** The errors field contains validation errors. */
  errors?: Maybe<Array<ValidationError>>;
  /** The total number of items that exist in our system. */
  totalItems: Scalars['Int']['output'];
};

export type GetManyPagedResponsePayloadOfGetWorkflowDefinitionInstanceAppointmentsPayloadModelAndAppointmentErrorType =
  {
    __typename?: 'GetManyPagedResponsePayloadOfGetWorkflowDefinitionInstanceAppointmentsPayloadModelAndAppointmentErrorType';
    /** The result field contains what we want to return in the payload. */
    data?: Maybe<Array<GetWorkflowDefinitionInstanceAppointmentsPayloadModel>>;
    /**
     * The error field contains one Enum with the error related with the payload.
     * @deprecated This property is deprecated. Use the ErrorDetails property instead.
     */
    error: AppointmentErrorType;
    /** The errorDetails field contains additional error information following RFC 7807. */
    errorDetails?: Maybe<ProblemDetailsOfAppointmentErrorType>;
    /** The errors field contains validation errors. */
    errors?: Maybe<Array<ValidationError>>;
    /** The total number of items that exist in our system. */
    totalItems: Scalars['Int']['output'];
  };

export type GetManyPagedResponsePayloadOfGetWorkflowDefinitionsWorkflowDefinitionPayloadModelAndWorkflowDefinitionErrorType =
  {
    __typename?: 'GetManyPagedResponsePayloadOfGetWorkflowDefinitionsWorkflowDefinitionPayloadModelAndWorkflowDefinitionErrorType';
    /** The result field contains what we want to return in the payload. */
    data?: Maybe<Array<GetWorkflowDefinitionsWorkflowDefinitionPayloadModel>>;
    /**
     * The error field contains one Enum with the error related with the payload.
     * @deprecated This property is deprecated. Use the ErrorDetails property instead.
     */
    error: WorkflowDefinitionErrorType;
    /** The errorDetails field contains additional error information following RFC 7807. */
    errorDetails?: Maybe<ProblemDetailsOfWorkflowDefinitionErrorType>;
    /** The errors field contains validation errors. */
    errors?: Maybe<Array<ValidationError>>;
    /** The total number of items that exist in our system. */
    totalItems: Scalars['Int']['output'];
  };

export type GetManyPagedResponsePayloadOfICalendarItemPayloadModelAndCalendarItemErrorType = {
  __typename?: 'GetManyPagedResponsePayloadOfICalendarItemPayloadModelAndCalendarItemErrorType';
  /** The result field contains what we want to return in the payload. */
  data?: Maybe<Array<CalendarItemPayloadModel>>;
  /**
   * The error field contains one Enum with the error related with the payload.
   * @deprecated This property is deprecated. Use the ErrorDetails property instead.
   */
  error: CalendarItemErrorType;
  /** The errorDetails field contains additional error information following RFC 7807. */
  errorDetails?: Maybe<ProblemDetailsOfCalendarItemErrorType>;
  /** The errors field contains validation errors. */
  errors?: Maybe<Array<ValidationError>>;
  /** The total number of items that exist in our system. */
  totalItems: Scalars['Int']['output'];
};

export type GetManyResponsePayloadOfGenerateUploadSignedUrlsForWorkOrderPayloadModelAndGenerateUploadSignedUrlsForWorkOrderErrorType =
  {
    __typename?: 'GetManyResponsePayloadOfGenerateUploadSignedUrlsForWorkOrderPayloadModelAndGenerateUploadSignedUrlsForWorkOrderErrorType';
    /** The result field contains what we want to return in the payload. */
    data?: Maybe<Array<GenerateUploadSignedUrlsForWorkOrderPayloadModel>>;
    /**
     * The error field contains one Enum with the error related with the payload.
     * @deprecated This property is deprecated. Use the ErrorDetails property instead.
     */
    error: GenerateUploadSignedUrlsForWorkOrderErrorType;
    /** The errorDetails field contains additional error information following RFC 7807. */
    errorDetails?: Maybe<ProblemDetailsOfGenerateUploadSignedUrlsForWorkOrderErrorType>;
    /** The errors field contains validation errors. */
    errors?: Maybe<Array<ValidationError>>;
  };

export type GetManyResponsePayloadOfGetFieldValuesByAppointmentFieldValuePayloadModelAndFieldValueErrorType = {
  __typename?: 'GetManyResponsePayloadOfGetFieldValuesByAppointmentFieldValuePayloadModelAndFieldValueErrorType';
  /** The result field contains what we want to return in the payload. */
  data?: Maybe<Array<GetFieldValuesByAppointmentFieldValuePayloadModel>>;
  /**
   * The error field contains one Enum with the error related with the payload.
   * @deprecated This property is deprecated. Use the ErrorDetails property instead.
   */
  error: FieldValueErrorType;
  /** The errorDetails field contains additional error information following RFC 7807. */
  errorDetails?: Maybe<ProblemDetailsOfFieldValueErrorType>;
  /** The errors field contains validation errors. */
  errors?: Maybe<Array<ValidationError>>;
};

export type GetManyResponsePayloadOfGetFieldValuesByWorkOrderPayloadModelAndFieldValueErrorType = {
  __typename?: 'GetManyResponsePayloadOfGetFieldValuesByWorkOrderPayloadModelAndFieldValueErrorType';
  /** The result field contains what we want to return in the payload. */
  data?: Maybe<Array<GetFieldValuesByWorkOrderPayloadModel>>;
  /**
   * The error field contains one Enum with the error related with the payload.
   * @deprecated This property is deprecated. Use the ErrorDetails property instead.
   */
  error: FieldValueErrorType;
  /** The errorDetails field contains additional error information following RFC 7807. */
  errorDetails?: Maybe<ProblemDetailsOfFieldValueErrorType>;
  /** The errors field contains validation errors. */
  errors?: Maybe<Array<ValidationError>>;
};

export type GetManyResponsePayloadOfGetUsersUserPayloadModelAndUserErrorType = {
  __typename?: 'GetManyResponsePayloadOfGetUsersUserPayloadModelAndUserErrorType';
  /** The result field contains what we want to return in the payload. */
  data?: Maybe<Array<GetUsersUserPayloadModel>>;
  /**
   * The error field contains one Enum with the error related with the payload.
   * @deprecated This property is deprecated. Use the ErrorDetails property instead.
   */
  error: UserErrorType;
  /** The errorDetails field contains additional error information following RFC 7807. */
  errorDetails?: Maybe<ProblemDetailsOfUserErrorType>;
  /** The errors field contains validation errors. */
  errors?: Maybe<Array<ValidationError>>;
};

export type GetManyResponsePayloadOfGetWorkItemFieldValuesPayloadModelAndFieldValueErrorType = {
  __typename?: 'GetManyResponsePayloadOfGetWorkItemFieldValuesPayloadModelAndFieldValueErrorType';
  /** The result field contains what we want to return in the payload. */
  data?: Maybe<Array<GetWorkItemFieldValuesPayloadModel>>;
  /**
   * The error field contains one Enum with the error related with the payload.
   * @deprecated This property is deprecated. Use the ErrorDetails property instead.
   */
  error: FieldValueErrorType;
  /** The errorDetails field contains additional error information following RFC 7807. */
  errorDetails?: Maybe<ProblemDetailsOfFieldValueErrorType>;
  /** The errors field contains validation errors. */
  errors?: Maybe<Array<ValidationError>>;
};

export type GetManyResponsePayloadOfGetWorkOrderFilesPayloadModelAndWorkOrderErrorType = {
  __typename?: 'GetManyResponsePayloadOfGetWorkOrderFilesPayloadModelAndWorkOrderErrorType';
  /** The result field contains what we want to return in the payload. */
  data?: Maybe<Array<GetWorkOrderFilesPayloadModel>>;
  /**
   * The error field contains one Enum with the error related with the payload.
   * @deprecated This property is deprecated. Use the ErrorDetails property instead.
   */
  error: WorkOrderErrorType;
  /** The errorDetails field contains additional error information following RFC 7807. */
  errorDetails?: Maybe<ProblemDetailsOfWorkOrderErrorType>;
  /** The errors field contains validation errors. */
  errors?: Maybe<Array<ValidationError>>;
};

export type GetManyResponsePayloadOfMediaPayloadModelAndFileErrorType = {
  __typename?: 'GetManyResponsePayloadOfMediaPayloadModelAndFileErrorType';
  /** The result field contains what we want to return in the payload. */
  data?: Maybe<Array<MediaPayloadModel>>;
  /**
   * The error field contains one Enum with the error related with the payload.
   * @deprecated This property is deprecated. Use the ErrorDetails property instead.
   */
  error: FileErrorType;
  /** The errorDetails field contains additional error information following RFC 7807. */
  errorDetails?: Maybe<ProblemDetailsOfFileErrorType>;
  /** The errors field contains validation errors. */
  errors?: Maybe<Array<ValidationError>>;
};

export type GetNoItemResponsePayloadOfAppointmentErrorType = {
  __typename?: 'GetNoItemResponsePayloadOfAppointmentErrorType';
  /**
   * The error field contains one Enum with the error related with the payload.
   * @deprecated This property is deprecated. Use the ErrorDetails property instead.
   */
  error: AppointmentErrorType;
  /** The errorDetails field contains additional error information following RFC 7807. */
  errorDetails?: Maybe<ProblemDetailsOfAppointmentErrorType>;
  /** The errors field contains validation errors. */
  errors?: Maybe<Array<ValidationError>>;
};

export type GetNoItemResponsePayloadOfBlockerErrorType = {
  __typename?: 'GetNoItemResponsePayloadOfBlockerErrorType';
  /**
   * The error field contains one Enum with the error related with the payload.
   * @deprecated This property is deprecated. Use the ErrorDetails property instead.
   */
  error: BlockerErrorType;
  /** The errorDetails field contains additional error information following RFC 7807. */
  errorDetails?: Maybe<ProblemDetailsOfBlockerErrorType>;
  /** The errors field contains validation errors. */
  errors?: Maybe<Array<ValidationError>>;
};

export type GetNoItemResponsePayloadOfDeviceErrorType = {
  __typename?: 'GetNoItemResponsePayloadOfDeviceErrorType';
  /**
   * The error field contains one Enum with the error related with the payload.
   * @deprecated This property is deprecated. Use the ErrorDetails property instead.
   */
  error: DeviceErrorType;
  /** The errorDetails field contains additional error information following RFC 7807. */
  errorDetails?: Maybe<ProblemDetailsOfDeviceErrorType>;
  /** The errors field contains validation errors. */
  errors?: Maybe<Array<ValidationError>>;
};

export type GetNoItemResponsePayloadOfProductFolderLayoutErrorType = {
  __typename?: 'GetNoItemResponsePayloadOfProductFolderLayoutErrorType';
  /**
   * The error field contains one Enum with the error related with the payload.
   * @deprecated This property is deprecated. Use the ErrorDetails property instead.
   */
  error: ProductFolderLayoutErrorType;
  /** The errorDetails field contains additional error information following RFC 7807. */
  errorDetails?: Maybe<ProblemDetailsOfProductFolderLayoutErrorType>;
  /** The errors field contains validation errors. */
  errors?: Maybe<Array<ValidationError>>;
};

export type GetNoItemResponsePayloadOfTeamErrorType = {
  __typename?: 'GetNoItemResponsePayloadOfTeamErrorType';
  /**
   * The error field contains one Enum with the error related with the payload.
   * @deprecated This property is deprecated. Use the ErrorDetails property instead.
   */
  error: TeamErrorType;
  /** The errorDetails field contains additional error information following RFC 7807. */
  errorDetails?: Maybe<ProblemDetailsOfTeamErrorType>;
  /** The errors field contains validation errors. */
  errors?: Maybe<Array<ValidationError>>;
};

export type GetRolesInput = {
  /**
   * Sets the sorting. By default, the response will be sorted by id (asc).
   *
   * Valid columns to sort by are: id, name
   */
  orderBy?: InputMaybe<Array<SortDescriptionInput>>;
  /** Sets the page number and size of elements to return. */
  page?: InputMaybe<PageInput>;
};

export type GetRolesRolePayloadModel = {
  __typename?: 'GetRolesRolePayloadModel';
  /** May contain a human readable description of the role. */
  description?: Maybe<Scalars['String']['output']>;
  /** Determines the unique identifier for this object. */
  id: Scalars['Int']['output'];
  /** Contains the name of the role. */
  name?: Maybe<Scalars['String']['output']>;
};

export type GetSingleResponsePayloadOfAppointmentCalendarItemPayloadModelAndAppointmentErrorType = {
  __typename?: 'GetSingleResponsePayloadOfAppointmentCalendarItemPayloadModelAndAppointmentErrorType';
  /** The result field contains what we want to return in the payload. */
  data?: Maybe<AppointmentCalendarItemPayloadModel>;
  /**
   * The error field contains one Enum with the error related with the payload.
   * @deprecated This property is deprecated. Use the ErrorDetails property instead.
   */
  error: AppointmentErrorType;
  /** The errorDetails field contains additional error information following RFC 7807. */
  errorDetails?: Maybe<ProblemDetailsOfAppointmentErrorType>;
  /** The errors field contains validation errors. */
  errors?: Maybe<Array<ValidationError>>;
};

export type GetSingleResponsePayloadOfAppointmentPayloadModelAndAppointmentErrorType = {
  __typename?: 'GetSingleResponsePayloadOfAppointmentPayloadModelAndAppointmentErrorType';
  /** The result field contains what we want to return in the payload. */
  data?: Maybe<AppointmentPayloadModel>;
  /**
   * The error field contains one Enum with the error related with the payload.
   * @deprecated This property is deprecated. Use the ErrorDetails property instead.
   */
  error: AppointmentErrorType;
  /** The errorDetails field contains additional error information following RFC 7807. */
  errorDetails?: Maybe<ProblemDetailsOfAppointmentErrorType>;
  /** The errors field contains validation errors. */
  errors?: Maybe<Array<ValidationError>>;
};

export type GetSingleResponsePayloadOfAttachTeamToAppointmentPayloadModelAndAppointmentErrorType = {
  __typename?: 'GetSingleResponsePayloadOfAttachTeamToAppointmentPayloadModelAndAppointmentErrorType';
  /** The result field contains what we want to return in the payload. */
  data?: Maybe<AttachTeamToAppointmentPayloadModel>;
  /**
   * The error field contains one Enum with the error related with the payload.
   * @deprecated This property is deprecated. Use the ErrorDetails property instead.
   */
  error: AppointmentErrorType;
  /** The errorDetails field contains additional error information following RFC 7807. */
  errorDetails?: Maybe<ProblemDetailsOfAppointmentErrorType>;
  /** The errors field contains validation errors. */
  errors?: Maybe<Array<ValidationError>>;
};

export type GetSingleResponsePayloadOfAttachUserToAppointmentPayloadModelAndAppointmentErrorType = {
  __typename?: 'GetSingleResponsePayloadOfAttachUserToAppointmentPayloadModelAndAppointmentErrorType';
  /** The result field contains what we want to return in the payload. */
  data?: Maybe<AttachUserToAppointmentPayloadModel>;
  /**
   * The error field contains one Enum with the error related with the payload.
   * @deprecated This property is deprecated. Use the ErrorDetails property instead.
   */
  error: AppointmentErrorType;
  /** The errorDetails field contains additional error information following RFC 7807. */
  errorDetails?: Maybe<ProblemDetailsOfAppointmentErrorType>;
  /** The errors field contains validation errors. */
  errors?: Maybe<Array<ValidationError>>;
};

export type GetSingleResponsePayloadOfBlockerCalendarItemPayloadModelAndBlockerErrorType = {
  __typename?: 'GetSingleResponsePayloadOfBlockerCalendarItemPayloadModelAndBlockerErrorType';
  /** The result field contains what we want to return in the payload. */
  data?: Maybe<BlockerCalendarItemPayloadModel>;
  /**
   * The error field contains one Enum with the error related with the payload.
   * @deprecated This property is deprecated. Use the ErrorDetails property instead.
   */
  error: BlockerErrorType;
  /** The errorDetails field contains additional error information following RFC 7807. */
  errorDetails?: Maybe<ProblemDetailsOfBlockerErrorType>;
  /** The errors field contains validation errors. */
  errors?: Maybe<Array<ValidationError>>;
};

export type GetSingleResponsePayloadOfCreateTeamPayloadModelAndTeamErrorType = {
  __typename?: 'GetSingleResponsePayloadOfCreateTeamPayloadModelAndTeamErrorType';
  /** The result field contains what we want to return in the payload. */
  data?: Maybe<CreateTeamPayloadModel>;
  /**
   * The error field contains one Enum with the error related with the payload.
   * @deprecated This property is deprecated. Use the ErrorDetails property instead.
   */
  error: TeamErrorType;
  /** The errorDetails field contains additional error information following RFC 7807. */
  errorDetails?: Maybe<ProblemDetailsOfTeamErrorType>;
  /** The errors field contains validation errors. */
  errors?: Maybe<Array<ValidationError>>;
};

export type GetSingleResponsePayloadOfFieldValueEntryPayloadModelAndDecideFieldValueEntryErrorType = {
  __typename?: 'GetSingleResponsePayloadOfFieldValueEntryPayloadModelAndDecideFieldValueEntryErrorType';
  /** The result field contains what we want to return in the payload. */
  data?: Maybe<FieldValueEntryPayloadModel>;
  /**
   * The error field contains one Enum with the error related with the payload.
   * @deprecated This property is deprecated. Use the ErrorDetails property instead.
   */
  error: DecideFieldValueEntryErrorType;
  /** The errorDetails field contains additional error information following RFC 7807. */
  errorDetails?: Maybe<ProblemDetailsOfDecideFieldValueEntryErrorType>;
  /** The errors field contains validation errors. */
  errors?: Maybe<Array<ValidationError>>;
};

export type GetSingleResponsePayloadOfGenerateSignedUrlForFilePayloadModelAndGenerateSignedUrlForFileErrorType = {
  __typename?: 'GetSingleResponsePayloadOfGenerateSignedUrlForFilePayloadModelAndGenerateSignedUrlForFileErrorType';
  /** The result field contains what we want to return in the payload. */
  data?: Maybe<GenerateSignedUrlForFilePayloadModel>;
  /**
   * The error field contains one Enum with the error related with the payload.
   * @deprecated This property is deprecated. Use the ErrorDetails property instead.
   */
  error: GenerateSignedUrlForFileErrorType;
  /** The errorDetails field contains additional error information following RFC 7807. */
  errorDetails?: Maybe<ProblemDetailsOfGenerateSignedUrlForFileErrorType>;
  /** The errors field contains validation errors. */
  errors?: Maybe<Array<ValidationError>>;
};

export type GetSingleResponsePayloadOfGetAppointmentPayloadModelAndAppointmentErrorType = {
  __typename?: 'GetSingleResponsePayloadOfGetAppointmentPayloadModelAndAppointmentErrorType';
  /** The result field contains what we want to return in the payload. */
  data?: Maybe<GetAppointmentPayloadModel>;
  /**
   * The error field contains one Enum with the error related with the payload.
   * @deprecated This property is deprecated. Use the ErrorDetails property instead.
   */
  error: AppointmentErrorType;
  /** The errorDetails field contains additional error information following RFC 7807. */
  errorDetails?: Maybe<ProblemDetailsOfAppointmentErrorType>;
  /** The errors field contains validation errors. */
  errors?: Maybe<Array<ValidationError>>;
};

export type GetSingleResponsePayloadOfGetAppointmentWorkforcePayloadModelAndAppointmentErrorType = {
  __typename?: 'GetSingleResponsePayloadOfGetAppointmentWorkforcePayloadModelAndAppointmentErrorType';
  /** The result field contains what we want to return in the payload. */
  data?: Maybe<GetAppointmentWorkforcePayloadModel>;
  /**
   * The error field contains one Enum with the error related with the payload.
   * @deprecated This property is deprecated. Use the ErrorDetails property instead.
   */
  error: AppointmentErrorType;
  /** The errorDetails field contains additional error information following RFC 7807. */
  errorDetails?: Maybe<ProblemDetailsOfAppointmentErrorType>;
  /** The errors field contains validation errors. */
  errors?: Maybe<Array<ValidationError>>;
};

export type GetSingleResponsePayloadOfGetUserUserPayloadModelAndUserErrorType = {
  __typename?: 'GetSingleResponsePayloadOfGetUserUserPayloadModelAndUserErrorType';
  /** The result field contains what we want to return in the payload. */
  data?: Maybe<GetUserUserPayloadModel>;
  /**
   * The error field contains one Enum with the error related with the payload.
   * @deprecated This property is deprecated. Use the ErrorDetails property instead.
   */
  error: UserErrorType;
  /** The errorDetails field contains additional error information following RFC 7807. */
  errorDetails?: Maybe<ProblemDetailsOfUserErrorType>;
  /** The errors field contains validation errors. */
  errors?: Maybe<Array<ValidationError>>;
};

export type GetSingleResponsePayloadOfGetWorkCategoryWorkCategoryPayloadModelAndWorkCategoryErrorType = {
  __typename?: 'GetSingleResponsePayloadOfGetWorkCategoryWorkCategoryPayloadModelAndWorkCategoryErrorType';
  /** The result field contains what we want to return in the payload. */
  data?: Maybe<GetWorkCategoryWorkCategoryPayloadModel>;
  /**
   * The error field contains one Enum with the error related with the payload.
   * @deprecated This property is deprecated. Use the ErrorDetails property instead.
   */
  error: WorkCategoryErrorType;
  /** The errorDetails field contains additional error information following RFC 7807. */
  errorDetails?: Maybe<ProblemDetailsOfWorkCategoryErrorType>;
  /** The errors field contains validation errors. */
  errors?: Maybe<Array<ValidationError>>;
};

export type GetSingleResponsePayloadOfGetWorkGroupPayloadModelAndWorkGroupErrorType = {
  __typename?: 'GetSingleResponsePayloadOfGetWorkGroupPayloadModelAndWorkGroupErrorType';
  /** The result field contains what we want to return in the payload. */
  data?: Maybe<GetWorkGroupPayloadModel>;
  /**
   * The error field contains one Enum with the error related with the payload.
   * @deprecated This property is deprecated. Use the ErrorDetails property instead.
   */
  error: WorkGroupErrorType;
  /** The errorDetails field contains additional error information following RFC 7807. */
  errorDetails?: Maybe<ProblemDetailsOfWorkGroupErrorType>;
  /** The errors field contains validation errors. */
  errors?: Maybe<Array<ValidationError>>;
};

export type GetSingleResponsePayloadOfGetWorkOrderPayloadModelAndWorkOrderErrorType = {
  __typename?: 'GetSingleResponsePayloadOfGetWorkOrderPayloadModelAndWorkOrderErrorType';
  /** The result field contains what we want to return in the payload. */
  data?: Maybe<GetWorkOrderPayloadModel>;
  /**
   * The error field contains one Enum with the error related with the payload.
   * @deprecated This property is deprecated. Use the ErrorDetails property instead.
   */
  error: WorkOrderErrorType;
  /** The errorDetails field contains additional error information following RFC 7807. */
  errorDetails?: Maybe<ProblemDetailsOfWorkOrderErrorType>;
  /** The errors field contains validation errors. */
  errors?: Maybe<Array<ValidationError>>;
};

export type GetSingleResponsePayloadOfGetWorkOrderStatusPayloadModelAndWorkOrderErrorType = {
  __typename?: 'GetSingleResponsePayloadOfGetWorkOrderStatusPayloadModelAndWorkOrderErrorType';
  /** The result field contains what we want to return in the payload. */
  data?: Maybe<GetWorkOrderStatusPayloadModel>;
  /**
   * The error field contains one Enum with the error related with the payload.
   * @deprecated This property is deprecated. Use the ErrorDetails property instead.
   */
  error: WorkOrderErrorType;
  /** The errorDetails field contains additional error information following RFC 7807. */
  errorDetails?: Maybe<ProblemDetailsOfWorkOrderErrorType>;
  /** The errors field contains validation errors. */
  errors?: Maybe<Array<ValidationError>>;
};

export type GetSingleResponsePayloadOfGetWorkflowDefinitionVersionPayloadModelAndWorkflowDefinitionVersionErrorType = {
  __typename?: 'GetSingleResponsePayloadOfGetWorkflowDefinitionVersionPayloadModelAndWorkflowDefinitionVersionErrorType';
  /** The result field contains what we want to return in the payload. */
  data?: Maybe<GetWorkflowDefinitionVersionPayloadModel>;
  /**
   * The error field contains one Enum with the error related with the payload.
   * @deprecated This property is deprecated. Use the ErrorDetails property instead.
   */
  error: WorkflowDefinitionVersionErrorType;
  /** The errorDetails field contains additional error information following RFC 7807. */
  errorDetails?: Maybe<ProblemDetailsOfWorkflowDefinitionVersionErrorType>;
  /** The errors field contains validation errors. */
  errors?: Maybe<Array<ValidationError>>;
};

export type GetSingleResponsePayloadOfJobPayloadModelAndAppointmentErrorType = {
  __typename?: 'GetSingleResponsePayloadOfJobPayloadModelAndAppointmentErrorType';
  /** The result field contains what we want to return in the payload. */
  data?: Maybe<JobPayloadModel>;
  /**
   * The error field contains one Enum with the error related with the payload.
   * @deprecated This property is deprecated. Use the ErrorDetails property instead.
   */
  error: AppointmentErrorType;
  /** The errorDetails field contains additional error information following RFC 7807. */
  errorDetails?: Maybe<ProblemDetailsOfAppointmentErrorType>;
  /** The errors field contains validation errors. */
  errors?: Maybe<Array<ValidationError>>;
};

export type GetSingleResponsePayloadOfJobPayloadModelAndJobErrorType = {
  __typename?: 'GetSingleResponsePayloadOfJobPayloadModelAndJobErrorType';
  /** The result field contains what we want to return in the payload. */
  data?: Maybe<JobPayloadModel>;
  /**
   * The error field contains one Enum with the error related with the payload.
   * @deprecated This property is deprecated. Use the ErrorDetails property instead.
   */
  error: JobErrorType;
  /** The errorDetails field contains additional error information following RFC 7807. */
  errorDetails?: Maybe<ProblemDetailsOfJobErrorType>;
  /** The errors field contains validation errors. */
  errors?: Maybe<Array<ValidationError>>;
};

export type GetSingleResponsePayloadOfJobPayloadModelAndWorkOrderErrorType = {
  __typename?: 'GetSingleResponsePayloadOfJobPayloadModelAndWorkOrderErrorType';
  /** The result field contains what we want to return in the payload. */
  data?: Maybe<JobPayloadModel>;
  /**
   * The error field contains one Enum with the error related with the payload.
   * @deprecated This property is deprecated. Use the ErrorDetails property instead.
   */
  error: WorkOrderErrorType;
  /** The errorDetails field contains additional error information following RFC 7807. */
  errorDetails?: Maybe<ProblemDetailsOfWorkOrderErrorType>;
  /** The errors field contains validation errors. */
  errors?: Maybe<Array<ValidationError>>;
};

export type GetSingleResponsePayloadOfPatchCustomerPayloadModelAndCustomerErrorType = {
  __typename?: 'GetSingleResponsePayloadOfPatchCustomerPayloadModelAndCustomerErrorType';
  /** The result field contains what we want to return in the payload. */
  data?: Maybe<PatchCustomerPayloadModel>;
  /**
   * The error field contains one Enum with the error related with the payload.
   * @deprecated This property is deprecated. Use the ErrorDetails property instead.
   */
  error: CustomerErrorType;
  /** The errorDetails field contains additional error information following RFC 7807. */
  errorDetails?: Maybe<ProblemDetailsOfCustomerErrorType>;
  /** The errors field contains validation errors. */
  errors?: Maybe<Array<ValidationError>>;
};

export type GetSingleResponsePayloadOfPatchOutboundSyncPayloadModelAndOutboundSyncErrorType = {
  __typename?: 'GetSingleResponsePayloadOfPatchOutboundSyncPayloadModelAndOutboundSyncErrorType';
  /** The result field contains what we want to return in the payload. */
  data?: Maybe<PatchOutboundSyncPayloadModel>;
  /**
   * The error field contains one Enum with the error related with the payload.
   * @deprecated This property is deprecated. Use the ErrorDetails property instead.
   */
  error: OutboundSyncErrorType;
  /** The errorDetails field contains additional error information following RFC 7807. */
  errorDetails?: Maybe<ProblemDetailsOfOutboundSyncErrorType>;
  /** The errors field contains validation errors. */
  errors?: Maybe<Array<ValidationError>>;
};

export type GetSingleResponsePayloadOfPullWorkOrderPayloadModelAndWorkOrderErrorType = {
  __typename?: 'GetSingleResponsePayloadOfPullWorkOrderPayloadModelAndWorkOrderErrorType';
  /** The result field contains what we want to return in the payload. */
  data?: Maybe<PullWorkOrderPayloadModel>;
  /**
   * The error field contains one Enum with the error related with the payload.
   * @deprecated This property is deprecated. Use the ErrorDetails property instead.
   */
  error: WorkOrderErrorType;
  /** The errorDetails field contains additional error information following RFC 7807. */
  errorDetails?: Maybe<ProblemDetailsOfWorkOrderErrorType>;
  /** The errors field contains validation errors. */
  errors?: Maybe<Array<ValidationError>>;
};

export type GetSingleResponsePayloadOfPushFieldValuesPayloadModelAndFieldValueErrorType = {
  __typename?: 'GetSingleResponsePayloadOfPushFieldValuesPayloadModelAndFieldValueErrorType';
  /** The result field contains what we want to return in the payload. */
  data?: Maybe<Array<KeyValuePairOfStringAndPushFieldValuesFieldValuePayloadModel>>;
  /**
   * The error field contains one Enum with the error related with the payload.
   * @deprecated This property is deprecated. Use the ErrorDetails property instead.
   */
  error: FieldValueErrorType;
  /** The errorDetails field contains additional error information following RFC 7807. */
  errorDetails?: Maybe<ProblemDetailsOfFieldValueErrorType>;
  /** The errors field contains validation errors. */
  errors?: Maybe<Array<ValidationError>>;
};

export type GetSingleResponsePayloadOfStartAppointmentAppointmentPayloadModelAndAppointmentErrorType = {
  __typename?: 'GetSingleResponsePayloadOfStartAppointmentAppointmentPayloadModelAndAppointmentErrorType';
  /** The result field contains what we want to return in the payload. */
  data?: Maybe<StartAppointmentAppointmentPayloadModel>;
  /**
   * The error field contains one Enum with the error related with the payload.
   * @deprecated This property is deprecated. Use the ErrorDetails property instead.
   */
  error: AppointmentErrorType;
  /** The errorDetails field contains additional error information following RFC 7807. */
  errorDetails?: Maybe<ProblemDetailsOfAppointmentErrorType>;
  /** The errors field contains validation errors. */
  errors?: Maybe<Array<ValidationError>>;
};

export type GetSingleResponsePayloadOfUpdateTeamPayloadModelAndTeamErrorType = {
  __typename?: 'GetSingleResponsePayloadOfUpdateTeamPayloadModelAndTeamErrorType';
  /** The result field contains what we want to return in the payload. */
  data?: Maybe<UpdateTeamPayloadModel>;
  /**
   * The error field contains one Enum with the error related with the payload.
   * @deprecated This property is deprecated. Use the ErrorDetails property instead.
   */
  error: TeamErrorType;
  /** The errorDetails field contains additional error information following RFC 7807. */
  errorDetails?: Maybe<ProblemDetailsOfTeamErrorType>;
  /** The errors field contains validation errors. */
  errors?: Maybe<Array<ValidationError>>;
};

export type GetSingleResponsePayloadOfWorkflowDefinitionsCompositePayloadModelAndWorkflowDefinitionsIncludingBlockerReasonsErrorType =
  {
    __typename?: 'GetSingleResponsePayloadOfWorkflowDefinitionsCompositePayloadModelAndWorkflowDefinitionsIncludingBlockerReasonsErrorType';
    /** The result field contains what we want to return in the payload. */
    data?: Maybe<WorkflowDefinitionsCompositePayloadModel>;
    /**
     * The error field contains one Enum with the error related with the payload.
     * @deprecated This property is deprecated. Use the ErrorDetails property instead.
     */
    error: WorkflowDefinitionsIncludingBlockerReasonsErrorType;
    /** The errorDetails field contains additional error information following RFC 7807. */
    errorDetails?: Maybe<ProblemDetailsOfWorkflowDefinitionsIncludingBlockerReasonsErrorType>;
    /** The errors field contains validation errors. */
    errors?: Maybe<Array<ValidationError>>;
  };

export type GetTeamsBranchOfficePayloadModel = {
  __typename?: 'GetTeamsBranchOfficePayloadModel';
  /** Determines the unique identifier for this object. */
  id: Scalars['Int']['output'];
  /** Whether this entity is deleted or not. */
  isDeleted?: Maybe<Scalars['Boolean']['output']>;
  /** Contains the name of the branch office or null if not set. */
  name?: Maybe<Scalars['String']['output']>;
  /** Determines the service provider related to this entity, if any. */
  serviceProvider?: Maybe<ServiceProviderPayloadModel>;
};

export type GetTeamsInput = {
  /** If set, only returns teams containing this value in their branch office. */
  branchOfficeId?: InputMaybe<Scalars['Int']['input']>;
  /** Include deleted Teams */
  includeDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  /** If set, only returns teams containing this value in their name. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** If set, this property gets the calling user's EmployerId and then only returns teams where this id matches ServiceProvider.Id. */
  onlyMyServiceProvider?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * Sets the sorting. By default, the response will be sorted by team id (asc).
   *     Valid columns to sort by are: name.
   */
  orderBy?: InputMaybe<Array<SortDescriptionInput>>;
  /** Sets the page number and size of elements to return. */
  page?: InputMaybe<PageInput>;
  /** If set, only returns teams containing this value in their workflow definition. One team could contain skills and each skill is related with a workflow definition. */
  workflowDefinitionName?: InputMaybe<Scalars['String']['input']>;
};

export type GetTeamsPayloadModel = {
  __typename?: 'GetTeamsPayloadModel';
  /** Determines the branch office related to this entity, if any. */
  branchOffice?: Maybe<GetTeamsBranchOfficePayloadModel>;
  /** Determines the unique identifier for this object. */
  id: Scalars['Int']['output'];
  /** Whether this entity is deleted or not. */
  isDeleted: Scalars['Boolean']['output'];
  /** Determines the members related to this entity, if any. */
  members?: Maybe<Array<UserPayloadModel>>;
  /** Contains the name of the team. */
  name?: Maybe<Scalars['String']['output']>;
  /** Determines the skills related to this entity, if any. */
  skills?: Maybe<Array<GetTeamsSkillPayloadModel>>;
};

export type GetTeamsSkillPayloadModel = {
  __typename?: 'GetTeamsSkillPayloadModel';
  /** Determines the unique identifier for this object. */
  id: Scalars['Int']['output'];
  /** Determines the Workflow Definition related to this entity, if any. */
  workflowDefinition?: Maybe<WorkflowDefinitionPayloadModel>;
};

export type GetUserBranchOfficePayloadModel = {
  __typename?: 'GetUserBranchOfficePayloadModel';
  /** Determines the main address of this branch office. */
  address?: Maybe<AddressPayloadModel>;
  /** Determines the unique identifier for this object. */
  id: Scalars['Int']['output'];
  /** Whether this entity is deleted or not. */
  isDeleted: Scalars['Boolean']['output'];
  /** Contains the name of the branch office or null if not set. */
  name?: Maybe<Scalars['String']['output']>;
};

export type GetUserInput = {
  /** Identifies the user to return information about. Will return information about the user invoking the endpoint if null. */
  userId?: InputMaybe<Scalars['Int']['input']>;
};

export type GetUserTeamPayloadModel = {
  __typename?: 'GetUserTeamPayloadModel';
  /** Determines the branch office this team is assigned to. */
  branchOffice?: Maybe<GetUserBranchOfficePayloadModel>;
  /** Determines the unique identifier for this object. */
  id: Scalars['Int']['output'];
  /** Whether this entity is deleted or not. */
  isDeleted: Scalars['Boolean']['output'];
  /** Contains the name of the team. */
  name?: Maybe<Scalars['String']['output']>;
};

export type GetUserUserPayloadModel = {
  __typename?: 'GetUserUserPayloadModel';
  /** Determines the default team the user is a member of, if any. */
  defaultTeam?: Maybe<GetUserTeamPayloadModel>;
  /** Determines the e-mail address of the user. */
  eMail?: Maybe<Scalars['String']['output']>;
  /** Determines the firstname of the user. */
  firstName?: Maybe<Scalars['String']['output']>;
  /** Determines the unique identifier for this object. */
  id: Scalars['Int']['output'];
  /** Whether this entity is deleted or not. */
  isDeleted: Scalars['Boolean']['output'];
  /** Determines the users job title, if any. */
  jobTitle?: Maybe<Scalars['String']['output']>;
  /** Determines the lastname of the user. */
  lastName?: Maybe<Scalars['String']['output']>;
  /** Determines the users mobile phone number, if any. */
  mobilePhone?: Maybe<Scalars['String']['output']>;
  /** Determines the users phone number, if any. */
  phone?: Maybe<Scalars['String']['output']>;
  /** Determines the roles the user is a member of, if any. */
  roles?: Maybe<Array<RolePayloadModel>>;
  /** Determines the salutation of this user. */
  salutation?: Maybe<Salutation>;
};

export type GetUsersInput = {
  /** If set to true, the result set will never contain the user performing this request. */
  excludeMyself?: InputMaybe<Scalars['Boolean']['input']>;
  /** If set, only returns users containing this value in their first name. */
  firstName?: InputMaybe<Scalars['String']['input']>;
  /** Determines if the result set should include already deleted users. Default is 'false'. */
  includeDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  /** If set, only returns users containing this value in their last name. */
  lastName?: InputMaybe<Scalars['String']['input']>;
  /**
   * Sets the sorting. By default, the response will be sorted by first name (asc), then last name (asc).
   *
   * Valid columns to sort by are: id, firstName, lastName
   */
  orderBy?: InputMaybe<Array<SortDescriptionInput>>;
  /** Sets the page number and size of elements to return. */
  page?: InputMaybe<PageInput>;
  /** Role so only users in possession of a certain role are returned. The role is specified by its ID. The user can have multiple roles. */
  roleId?: InputMaybe<Scalars['Int']['input']>;
  /** Gets the users that contain the partial string in their name. */
  search?: InputMaybe<Scalars['String']['input']>;
};

export type GetUsersUserPayloadModel = {
  __typename?: 'GetUsersUserPayloadModel';
  /** Determines the default team the user is a member of, if any. */
  defaultTeam?: Maybe<GetUserTeamPayloadModel>;
  /** Gets or sets a point in time when this record has been deleted or "null" if it never has been deleted. */
  deletedAtUtc?: Maybe<Scalars['DateTime']['output']>;
  /** Determines id of the user who deleted this user or null, if this user has not been deleted. */
  deletedById?: Maybe<Scalars['Int']['output']>;
  /** Determines the e-mail address of the user. */
  eMail?: Maybe<Scalars['String']['output']>;
  /** Determines the employer the user is currently working for. */
  employer?: Maybe<ServiceProviderPayloadModel>;
  /** Determines the firstname of the user. */
  firstName?: Maybe<Scalars['String']['output']>;
  /** Determines the unique identifier for this object. */
  id: Scalars['Int']['output'];
  /** Whether this entity is deleted or not. */
  isDeleted: Scalars['Boolean']['output'];
  /** Determines the users job title, if any. */
  jobTitle?: Maybe<Scalars['String']['output']>;
  /** Determines the lastname of the user. */
  lastName?: Maybe<Scalars['String']['output']>;
  /** Determines the users mobile phone number, if any. */
  mobilePhone?: Maybe<Scalars['String']['output']>;
  /** Determines the users phone number, if any. */
  phone?: Maybe<Scalars['String']['output']>;
  /** Determines the roles the user is a member of, if any. */
  roles?: Maybe<Array<RolePayloadModel>>;
  /** Determines the salutation of this user. */
  salutation?: Maybe<Salutation>;
};

export type GetWorkCategoriesInput = {
  /** Distinct work categories by Name. */
  distinctByName: Scalars['Boolean']['input'];
  /**
   * Sets the sorting. By default, the response will be sorted by name(asc).
   *
   * Valid columns to sort by are: Name
   */
  orderBy?: InputMaybe<Array<SortDescriptionInput>>;
  /** Sets the page number and size of elements to return. */
  page?: InputMaybe<PageInput>;
};

/** This input receives the ID of the work category. */
export type GetWorkCategoryInput = {
  /** Property that indicates the ID of the work category. */
  workCategoryId: Scalars['Int']['input'];
};

export type GetWorkCategoryWorkCategoryPayloadModel = {
  __typename?: 'GetWorkCategoryWorkCategoryPayloadModel';
  /** Contains the name of the customer or null if not set. Can be a company name or firstname + lastname if private person. */
  approvalState: ApprovalState;
  /** Contains the point in time when this tuple has been created. */
  createdAtUtc?: Maybe<Scalars['DateTime']['output']>;
  groups?: Maybe<Array<GetWorkCategoryWorkGroupPayloadModel>>;
  /** Determines the unique identifier for this object. */
  id: Scalars['Int']['output'];
  /** Contains the point in time when this tuple has been modified last or null if it has never been modified. */
  modifiedAtUtc?: Maybe<Scalars['DateTime']['output']>;
  /** Contains the name of the work order. */
  name?: Maybe<Scalars['String']['output']>;
  /** Gets the number of blocking values that have been submitted below this node. Blocking values prevent craftspeople from continuing their work. */
  numberOfBlockedFields: Scalars['Int']['output'];
  /** Contains the number of re-submitted field values entries within this work order. */
  numberOfResubmitted: Scalars['Int']['output'];
  /** Contains the number of newly submitted field values entries within this work order. */
  numberOfSubmitted: Scalars['Int']['output'];
};

export type GetWorkCategoryWorkGroupPayloadModel = {
  __typename?: 'GetWorkCategoryWorkGroupPayloadModel';
  /** Contains the name of the customer or null if not set. Can be a company name or firstname + lastname if private person. */
  approvalState: ApprovalState;
  /** Contains the point in time when this tuple has been created. */
  createdAtUtc?: Maybe<Scalars['DateTime']['output']>;
  /** Determines the unique identifier for this object. */
  id: Scalars['Int']['output'];
  items?: Maybe<Array<WorkItemPayloadModel>>;
  /** Contains the point in time when this tuple has been modified last or null if it has never been modified. */
  modifiedAtUtc?: Maybe<Scalars['DateTime']['output']>;
  /** Contains the name of the work order. */
  name?: Maybe<Scalars['String']['output']>;
  /** Gets the number of blocking values that have been submitted below this node. Blocking values prevent craftspeople from continuing their work. */
  numberOfBlockedFields: Scalars['Int']['output'];
  /** Contains the number of re-submitted field values entries within this work order. */
  numberOfResubmitted: Scalars['Int']['output'];
  /** Contains the number of newly submitted field values entries within this work order. */
  numberOfSubmitted: Scalars['Int']['output'];
};

/** This input receives the ID of the work group. */
export type GetWorkGroupInput = {
  /** If set to true, also include logically unreachable workflow items. Default: false */
  includeUnreachable?: InputMaybe<Scalars['Boolean']['input']>;
  /** Property that indicates the ID of the work group. */
  workGroupId: Scalars['Int']['input'];
  /** Only returns work items in any of these approval states. Set to NULL or empty to return all work items. */
  workItemApprovalStates?: InputMaybe<Array<ApprovalState>>;
};

export type GetWorkGroupPayloadModel = {
  __typename?: 'GetWorkGroupPayloadModel';
  /** Contains the name of the customer or null if not set. Can be a company name or firstname + lastname if private person. */
  approvalState: ApprovalState;
  /** Contains the point in time when this tuple has been created. */
  createdAtUtc?: Maybe<Scalars['DateTime']['output']>;
  /** Determines the unique identifier for this object. */
  id: Scalars['Int']['output'];
  /** Property that indicates all the work items related with this work group. */
  items?: Maybe<Array<GetWorkItemWorkGroupPayloadModel>>;
  /** Contains the point in time when this tuple has been modified last or null if it has never been modified. */
  modifiedAtUtc?: Maybe<Scalars['DateTime']['output']>;
  /** Contains the name of the work order. */
  name?: Maybe<Scalars['String']['output']>;
  /** Gets the number of blocking values that have been submitted below this node. Blocking values prevent craftspeople from continuing their work. */
  numberOfBlockedFields: Scalars['Int']['output'];
  /** Contains the number of re-submitted field values entries within this work order. */
  numberOfResubmitted: Scalars['Int']['output'];
  /** Contains the number of newly submitted field values entries within this work order. */
  numberOfSubmitted: Scalars['Int']['output'];
  /** Determines the user that submitted the work group. */
  submittedBy?: Maybe<UserPayloadModel>;
  /** Property that indicates the work category that is associated with this work group. */
  workCategory?: Maybe<GetWorkGroupWorkCategoryPayloadModel>;
};

export type GetWorkGroupWorkCategoryPayloadModel = {
  __typename?: 'GetWorkGroupWorkCategoryPayloadModel';
  /** Determines the unique identifier for this object. */
  id: Scalars['Int']['output'];
  /** Contains the name of the WorkCategory. */
  name?: Maybe<Scalars['String']['output']>;
};

export type GetWorkItemFieldValuesFieldDefinitionPayloadModel = {
  __typename?: 'GetWorkItemFieldValuesFieldDefinitionPayloadModel';
  /** Determines the unique identifier for this object. */
  id: Scalars['Int']['output'];
  /** Determines the name of this field definition. */
  name?: Maybe<Scalars['String']['output']>;
};

export type GetWorkItemFieldValuesFieldValuePayloadModel = {
  __typename?: 'GetWorkItemFieldValuesFieldValuePayloadModel';
  /**
   * Gets the FieldDefinition for this field value.
   * @deprecated Please use 'FieldName'.
   */
  fieldDefinition?: Maybe<GetWorkItemFieldValuesFieldDefinitionPayloadModel>;
  fieldName?: Maybe<Scalars['String']['output']>;
  /** Determines the unique identifier for this object. */
  id: Scalars['GraphQLLong']['output'];
  /** Determines the point in time when this object has been created. This is in UTC. */
  isApprovalRequired?: Maybe<Scalars['Boolean']['output']>;
  modifiedAtUtc?: Maybe<Scalars['DateTime']['output']>;
  modifiedBy?: Maybe<UserPayloadModel>;
  /**
   * Contains the full list of all values for this field or
   *  only the last entry, depending on the request parameters.
   */
  values?: Maybe<Array<FieldValueEntryPayloadModel>>;
};

export type GetWorkItemFieldValuesInput = {
  includeFieldValueMetadata?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * If true, loads per-media decisions (image/video arrays) for each FieldValueEntry.
   *      Defaults to false to keep payloads light and fully backward compatible.
   */
  includeItemDecisions?: InputMaybe<Scalars['Boolean']['input']>;
  onlyLatestValue?: InputMaybe<Scalars['Boolean']['input']>;
  workItemId?: InputMaybe<Scalars['GraphQLLong']['input']>;
};

export type GetWorkItemFieldValuesPayloadModel = {
  __typename?: 'GetWorkItemFieldValuesPayloadModel';
  /**
   * Contains the acceptance criteria of the field value or NULL of
   * that information has not been requested.
   */
  acceptanceCriteria?: Maybe<FieldAcceptanceCriteriaPayloadModel>;
  /** Contains the FieldValue with its entries (or entry). */
  fieldValue?: Maybe<GetWorkItemFieldValuesFieldValuePayloadModel>;
};

export type GetWorkItemWorkGroupPayloadModel = {
  __typename?: 'GetWorkItemWorkGroupPayloadModel';
  /** Contains the name of the customer or null if not set. Can be a company name or firstname + lastname if private person. */
  approvalState: ApprovalState;
  /** Contains the point in time when this tuple has been created. */
  createdAtUtc?: Maybe<Scalars['DateTime']['output']>;
  /** Determines the unique identifier for this object. */
  id: Scalars['Long']['output'];
  /** Contains the point in time when this tuple has been modified last or null if it has never been modified. */
  modifiedAtUtc?: Maybe<Scalars['DateTime']['output']>;
  /** Contains the name of the work order. */
  name?: Maybe<Scalars['String']['output']>;
  /** Gets the number of blocking values that have been submitted below this node. Blocking values prevent craftspeople from continuing their work. */
  numberOfBlockedFields: Scalars['Int']['output'];
  /** Contains the number of re-submitted field values entries within this work order. */
  numberOfResubmitted: Scalars['Int']['output'];
  /** Contains the number of newly submitted field values entries within this work order. */
  numberOfSubmitted: Scalars['Int']['output'];
  /** Determines the user that submitted the work item. */
  submittedBy?: Maybe<UserPayloadModel>;
};

export type GetWorkItemsInput = {
  /** Only return work items whose associated appointment ends at or before this point in time. If null, all work items are returned. */
  endDateUtc?: InputMaybe<Scalars['DateTime']['input']>;
  /** If set to true, the response will include the total count of submitted and re-submitted items across all pages. Default: false */
  includeStatistics?: InputMaybe<Scalars['Boolean']['input']>;
  /** If set to true, also include logically unreachable workflow items. Default: false */
  includeUnreachable?: InputMaybe<Scalars['Boolean']['input']>;
  /** If set to true, only return blocking work items. Otherwise do not filter on the blocking state. */
  onlyBlocking?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * Sets the sorting. By default, the response will be sorted by first name (asc), then last name (asc).
   *
   * Valid columns to sort by are: id, firstName, lastName
   */
  orderBy?: InputMaybe<Array<SortDescriptionInput>>;
  /** Sets the page number and size of elements to return. */
  page?: InputMaybe<PageInput>;
  /** Only return work items that have this project manager assigned. If null, all work items are returned. */
  projectManagerId?: InputMaybe<Scalars['Int']['input']>;
  /** Only return work items that have this quality manager assigned. If null, all work items are returned. If '0', only not assigned work items will be displayed. */
  qualityManagerId?: InputMaybe<Scalars['Int']['input']>;
  /** Only return work items whose associated appointment starts at or after this point in time. If null, all work items are returned. */
  startDateUtc?: InputMaybe<Scalars['DateTime']['input']>;
  /** Only return work items that are in one of the states specified. If null or empty, all work items are returned. */
  states?: InputMaybe<Array<ApprovalState>>;
  /** Only return work items that are in one of the work categories specified. If null or empty, all work items are returned. */
  workCategoryNames?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Only return work items associated with the requested work order id. */
  workOrderId?: InputMaybe<Scalars['Int']['input']>;
};

export type GetWorkItemsWorkItemPayloadModel = {
  __typename?: 'GetWorkItemsWorkItemPayloadModel';
  /** Contains the name of the customer or null if not set. Can be a company name or firstname + lastname if private person. */
  approvalState: ApprovalState;
  /** Contains the point in time when this tuple has been created. */
  createdAtUtc?: Maybe<Scalars['DateTime']['output']>;
  /** Determines the unique identifier for this object. */
  id: Scalars['Long']['output'];
  /** Contains the point in time when this tuple has been modified last or null if it has never been modified. */
  modifiedAtUtc?: Maybe<Scalars['DateTime']['output']>;
  /** Contains the name of the work order. */
  name?: Maybe<Scalars['String']['output']>;
  /** Gets the number of blocking values that have been submitted below this node. Blocking values prevent craftspeople from continuing their work. */
  numberOfBlockedFields: Scalars['Int']['output'];
  /** Contains the number of re-submitted field values entries within this work order. */
  numberOfResubmitted: Scalars['Int']['output'];
  /** Contains the number of newly submitted field values entries within this work order. */
  numberOfSubmitted: Scalars['Int']['output'];
  projectManager?: Maybe<UserPayloadModel>;
  qualityManager?: Maybe<UserPayloadModel>;
  submittedBy?: Maybe<UserPayloadModel>;
  workCategory: WorkCategoryPayloadModel;
  workGroup: WorkGroupPayloadModel;
  workOrder: WorkOrderPayloadModel;
};

export type GetWorkOrderAppointmentsInput = {
  /** Only return appointments that end at or before this point in time. If null, all appointments are returned. Do not filter if null. Default: null */
  endDateUtc?: InputMaybe<Scalars['DateTime']['input']>;
  /** Only return appointments where at least one sub-node is in the re-submitted state. Do not filter if null. Default: null */
  hasResubmitted?: InputMaybe<Scalars['Boolean']['input']>;
  /** Only return appointments where at least one sub-node is in the submitted state. Do not filter if null. Default: null */
  hasSubmitted?: InputMaybe<Scalars['Boolean']['input']>;
  /** If set to true, also include logically unreachable workflow items. Default: false */
  includeUnreachable?: InputMaybe<Scalars['Boolean']['input']>;
  /** If set to true, only return blocking work items. Otherwise do not filter on the blocking state. Default: false */
  onlyBlocking?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * Sets the sorting.
   *
   * Valid columns to sort by are: id, workflowDefinition, startAtUtc, status
   */
  orderBy?: InputMaybe<Array<SortDescriptionInput>>;
  /** Sets the page number and size of elements to return. */
  page?: InputMaybe<PageInput>;
  /** Only return appointments that start at or after this point in time. If null, all appointments are returned. Do not filter if null. Default: null */
  startDateUtc?: InputMaybe<Scalars['DateTime']['input']>;
  /**
   * Only return appointments that are in one of the supplied statuses. If null,
   * appropriate defaults are used depending on the role of the calling user. Deleted appointments can only
   * ever be seen by super users.
   */
  states?: InputMaybe<Array<AppointmentStatus>>;
  /** Only return appointments that are in one of the work categories specified. If null or empty, all appointments are returned. */
  workCategoryNames?: InputMaybe<Array<Scalars['String']['input']>>;
  /** The primary key of the work order to fetch appointments for. Must be specified and must be greater than zero. */
  workOrderId: Scalars['Int']['input'];
  /** Only return appointments with the specified workflow definition assigned. If null, no filtering happens. Default: null */
  workflowDefinitionId?: InputMaybe<Scalars['Int']['input']>;
};

export type GetWorkOrderAppointmentsPayloadModel = {
  __typename?: 'GetWorkOrderAppointmentsPayloadModel';
  /** Gets the responsible branch office for this appointment. */
  branchOffice?: Maybe<BranchOfficePayloadModel>;
  /** Gets the user created comment for this appointment. */
  comment?: Maybe<Scalars['String']['output']>;
  craftsmen?: Maybe<Array<UserPayloadModel>>;
  /** The end date of the appointment. */
  endDateUtc?: Maybe<Scalars['DateTime']['output']>;
  /** The expected duration of this appointment. */
  expectedDuration?: Maybe<Scalars['TimeSpan']['output']>;
  /** Determines the unique identifier for this object. */
  id: Scalars['Int']['output'];
  /** Gets or sets if the appointment has been acknowledged by the customer. */
  isBinding: Scalars['Boolean']['output'];
  /** Gets all partner companies associated with this appointment. */
  partnerCompanies?: Maybe<Array<PartnerCompanyPayloadModel>>;
  qualityManager?: Maybe<UserPayloadModel>;
  /** The start date of the appointment. */
  startDateUtc?: Maybe<Scalars['DateTime']['output']>;
  /** Contains a text that is supposed to be displayed on the start-screen of the appointment before it is started. */
  startScreenInformation?: Maybe<Scalars['String']['output']>;
  /** The status of this appointment. */
  status?: Maybe<AppointmentStatus>;
  teams?: Maybe<Array<TeamPayloadModel>>;
  /** The type of this appointment. */
  type?: Maybe<Scalars['String']['output']>;
  /**
   * Contains the work category, if any. This can be null if the appointment has not
   * ever been started.
   */
  workCategory?: Maybe<GetWorkOrderAppointmentsWorkCategoryPayloadModel>;
  /**
   * Contains the workflow associated with this appointment. The name of the workflow
   * corresponds to the 'Type' property.
   */
  workflowDefinition?: Maybe<WorkflowDefinitionPayloadModel>;
};

export type GetWorkOrderAppointmentsWorkCategoryPayloadModel = {
  __typename?: 'GetWorkOrderAppointmentsWorkCategoryPayloadModel';
  /** Contains the name of the customer or null if not set. Can be a company name or firstname + lastname if private person. */
  approvalState: ApprovalState;
  /** Contains the point in time when this tuple has been created. */
  createdAtUtc?: Maybe<Scalars['DateTime']['output']>;
  /** Contains the description of the WorkCategory. */
  description?: Maybe<Scalars['String']['output']>;
  /** Determines the unique identifier for this object. */
  id: Scalars['Int']['output'];
  /** Contains the point in time when this tuple has been modified last or null if it has never been modified. */
  modifiedAtUtc?: Maybe<Scalars['DateTime']['output']>;
  /** Contains the name of the work order. */
  name?: Maybe<Scalars['String']['output']>;
  /** Gets the number of blocking values that have been submitted below this node. Blocking values prevent craftspeople from continuing their work. */
  numberOfBlockedFields: Scalars['Int']['output'];
  /** Contains the number of re-submitted field values entries within this work order. */
  numberOfResubmitted: Scalars['Int']['output'];
  /** Contains the number of newly submitted field values entries within this work order. */
  numberOfSubmitted: Scalars['Int']['output'];
  /** Gets or sets the children of this node which must be of type WorkGroup. */
  workGroups?: Maybe<Array<GetWorkOrderAppointmentsWorkGroupPayloadModel>>;
};

export type GetWorkOrderAppointmentsWorkGroupPayloadModel = {
  __typename?: 'GetWorkOrderAppointmentsWorkGroupPayloadModel';
  /** Contains the name of the customer or null if not set. Can be a company name or firstname + lastname if private person. */
  approvalState: ApprovalState;
  /** Contains the point in time when this tuple has been created. */
  createdAtUtc?: Maybe<Scalars['DateTime']['output']>;
  /** Contains the description of the WorkGroup. */
  description?: Maybe<Scalars['String']['output']>;
  /** Determines the unique identifier for this object. */
  id: Scalars['Int']['output'];
  /** Contains the point in time when this tuple has been modified last or null if it has never been modified. */
  modifiedAtUtc?: Maybe<Scalars['DateTime']['output']>;
  /** Contains the name of the work order. */
  name?: Maybe<Scalars['String']['output']>;
  /** Gets the number of blocking values that have been submitted below this node. Blocking values prevent craftspeople from continuing their work. */
  numberOfBlockedFields: Scalars['Int']['output'];
  /** Contains the number of re-submitted field values entries within this work order. */
  numberOfResubmitted: Scalars['Int']['output'];
  /** Contains the number of newly submitted field values entries within this work order. */
  numberOfSubmitted: Scalars['Int']['output'];
  /** Gets or sets the children of this node which must be of type WorkItem. */
  workItems?: Maybe<Array<GetWorkOrderAppointmentsWorkItemPayloadModel>>;
};

export type GetWorkOrderAppointmentsWorkItemPayloadModel = {
  __typename?: 'GetWorkOrderAppointmentsWorkItemPayloadModel';
  /** Contains the name of the customer or null if not set. Can be a company name or firstname + lastname if private person. */
  approvalState: ApprovalState;
  /** Contains the point in time when this tuple has been created. */
  createdAtUtc?: Maybe<Scalars['DateTime']['output']>;
  /** Contains the description of the WorkItem. */
  description?: Maybe<Scalars['String']['output']>;
  /** Determines the unique identifier for this object. */
  id: Scalars['Long']['output'];
  /** Contains the point in time when this tuple has been modified last or null if it has never been modified. */
  modifiedAtUtc?: Maybe<Scalars['DateTime']['output']>;
  /** Contains the name of the work order. */
  name?: Maybe<Scalars['String']['output']>;
  /** Gets the number of blocking values that have been submitted below this node. Blocking values prevent craftspeople from continuing their work. */
  numberOfBlockedFields: Scalars['Int']['output'];
  /** Contains the number of re-submitted field values entries within this work order. */
  numberOfResubmitted: Scalars['Int']['output'];
  /** Contains the number of newly submitted field values entries within this work order. */
  numberOfSubmitted: Scalars['Int']['output'];
};

export type GetWorkOrderFilesInput = {
  /** Set to true (default: false) to also return all files in each folder returned. */
  includeFiles?: InputMaybe<Scalars['Boolean']['input']>;
  /** Only considered when 'IncludeFiles' is set to true. If set to true (default: false) unsafe files will also be returned. Unsafe files cannot be downloaded. */
  includeUnsafeFiles?: InputMaybe<Scalars['Boolean']['input']>;
  /** Set to true (default) to return data recursively. This would then traverse sub-folders. */
  recursive?: InputMaybe<Scalars['Boolean']['input']>;
  /** The primary key of the folder where to start returning data. Leave at NULL to use the work orders root folder. */
  rootFolderId?: InputMaybe<Scalars['Int']['input']>;
  /** The primary key of the work order whose files ought to be returned. */
  workOrderId: Scalars['Int']['input'];
};

export type GetWorkOrderFilesMediaPayloadModel = {
  __typename?: 'GetWorkOrderFilesMediaPayloadModel';
  /** The creation date of the file. */
  createdAtUtc?: Maybe<Scalars['DateTime']['output']>;
  /** Contains the user that has initially submitted the file. */
  createdBy?: Maybe<UserPayloadModel>;
  /** Contains the original filename the file had when it was uploaded. */
  fileName?: Maybe<Scalars['String']['output']>;
  /** Contains the size of the file in bytes. */
  fileSize?: Maybe<Scalars['Long']['output']>;
  /** Contains the folder name of the file. */
  folderName?: Maybe<Scalars['String']['output']>;
  /** Determines the unique identifier for this object. */
  id: Scalars['Int']['output'];
  /** Is true if the file can be downloaded, is false if the file cannot be downloaded due to security constraints. */
  isSafe: Scalars['Boolean']['output'];
  /** Contains the mimetype of the file. */
  mimeType?: Maybe<Scalars['String']['output']>;
  /** Contains the URL at which this blob can be downloaded. */
  uri?: Maybe<Scalars['String']['output']>;
  /** Contains text that describes the result of a virus scan. Is empty if the file has not yet been scanned. */
  virusScanResult?: Maybe<Scalars['String']['output']>;
};

export type GetWorkOrderFilesPayloadModel = {
  __typename?: 'GetWorkOrderFilesPayloadModel';
  /** Contains files within this folder. Can be empty. */
  files?: Maybe<Array<GetWorkOrderFilesMediaPayloadModel>>;
  /** Determines the unique identifier for this object. */
  id: Scalars['Int']['output'];
  /** Determines the name of the folder. */
  name: Scalars['String']['output'];
  /** Contains the primary key of the parent folder of this folder. Is NULL if this is a root folder. */
  parentId?: Maybe<Scalars['Int']['output']>;
};

export type GetWorkOrderInput = {
  /** Retrieves a work order by id. */
  workOrderId: Scalars['Int']['input'];
};

export type GetWorkOrderPayloadModel = {
  __typename?: 'GetWorkOrderPayloadModel';
  address?: Maybe<AddressPayloadModel>;
  /** Contains the name of the customer or null if not set. Can be a company name or firstname + lastname if private person. */
  approvalState: ApprovalState;
  branchOffice?: Maybe<BranchOfficePayloadModel>;
  /** Contains the info on the craftpeople that are assigned to the Appointments that are part of the Work Order. */
  constructedByCraftsmen?: Maybe<Array<GetWorkOrderUserPayloadModel>>;
  /** Contains the point in time when this tuple has been created. */
  createdAtUtc?: Maybe<Scalars['DateTime']['output']>;
  customers?: Maybe<Array<WorkOrderCustomerPayloadModelOfCustomerPayloadModel>>;
  /** Determines the eaasId for this object. */
  eaasId?: Maybe<Scalars['String']['output']>;
  /** Determines the unique identifier for this object. */
  id: Scalars['Int']['output'];
  /** Contains the point in time when this tuple has been modified last or null if it has never been modified. */
  modifiedAtUtc?: Maybe<Scalars['DateTime']['output']>;
  /** Contains the name of the work order. */
  name?: Maybe<Scalars['String']['output']>;
  /** Gets the number of blocking values that have been submitted below this node. Blocking values prevent craftspeople from continuing their work. */
  numberOfBlockedFields: Scalars['Int']['output'];
  /** Contains the number of re-submitted field values entries within this work order. */
  numberOfResubmitted: Scalars['Int']['output'];
  /** Contains the number of newly submitted field values entries within this work order. */
  numberOfSubmitted: Scalars['Int']['output'];
  paused: Scalars['Boolean']['output'];
  product?: Maybe<ProductPayloadModel>;
  projectManager?: Maybe<UserPayloadModel>;
  qualityManager?: Maybe<UserPayloadModel>;
  status: WorkOrderStatus;
};

export type GetWorkOrderStatusAppointmentPayloadModel = {
  __typename?: 'GetWorkOrderStatusAppointmentPayloadModel';
  /** Gets or sets all Teams which are working or going to work on the construction site of this appointment. */
  constructedByTeams?: Maybe<Array<TeamPayloadModel>>;
  /** The end date of the appointment. */
  endDateUtc?: Maybe<Scalars['DateTime']['output']>;
  /** The expected duration of this appointment. */
  expectedDuration?: Maybe<Scalars['TimeSpan']['output']>;
  /** Determines the unique identifier for this object. */
  id: Scalars['Int']['output'];
  /** The start date of the appointment. */
  startDateUtc?: Maybe<Scalars['DateTime']['output']>;
  /** Contains a text that is supposed to be displayed on the start-screen of the appointment before it is started. */
  startScreenInformation?: Maybe<Scalars['String']['output']>;
  /** The status of this appointment. */
  status?: Maybe<AppointmentStatus>;
  /** The type of this appointment. */
  type?: Maybe<Scalars['String']['output']>;
  /** Gets or sets the Workflow.WorkCategory that is associated with this appointment. */
  workCategory?: Maybe<GetWorkOrderStatusWorkCategoryPayloadModel>;
};

export type GetWorkOrderStatusInput = {
  workCategoryId?: InputMaybe<Scalars['Int']['input']>;
  workOrderId?: InputMaybe<Scalars['Int']['input']>;
};

export type GetWorkOrderStatusPayloadModel = {
  __typename?: 'GetWorkOrderStatusPayloadModel';
  /** Gets or sets a collection of Appointments that are associated with this WorkOrder. */
  appointments?: Maybe<Array<GetWorkOrderStatusAppointmentPayloadModel>>;
  /** Contains the name of the customer or null if not set. Can be a company name or firstname + lastname if private person. */
  approvalState: ApprovalState;
  /** Contains the point in time when this tuple has been created. */
  createdAtUtc?: Maybe<Scalars['DateTime']['output']>;
  /** Determines the eaasId for this object. */
  eaasId?: Maybe<Scalars['String']['output']>;
  /** Determines the unique identifier for this object. */
  id: Scalars['Int']['output'];
  /** Contains the point in time when this tuple has been modified last or null if it has never been modified. */
  modifiedAtUtc?: Maybe<Scalars['DateTime']['output']>;
  /** Contains the name of the work order. */
  name?: Maybe<Scalars['String']['output']>;
  /** Gets the number of blocking values that have been submitted below this node. Blocking values prevent craftspeople from continuing their work. */
  numberOfBlockedFields: Scalars['Int']['output'];
  /** Contains the number of re-submitted field values entries within this work order. */
  numberOfResubmitted: Scalars['Int']['output'];
  /** Contains the number of newly submitted field values entries within this work order. */
  numberOfSubmitted: Scalars['Int']['output'];
  /** Determines the quality manager. */
  qualityManager?: Maybe<UserPayloadModel>;
};

export type GetWorkOrderStatusWorkCategoryPayloadModel = {
  __typename?: 'GetWorkOrderStatusWorkCategoryPayloadModel';
  /** Contains the name of the customer or null if not set. Can be a company name or firstname + lastname if private person. */
  approvalState: ApprovalState;
  /** Contains the point in time when this tuple has been created. */
  createdAtUtc?: Maybe<Scalars['DateTime']['output']>;
  /** Contains the description of the WorkCategory. */
  description?: Maybe<Scalars['String']['output']>;
  /** Determines the unique identifier for this object. */
  id: Scalars['Int']['output'];
  /** Contains the point in time when this tuple has been modified last or null if it has never been modified. */
  modifiedAtUtc?: Maybe<Scalars['DateTime']['output']>;
  /** Contains the name of the work order. */
  name?: Maybe<Scalars['String']['output']>;
  /** Gets the number of blocking values that have been submitted below this node. Blocking values prevent craftspeople from continuing their work. */
  numberOfBlockedFields: Scalars['Int']['output'];
  /** Contains the number of re-submitted field values entries within this work order. */
  numberOfResubmitted: Scalars['Int']['output'];
  /** Contains the number of newly submitted field values entries within this work order. */
  numberOfSubmitted: Scalars['Int']['output'];
  /** Gets or sets the children of this node which must be of type WorkGroup. */
  workGroups?: Maybe<Array<GetWorkOrderStatusWorkGroupPayloadModel>>;
};

export type GetWorkOrderStatusWorkGroupPayloadModel = {
  __typename?: 'GetWorkOrderStatusWorkGroupPayloadModel';
  /** Contains the name of the customer or null if not set. Can be a company name or firstname + lastname if private person. */
  approvalState: ApprovalState;
  /** Contains the point in time when this tuple has been created. */
  createdAtUtc?: Maybe<Scalars['DateTime']['output']>;
  /** Contains the description of the WorkGroup. */
  description?: Maybe<Scalars['String']['output']>;
  /** Determines the unique identifier for this object. */
  id: Scalars['Int']['output'];
  /** Contains the point in time when this tuple has been modified last or null if it has never been modified. */
  modifiedAtUtc?: Maybe<Scalars['DateTime']['output']>;
  /** Contains the name of the work order. */
  name?: Maybe<Scalars['String']['output']>;
  /** Gets the number of blocking values that have been submitted below this node. Blocking values prevent craftspeople from continuing their work. */
  numberOfBlockedFields: Scalars['Int']['output'];
  /** Contains the number of re-submitted field values entries within this work order. */
  numberOfResubmitted: Scalars['Int']['output'];
  /** Contains the number of newly submitted field values entries within this work order. */
  numberOfSubmitted: Scalars['Int']['output'];
  /** Gets or sets the children of this node which must be of type WorkItems. */
  workItems?: Maybe<Array<WorkItemPayloadModel>>;
};

export type GetWorkOrderUserPayloadModel = {
  __typename?: 'GetWorkOrderUserPayloadModel';
  /** Determines the e-mail address of the user. */
  eMail?: Maybe<Scalars['String']['output']>;
  /** Determines the firstname of the user. */
  firstName?: Maybe<Scalars['String']['output']>;
  /** Determines the unique identifier for this object. */
  id: Scalars['Int']['output'];
  /** Whether this entity is deleted or not. */
  isDeleted: Scalars['Boolean']['output'];
  /** Determines the lastname of the user. */
  lastName?: Maybe<Scalars['String']['output']>;
  /** Determines the mobile phone number of the user. */
  mobilePhone?: Maybe<Scalars['String']['output']>;
  /** Determines the phone number of the user. */
  phone?: Maybe<Scalars['String']['output']>;
};

export type GetWorkOrdersInput = {
  /** Only return work orders created on/before this day. Day-based filter. */
  createdAtEndUtc?: InputMaybe<Scalars['DateTime']['input']>;
  /** Only return work orders created on/after this day. Day-based filter. */
  createdAtStartUtc?: InputMaybe<Scalars['DateTime']['input']>;
  /** Only return work orders where at least one associated appointment end at or before this point in time. If null, all work orders are returned. Do not filter if null. Default: null */
  endDateUtc?: InputMaybe<Scalars['DateTime']['input']>;
  /** Only return work orders where at least one sub-node is in the re-submitted state. Do not filter if null. Default: null */
  hasResubmitted?: InputMaybe<Scalars['Boolean']['input']>;
  /** Only return work orders where at least one sub-node is in the submitted state. Do not filter if null. Default: null */
  hasSubmitted?: InputMaybe<Scalars['Boolean']['input']>;
  /** If set to true, the response will include the total count of submitted and re-submitted items across all pages. Default: false */
  includeStatistics?: InputMaybe<Scalars['Boolean']['input']>;
  /** If set to true, only return blocking work items. Otherwise do not filter on the blocking state. Default: false */
  onlyBlocking?: InputMaybe<Scalars['Boolean']['input']>;
  /** If set to false, return also work orders that don't have any appointment. Otherwise returns only those that have appointment in not aborted nor deleted status. Default: true */
  onlyWithAppointments?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * Sets the sorting. By default, the response will be sorted by first name (asc), then last name (asc).
   *
   * Valid columns to sort by are: id, firstName, lastName
   */
  orderBy?: InputMaybe<Array<SortDescriptionInput>>;
  /** Sets the page number and size of elements to return. */
  page?: InputMaybe<PageInput>;
  /** Only return work orders assigned to this product. Do not filter if null. Default: null */
  productId?: InputMaybe<Scalars['Int']['input']>;
  /** Only return work orders assigned to this project manager. Do not filter if null. Filter for [nobody], If the value is '0'. Default: null */
  projectManagerId?: InputMaybe<Scalars['Int']['input']>;
  /** Only return work orders assigned to this quality manager. Do not filter if null. Filter for [nobody], If the value is '0'. Default: null */
  qualityManagerId?: InputMaybe<Scalars['Int']['input']>;
  /** A user defined search string analog to Google syntax. Default: null */
  search?: InputMaybe<Scalars['String']['input']>;
  /** Only return work orders where at least one associated appointment starts at or after this point in time. If null, all work orders are returned. Do not filter if null. Default: null */
  startDateUtc?: InputMaybe<Scalars['DateTime']['input']>;
  /** Only return work orders that are in one of the supplied statuses. Do not filter if null. Default: null */
  status?: InputMaybe<Array<ApprovalState>>;
  /** Only return work orders where updated at this point in time. If null, all work orders are returned. Do not filter if null. Default: null */
  updatedAtUtc?: InputMaybe<Scalars['DateTime']['input']>;
  /** Only return work orders that are in one of the work categories specified. If null or empty, all work orders are returned. */
  workCategoryNames?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type GetWorkOrdersWorkOrderPayloadModel = {
  __typename?: 'GetWorkOrdersWorkOrderPayloadModel';
  /** Contains the name of the customer or null if not set. Can be a company name or firstname + lastname if private person. */
  approvalState: ApprovalState;
  branchOffice?: Maybe<BranchOfficePayloadModel>;
  /** Contains the point in time when this tuple has been created. */
  createdAtUtc?: Maybe<Scalars['DateTime']['output']>;
  customers?: Maybe<Array<WorkOrderCustomerPayloadModelOfCustomerPayloadModel>>;
  /** Determines the eaasId for this object. */
  eaasId?: Maybe<Scalars['String']['output']>;
  /** Determines the unique identifier for this object. */
  id: Scalars['Int']['output'];
  /** Contains the point in time when this tuple has been modified last or null if it has never been modified. */
  modifiedAtUtc?: Maybe<Scalars['DateTime']['output']>;
  /** Contains the name of the work order. */
  name?: Maybe<Scalars['String']['output']>;
  /** Gets the number of blocking values that have been submitted below this node. Blocking values prevent craftspeople from continuing their work. */
  numberOfBlockedFields: Scalars['Int']['output'];
  /** Represents the sum of `NumberOfSubmitted` and `NumberOfResubmitted`. */
  numberOfIssues: Scalars['Int']['output'];
  /** Contains the number of re-submitted field values entries within this work order. */
  numberOfResubmitted: Scalars['Int']['output'];
  /** Contains the number of newly submitted field values entries within this work order. */
  numberOfSubmitted: Scalars['Int']['output'];
  paused: Scalars['Boolean']['output'];
  product?: Maybe<ProductPayloadModel>;
  projectManager?: Maybe<UserPayloadModel>;
  qualityManager?: Maybe<UserPayloadModel>;
  status: WorkOrderStatus;
  workCategories?: Maybe<Array<WorkCategoryPayloadModel>>;
};

export type GetWorkflowDefinitionInstanceAppointmentsInput = {
  /** Only return appointments that end at or before this point in time. If null, all appointments are returned. Do not filter if null. Default: null */
  endDateUtc?: InputMaybe<Scalars['DateTime']['input']>;
  /** Only return appointments where at least one sub-node is in the re-submitted state. Do not filter if null. Default: null */
  hasResubmitted?: InputMaybe<Scalars['Boolean']['input']>;
  /** Only return appointments where at least one sub-node is in the submitted state. Do not filter if null. Default: null */
  hasSubmitted?: InputMaybe<Scalars['Boolean']['input']>;
  /** If set to true, also include logically unreachable workflow items. Default: false */
  includeUnreachable?: InputMaybe<Scalars['Boolean']['input']>;
  /** If set to true, only return blocking work items. Otherwise do not filter on the blocking state. Default: false */
  onlyBlocking?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * Sets the sorting.
   *
   * Valid columns to sort by are: id, workflowDefinition, startAtUtc, status
   */
  orderBy?: InputMaybe<Array<SortDescriptionInput>>;
  /** Sets the page number and size of elements to return. */
  page?: InputMaybe<PageInput>;
  /** Only return appointments that start at or after this point in time. If null, all appointments are returned. Do not filter if null. Default: null */
  startDateUtc?: InputMaybe<Scalars['DateTime']['input']>;
  /**
   * Only return appointments that are in one of the supplied statuses. If null,
   * appropriate defaults are used depending on the role of the calling user. Deleted appointments can only
   * ever be seen by super users.
   */
  states?: InputMaybe<Array<AppointmentStatus>>;
  /** Only return appointments that are in one of the work categories specified. If null or empty, all appointments are returned. */
  workCategoryNames?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Only return appointments with the specified workflow definition assigned. If null, no filtering happens. Default: null */
  workflowDefinitionId?: InputMaybe<Scalars['Int']['input']>;
  /** The primary key of the workflow definition instance to fetch appointments for. Must be specified and must be greater than zero. */
  workflowDefinitionInstanceId: Scalars['Int']['input'];
};

export type GetWorkflowDefinitionInstanceAppointmentsPayloadModel = {
  __typename?: 'GetWorkflowDefinitionInstanceAppointmentsPayloadModel';
  /** Gets the responsible branch office for this appointment. */
  branchOffice?: Maybe<BranchOfficePayloadModel>;
  /** Gets the user created comment for this appointment. */
  comment?: Maybe<Scalars['String']['output']>;
  craftsmen?: Maybe<Array<UserPayloadModel>>;
  /** The end date of the appointment. */
  endDateUtc?: Maybe<Scalars['DateTime']['output']>;
  /** The expected duration of this appointment. */
  expectedDuration?: Maybe<Scalars['TimeSpan']['output']>;
  /** Determines the unique identifier for this object. */
  id: Scalars['Int']['output'];
  /** Gets or sets if the appointment has been acknowledged by the customer. */
  isBinding: Scalars['Boolean']['output'];
  /** Gets all partner companies associated with this appointment. */
  partnerCompanies?: Maybe<Array<PartnerCompanyPayloadModel>>;
  qualityManager?: Maybe<UserPayloadModel>;
  /** The start date of the appointment. */
  startDateUtc?: Maybe<Scalars['DateTime']['output']>;
  /** Contains a text that is supposed to be displayed on the start-screen of the appointment before it is started. */
  startScreenInformation?: Maybe<Scalars['String']['output']>;
  /** The status of this appointment. */
  status?: Maybe<AppointmentStatus>;
  teams?: Maybe<Array<TeamPayloadModel>>;
  /** The type of this appointment. */
  type?: Maybe<Scalars['String']['output']>;
  /**
   * Contains the work category, if any. This can be null if the appointment has not
   * ever been started.
   */
  workCategory?: Maybe<GetWorkflowDefinitionInstanceAppointmentsWorkCategoryPayloadModel>;
  /**
   * Contains the workflow associated with this appointment. The name of the workflow
   * corresponds to the 'Type' property.
   */
  workflowDefinition?: Maybe<WorkflowDefinitionPayloadModel>;
};

export type GetWorkflowDefinitionInstanceAppointmentsWorkCategoryPayloadModel = {
  __typename?: 'GetWorkflowDefinitionInstanceAppointmentsWorkCategoryPayloadModel';
  /** Contains the name of the customer or null if not set. Can be a company name or firstname + lastname if private person. */
  approvalState: ApprovalState;
  /** Contains the point in time when this tuple has been created. */
  createdAtUtc?: Maybe<Scalars['DateTime']['output']>;
  /** Contains the description of the WorkCategory. */
  description?: Maybe<Scalars['String']['output']>;
  /** Determines the unique identifier for this object. */
  id: Scalars['Int']['output'];
  /** Contains the point in time when this tuple has been modified last or null if it has never been modified. */
  modifiedAtUtc?: Maybe<Scalars['DateTime']['output']>;
  /** Contains the name of the work order. */
  name?: Maybe<Scalars['String']['output']>;
  /** Gets the number of blocking values that have been submitted below this node. Blocking values prevent craftspeople from continuing their work. */
  numberOfBlockedFields: Scalars['Int']['output'];
  /** Contains the number of re-submitted field values entries within this work order. */
  numberOfResubmitted: Scalars['Int']['output'];
  /** Contains the number of newly submitted field values entries within this work order. */
  numberOfSubmitted: Scalars['Int']['output'];
  /** Gets or sets the children of this node which must be of type WorkGroup. */
  workGroups?: Maybe<Array<GetWorkflowDefinitionInstanceAppointmentsWorkGroupPayloadModel>>;
};

export type GetWorkflowDefinitionInstanceAppointmentsWorkGroupPayloadModel = {
  __typename?: 'GetWorkflowDefinitionInstanceAppointmentsWorkGroupPayloadModel';
  /** Contains the name of the customer or null if not set. Can be a company name or firstname + lastname if private person. */
  approvalState: ApprovalState;
  /** Contains the point in time when this tuple has been created. */
  createdAtUtc?: Maybe<Scalars['DateTime']['output']>;
  /** Contains the description of the WorkGroup. */
  description?: Maybe<Scalars['String']['output']>;
  /** Determines the unique identifier for this object. */
  id: Scalars['Int']['output'];
  /** Contains the point in time when this tuple has been modified last or null if it has never been modified. */
  modifiedAtUtc?: Maybe<Scalars['DateTime']['output']>;
  /** Contains the name of the work order. */
  name?: Maybe<Scalars['String']['output']>;
  /** Gets the number of blocking values that have been submitted below this node. Blocking values prevent craftspeople from continuing their work. */
  numberOfBlockedFields: Scalars['Int']['output'];
  /** Contains the number of re-submitted field values entries within this work order. */
  numberOfResubmitted: Scalars['Int']['output'];
  /** Contains the number of newly submitted field values entries within this work order. */
  numberOfSubmitted: Scalars['Int']['output'];
  /** Gets or sets the children of this node which must be of type WorkItem. */
  workItems?: Maybe<Array<GetWorkflowDefinitionInstanceAppointmentsWorkItemPayloadModel>>;
};

export type GetWorkflowDefinitionInstanceAppointmentsWorkItemPayloadModel = {
  __typename?: 'GetWorkflowDefinitionInstanceAppointmentsWorkItemPayloadModel';
  /** Contains the name of the customer or null if not set. Can be a company name or firstname + lastname if private person. */
  approvalState: ApprovalState;
  /** Contains the point in time when this tuple has been created. */
  createdAtUtc?: Maybe<Scalars['DateTime']['output']>;
  /** Contains the description of the WorkItem. */
  description?: Maybe<Scalars['String']['output']>;
  /** Determines the unique identifier for this object. */
  id: Scalars['Long']['output'];
  /** Contains the point in time when this tuple has been modified last or null if it has never been modified. */
  modifiedAtUtc?: Maybe<Scalars['DateTime']['output']>;
  /** Contains the name of the work order. */
  name?: Maybe<Scalars['String']['output']>;
  /** Gets the number of blocking values that have been submitted below this node. Blocking values prevent craftspeople from continuing their work. */
  numberOfBlockedFields: Scalars['Int']['output'];
  /** Contains the number of re-submitted field values entries within this work order. */
  numberOfResubmitted: Scalars['Int']['output'];
  /** Contains the number of newly submitted field values entries within this work order. */
  numberOfSubmitted: Scalars['Int']['output'];
};

export type GetWorkflowDefinitionVersionInput = {
  /** The Workflow Definition Id */
  workflowDefinitionId: Scalars['Int']['input'];
};

export type GetWorkflowDefinitionVersionPayloadModel = {
  __typename?: 'GetWorkflowDefinitionVersionPayloadModel';
  /** The Workflow Definition version in Json Format */
  code?: Maybe<Scalars['String']['output']>;
  /** Determines the point in time when this object has been created. This is in UTC. */
  createdAtUtc?: Maybe<Scalars['DateTime']['output']>;
  /** Determines the unique identifier for this object. */
  id: Scalars['Int']['output'];
};

export type GetWorkflowDefinitionsInput = {
  /** Only return field definitions that have been created by this user. Set to null to disable filter. */
  createdByUserId?: InputMaybe<Scalars['Int']['input']>;
  /** Optionally declare by which columns you want to have the result set sorted. */
  orderBy?: InputMaybe<Array<SortDescriptionInput>>;
  /** Sets the page number and size of elements to return. */
  page?: InputMaybe<PageInput>;
};

export type GetWorkflowDefinitionsWorkflowDefinitionPayloadModel = {
  __typename?: 'GetWorkflowDefinitionsWorkflowDefinitionPayloadModel';
  /** Determines when this item has been created initially. */
  createdAtUtc?: Maybe<Scalars['DateTime']['output']>;
  /** Determines the user who created this item initially. */
  createdBy?: Maybe<UserPayloadModel>;
  /** Determines the current version of the workflow definition. */
  currentVersion?: Maybe<GetWorkflowDefinitionsWorkflowDefinitionVersionPayloadModel>;
  /** Determines the unique identifier for this object. */
  id: Scalars['Int']['output'];
  /** Determines the unique identifier for this object. */
  name?: Maybe<Scalars['String']['output']>;
};

export type GetWorkflowDefinitionsWorkflowDefinitionVersionPayloadModel = {
  __typename?: 'GetWorkflowDefinitionsWorkflowDefinitionVersionPayloadModel';
  /** Determines the point in time when this object has been created. This is in UTC. */
  createdAtUtc?: Maybe<Scalars['DateTime']['output']>;
  /** Determines the user who created this item initially. */
  createdBy?: Maybe<UserPayloadModel>;
  /** Determines the unique identifier for this object. */
  id: Scalars['Int']['output'];
  /**
   * Determines if this workflow definition version is used for
   * VOT appointments created via service bus messages.
   */
  isDefaultForDynamicsWorkOrders: Scalars['Boolean']['output'];
  /**
   * Determines if appointments using this workflow definition
   * version should show the material list.
   */
  showMaterialsInAppointment: Scalars['Boolean']['output'];
};

export type InvalidParam = {
  __typename?: 'InvalidParam';
  param: Scalars['String']['output'];
  reason: Scalars['String']['output'];
  values?: Maybe<Array<Scalars['String']['output']>>;
};

export enum JobErrorType {
  None = 'NONE',
  NotFound = 'NOT_FOUND',
  ValidationError = 'VALIDATION_ERROR',
}

export type JobPayloadModel = {
  __typename?: 'JobPayloadModel';
  /** Determines the unique ID of the job. */
  id?: Maybe<Scalars['String']['output']>;
  /** Depending on the type of job, this set may contain job result values like URLs or other data. */
  results?: Maybe<Array<KeyValuePairOfStringAndString>>;
  /**
   * Determines state of the job. Possible states are:
   *
   * Awaiting
   * Deleted
   * Enqueued
   * Failed
   * Processing
   * Scheduled
   * Succeeded
   */
  state?: Maybe<Scalars['String']['output']>;
};

export type KeyValuePairOfStringAndIFile__Input = {
  key: Scalars['String']['input'];
  value: Array<Scalars['Upload']['input']>;
};

export type KeyValuePairOfStringAndInt32__Input = {
  key: Scalars['String']['input'];
  value: Array<Scalars['Int']['input']>;
};

export type KeyValuePairOfStringAndPushFieldValuesFieldValuePayloadModel = {
  __typename?: 'KeyValuePairOfStringAndPushFieldValuesFieldValuePayloadModel';
  key: Scalars['String']['output'];
  value: PushFieldValuesFieldValuePayloadModel;
};

export type KeyValuePairOfStringAndString = {
  __typename?: 'KeyValuePairOfStringAndString';
  key: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type KeyValuePairOfStringAndStringInput = {
  key: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

export type KeyValuePairOfStringAndString__Input = {
  key: Scalars['String']['input'];
  value: Array<Scalars['String']['input']>;
};

export enum ListSortDirection {
  Ascending = 'ASCENDING',
  Descending = 'DESCENDING',
}

export type MaterialPayloadModel = {
  __typename?: 'MaterialPayloadModel';
  /** The human readable name of this material. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Determines the unique identifier for this object. */
  id: Scalars['Int']['output'];
  /** Gets or sets the pre-defined type of the material. */
  type: MaterialType;
};

export enum MaterialType {
  Battery = 'BATTERY',
  Heatpump = 'HEATPUMP',
  Inverter = 'INVERTER',
  Other = 'OTHER',
  SolarPanel = 'SOLAR_PANEL',
  Wallbox = 'WALLBOX',
}

export type MediaPayloadModel = {
  __typename?: 'MediaPayloadModel';
  /** The creation date of the file. */
  createdAtUtc?: Maybe<Scalars['DateTime']['output']>;
  /** Contains the user that has initially submitted the file. */
  createdBy?: Maybe<UserPayloadModel>;
  /** Contains the original filename the file had when it was uploaded. */
  fileName?: Maybe<Scalars['String']['output']>;
  /** Contains the size of the file in bytes. */
  fileSize?: Maybe<Scalars['Long']['output']>;
  /** Contains the folder name of the file. */
  folderName?: Maybe<Scalars['String']['output']>;
  /** Determines the unique identifier for this object. */
  id: Scalars['Int']['output'];
  /** Is true if the file can be downloaded, is false if the file cannot be downloaded due to security constraints. */
  isSafe: Scalars['Boolean']['output'];
  /** Contains the mimetype of the file. */
  mimeType?: Maybe<Scalars['String']['output']>;
  /** Contains the URL at which this blob can be downloaded. */
  uri?: Maybe<Scalars['String']['output']>;
  /** Contains text that describes the result of a virus scan. Is empty if the file has not yet been scanned. */
  virusScanResult?: Maybe<Scalars['String']['output']>;
};

export enum MobilePlatform {
  Android = 'ANDROID',
  IOs = 'I_OS',
  Unknown = 'UNKNOWN',
}

export type Mutation = {
  __typename?: 'Mutation';
  /** Mutation to assign some partner companies to the Appointment. This endpoint returns all assigned craft companies.Ref:Reza Gholam Shazari. Query Status: $Done */
  assignCraftCompanyToAppointment_V1: GetNoItemResponsePayloadOfAppointmentErrorType;
  /** Mutation to assign one user to one team. This endpoint will remove the user from any existing appointment construction craftsmen and assign the user for all appointments that belongs to the new team. Ref:André Varela. Query Status: $Done */
  assignUserToTeam_V1: GetNoItemResponsePayloadOfTeamErrorType;
  /** Mutation to attach one team and all the users assigned, on the Appointment. This endpoint will return all the new users assigned to the appointment. Ref:André Varela. Query Status: $Done */
  attachTeamToAppointment_V1: GetSingleResponsePayloadOfAttachTeamToAppointmentPayloadModelAndAppointmentErrorType;
  /** Mutation to attach some user or some users in the Appointment. This endpoint returns all input user ids and for each id if the assignment was sucessful or not. Ref:André Varela. Query Status: $Done */
  attachUserToAppointment_V1: GetSingleResponsePayloadOfAttachUserToAppointmentPayloadModelAndAppointmentErrorType;
  /** Closes an appointment by approving the final workflow field (isTerminator).Ref:Reza Gholam Shazari. Query Status: Done */
  closeAppointment_V1: GetNoItemResponsePayloadOfAppointmentErrorType;
  /**
   * Subscribes the current user for asynchronous notifications.
   *
   * Ref: Enrico Neidt
   */
  createDeviceSubscription_V1: GetNoItemResponsePayloadOfDeviceErrorType;
  /**
   * Endpoint that will create a new team. As we are creating a new one, we could assign the Members that will work within this team and all the skills (workflow definitions) that will be used in this team.
   *     Ref: André Varela
   */
  createTeam_V1: GetSingleResponsePayloadOfCreateTeamPayloadModelAndTeamErrorType;
  /** Mutation to update an existing field value entry state. Ref:André Varela */
  decideFieldValueEntry_V1: GetSingleResponsePayloadOfFieldValueEntryPayloadModelAndDecideFieldValueEntryErrorType;
  /** Approve/reject individual photos inside an item-array field entry (batch). Ref:Reza Gholam Shazari */
  decideFieldValueItems_V1: GetSingleResponsePayloadOfFieldValueEntryPayloadModelAndDecideFieldValueEntryErrorType;
  /**
   * Deletes an existing appointment.
   *
   * This mutation allows the deletion of an appointment, provided it meets the business logic requirements (e.g., the appointment is not in a restricted state such as STARTED or DONE). The mutation returns a response indicating the success or failure of the operation and includes error types specific to appointment operations.
   *
   * Ref: Reza Gholam Shazari
   */
  deleteAppointment_V1: GetNoItemResponsePayloadOfAppointmentErrorType;
  /**
   * Deletes a blocker by its Id.
   *
   * Ref: Reza Gholam Shazari
   */
  deleteBlocker_V1: GetNoItemResponsePayloadOfBlockerErrorType;
  /**
   * Subscribes the current user for asynchronous notifications.
   *
   * Ref: Enrico Neidt
   */
  deleteDeviceSubscription_V1: GetNoItemResponsePayloadOfDeviceErrorType;
  /**
   * Mutation to start the job that will create a report for a single appointment.
   *
   * Returns the job ID that represents the ongoing process. Use the 'getJob_V1' endpoint to query the
   * status of the job. Eventually, upon successful completion, the returned status will contain the URL at
   * which to download the generated file.
   *
   * Ref:Enrico Neidt.
   * Query Status: $Done
   */
  generateAppointmentReport_V1: GetSingleResponsePayloadOfJobPayloadModelAndAppointmentErrorType;
  /**
   * Generates Uri with SAS Token aka signed url for file by its name and path to it.
   *
   *  Ref: Mateusz Redynk
   */
  generateSignedUrlForFile_V1: GetSingleResponsePayloadOfGenerateSignedUrlForFilePayloadModelAndGenerateSignedUrlForFileErrorType;
  /**
   * Generates Uri with SAS Token aka signed url for upload temp file using its name and path related to work order.
   *
   *  Ref: Reza Gholam Shazari
   */
  generateUploadSignedUrlForWorkOrder_V1: GetManyResponsePayloadOfGenerateUploadSignedUrlsForWorkOrderPayloadModelAndGenerateUploadSignedUrlsForWorkOrderErrorType;
  /**
   * Mutation to start the job that will create a work order report.
   *
   * Returns the job ID that represents the ongoing process. Use the 'getJob_V1' endpoint to query the
   * status of the job. Eventually, upon successful completion, the returned status will contain the URL at
   * which to download the generated file.
   *
   * Ref:Ricardo Santos.
   * Query Status: $Done
   */
  generateWorkOrderReport_V1: GetSingleResponsePayloadOfJobPayloadModelAndWorkOrderErrorType;
  /**
   * Mutation to start the job that will create a zip file with all pictures of an appointment.
   *
   * Returns the job ID that represents the ongoing process. Use the 'getJob_V1' endpoint to query the
   * status of the job. Eventually, upon successful completion, the returned status will contain the URL at
   * which to download the generated file.
   *
   * Ref:André Varela.
   * Query Status: $Done
   */
  generateZipAppointmentPictures_V1: GetSingleResponsePayloadOfJobPayloadModelAndAppointmentErrorType;
  /**
   * Update an existing appointment with the option to modify its relations.
   *
   * Ref: Reza Gholam Shazari
   */
  patchAppointmentComposite_V1: GetNoItemResponsePayloadOfAppointmentErrorType;
  /**
   * Update an existing appointment associated with the specified work order.
   *
   * The appointment must have a workflow definition ID and start and end dates specified as well. In the
   * case of all-day appointments set the time to 00:00:00. If the appointment spans only one day, set
   * start- and end date to the same value.
   *
   * The endpoint will return enough information about the new appointment to present it in calendar view.
   *
   * Ref: Reza Gholam Shazari
   */
  patchAppointment_V1: GetSingleResponsePayloadOfAppointmentCalendarItemPayloadModelAndAppointmentErrorType;
  /**
   * Endpoint that will update an existing blocker.
   *     Ref: Reza Gholam Shazari
   */
  patchBlocker_V1: GetSingleResponsePayloadOfBlockerCalendarItemPayloadModelAndBlockerErrorType;
  /**
   * Create a new customer or Update an already existing customer. If we are creating a new one, we could assign the Invoice Address and Delivery Address to the customer.
   *
   * Ref: André Varela
   */
  patchCustomer_V1: GetSingleResponsePayloadOfPatchCustomerPayloadModelAndCustomerErrorType;
  /**
   * Updates an already existing outbound synchronization or creates a new one.
   *
   * Ref: Enrico Neidt
   */
  patchOutboundSynchronization_V1: GetSingleResponsePayloadOfPatchOutboundSyncPayloadModelAndOutboundSyncErrorType;
  /**
   * Adds a new product folder layout to a product/service provider combination.
   *
   * Ref: Enrico Neidt
   */
  patchProductFolderLayout_V1: GetNoItemResponsePayloadOfProductFolderLayoutErrorType;
  /**
   * Creates a new appointment associated with the specified work order.
   *
   * The appointment must have a workflow definition ID and start and end dates specified as well. In the
   * case of all-day appointments set the time to 00:00:00. If the appointment spans only one day, set
   * start- and end date to the same value.
   *
   * The endpoint will return enough information about the new appointment to present it in calendar view.
   *
   * Ref: Enrico Neidt, Reza Gholam Shazari
   */
  postAppointment_V1: GetSingleResponsePayloadOfAppointmentCalendarItemPayloadModelAndAppointmentErrorType;
  /** Ref: Reza Gholam Shazari */
  postBlocker_V1: GetSingleResponsePayloadOfBlockerCalendarItemPayloadModelAndBlockerErrorType;
  /** Mutation to pull the work order responsibility. The work order must not be closed yet. Ref:André Varela. Query Status: $Done */
  pullWorkOrder_V1: GetSingleResponsePayloadOfPullWorkOrderPayloadModelAndWorkOrderErrorType;
  /**
   * Mutation to update the the values of fields associated to a given Appointment.
   *
   * Use this endpoint to submit all user-modified workflow fields. You need the field name and their new value.
   * Keep in mind that you have to JSON the value as in this API it is simply a string but we need to cover
   * complex objects and arrays too. If the value is not valid JSON according to the field's type,
   * the endpoint will return an error.
   *
   * The endpoint will return you the now current value for all fields you submitted. If any value is invalid,
   * the endpoint does not return that information as no value is being stored in the database in this case
   * so no IDs can be generated. You will have to re-submit all values again after the user corrected the
   * invalid ones.
   *
   * This API does only deal with field names, not field IDs. The returned dictionary uses the corresponding
   * field name as key.
   *
   * Ref: Enrico Neidt.
   * Query Status: $Potential Changes
   */
  pushFieldValues_V1: GetSingleResponsePayloadOfPushFieldValuesPayloadModelAndFieldValueErrorType;
  /** reopen an appointmentRef:Reza Gholam Shazari. Query Status: Done */
  reopenAppointment_V1: GetNoItemResponsePayloadOfAppointmentErrorType;
  /**
   * Mutation to schedule an existing appointment.
   *
   * The appointment must either be in the "OPEN" or in the
   * "SCHEDULED" state. Make the the start date is smaller than
   * the end date. Set both dates to NULL to completely unschedule it.
   *
   * Ref: Enrico Neidt.
   * Endpoint Status: Potential Changes
   */
  scheduleAppointment_V1: GetSingleResponsePayloadOfAppointmentPayloadModelAndAppointmentErrorType;
  /** Mutation to start an existing appointment. The appointment must be in the "SCHEDULED" state for succesfully starting it. Ref:Adrian Buda. Query Status: $Done */
  startAppointment_V1: GetSingleResponsePayloadOfStartAppointmentAppointmentPayloadModelAndAppointmentErrorType;
  /** Mutation to unassign some partner companies from the Appointment.Ref:Reza Gholam Shazari. Query Status: $Done */
  unassignCraftCompanyToAppointment_V1: GetNoItemResponsePayloadOfAppointmentErrorType;
  /** Mutation to unassign some team from the Appointment. All the users assigned to the team will be unassigned from appointment. Ref:André Varela. Query Status: $Done */
  unassignTeamFromAppointment_V1: GetNoItemResponsePayloadOfAppointmentErrorType;
  /** Mutation to unassign some user from the Appointment. Ref:André Varela. Query Status: $Done */
  unassignUserFromAppointment_V1: GetNoItemResponsePayloadOfAppointmentErrorType;
  /**
   * Endpoint that will update an existing team. We must receive all the Members assigned that will work within this team and all the skills (workflow definitions) that will be used in this team.
   *     Ref: André Varela
   */
  updateTeam_V1: GetSingleResponsePayloadOfUpdateTeamPayloadModelAndTeamErrorType;
  /**
   * Mutation to upload a file into a folder.
   *
   * The folder the file is being put into must be specified on the request object. Since a folder
   * always directly or indirectly leads to a WorkOrder, the uploaded file becomes part of this WorkOrder.
   *
   * Ref: Enrico Neidt.
   * Query Status: $Done
   */
  uploadWorkOrderDocuments_V1: GetManyResponsePayloadOfMediaPayloadModelAndFileErrorType;
};

export type MutationAssignCraftCompanyToAppointment_V1Args = {
  input: AssignCraftCompanyToAppointmentInput;
};

export type MutationAssignUserToTeam_V1Args = {
  input: AssignUserToTeamInput;
};

export type MutationAttachTeamToAppointment_V1Args = {
  input: AttachTeamToAppointmentInput;
};

export type MutationAttachUserToAppointment_V1Args = {
  input: AttachUserToAppointmentInput;
};

export type MutationCloseAppointment_V1Args = {
  input: CloseAppointmentInput;
};

export type MutationCreateDeviceSubscription_V1Args = {
  input: CreateDeviceSubscriptionInput;
};

export type MutationCreateTeam_V1Args = {
  input: CreateTeamInput;
};

export type MutationDecideFieldValueEntry_V1Args = {
  input: DecideFieldValueEntryInput;
};

export type MutationDecideFieldValueItems_V1Args = {
  input: DecideFieldValueItemsInput;
};

export type MutationDeleteAppointment_V1Args = {
  input: DeleteAppointmentInput;
};

export type MutationDeleteBlocker_V1Args = {
  input: DeleteBlockerInput;
};

export type MutationDeleteDeviceSubscription_V1Args = {
  input: DeleteDeviceSubscriptionInput;
};

export type MutationGenerateAppointmentReport_V1Args = {
  input: GenerateAppointmentReportInput;
};

export type MutationGenerateSignedUrlForFile_V1Args = {
  input: GenerateSingedUrlForFileInput;
};

export type MutationGenerateUploadSignedUrlForWorkOrder_V1Args = {
  input: GenerateUploadSignedUrlsForWorkOrderInput;
};

export type MutationGenerateWorkOrderReport_V1Args = {
  input: GenerateWorkOrderReportInput;
};

export type MutationGenerateZipAppointmentPictures_V1Args = {
  input: GenerateZipAppointmentPicturesInput;
};

export type MutationPatchAppointmentComposite_V1Args = {
  input: PatchAppointmentCompositeInput;
};

export type MutationPatchAppointment_V1Args = {
  input: PatchAppointmentInput;
};

export type MutationPatchBlocker_V1Args = {
  input: PatchBlockerInput;
};

export type MutationPatchCustomer_V1Args = {
  input: PatchCustomerInput;
};

export type MutationPatchOutboundSynchronization_V1Args = {
  input: PatchOutboundSyncInput;
};

export type MutationPatchProductFolderLayout_V1Args = {
  input?: InputMaybe<PatchProductFolderLayoutInput>;
};

export type MutationPostAppointment_V1Args = {
  input: PostAppointmentInput;
};

export type MutationPostBlocker_V1Args = {
  input: PostBlockerInput;
};

export type MutationPullWorkOrder_V1Args = {
  input: PullWorkOrderInput;
};

export type MutationPushFieldValues_V1Args = {
  input: PushFieldValuesInput;
};

export type MutationReopenAppointment_V1Args = {
  input: ReopenAppointmentInput;
};

export type MutationScheduleAppointment_V1Args = {
  input: ScheduleAppointmentInput;
};

export type MutationStartAppointment_V1Args = {
  input: StartAppointmentInput;
};

export type MutationUnassignCraftCompanyToAppointment_V1Args = {
  input: UnassignCraftCompanyFromAppointmentInput;
};

export type MutationUnassignTeamFromAppointment_V1Args = {
  input: UnassignTeamFromAppointmentInput;
};

export type MutationUnassignUserFromAppointment_V1Args = {
  input: UnassignUserFromAppointmentInput;
};

export type MutationUpdateTeam_V1Args = {
  input: UpdateTeamInput;
};

export type MutationUploadWorkOrderDocuments_V1Args = {
  input: UploadWorkOrderDocumentsInput;
};

export enum OutboundSyncErrorType {
  InvalidDriver = 'INVALID_DRIVER',
  InvalidDriverConfiguration = 'INVALID_DRIVER_CONFIGURATION',
  InvalidSourceExpression = 'INVALID_SOURCE_EXPRESSION',
  KeyColumnNotFound = 'KEY_COLUMN_NOT_FOUND',
  None = 'NONE',
  ValidationError = 'VALIDATION_ERROR',
  WorkflowDefinitionNotFound = 'WORKFLOW_DEFINITION_NOT_FOUND',
}

export type PageInput = {
  /** Specifies the page number to request. The first page starts at 0. If not specified, 0 is the default. */
  number?: InputMaybe<Scalars['Int']['input']>;
  /** Specifies the page size. The API will return that many items or less. Endpoint specific limits will cap this to a fixed number if too large. */
  size?: InputMaybe<Scalars['Int']['input']>;
};

export type PartnerCompanyPayloadModel = {
  __typename?: 'PartnerCompanyPayloadModel';
  /** Determines the unique identifier for this object. */
  id: Scalars['Int']['output'];
  /** Contains the name of the company. */
  name?: Maybe<Scalars['String']['output']>;
};

export type PatchAppointmentCompositeInput = {
  /** The unique identifier of appointment. */
  appointmentId: Scalars['Int']['input'];
  /** Update a branch office to assign it to the team. The specified branch office must exist. */
  branchOfficeId?: InputMaybe<Scalars['Int']['input']>;
  /** Update the comment regarding this appointment. */
  comment?: InputMaybe<Scalars['String']['input']>;
  /**
   * Update the end date and time of this appointment in UTC. Must be greater than or
   * equal to 'StartAtUtc', if specified.
   */
  endAtUtc?: InputMaybe<Scalars['DateTime']['input']>;
  /** Update if the appointment is binding or not. */
  isBinding?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update multiple partner companies to assign them to the appointment. The specified companies must exist. */
  partnerCompanyIdsToAssign?: InputMaybe<Array<Scalars['Long']['input']>>;
  /** Update multiple partner companies to unassign them from the appointment. The specified companies must exist. */
  partnerCompanyIdsToUnassign?: InputMaybe<Array<Scalars['Long']['input']>>;
  /**
   * Update the start date and time of this appointment in UTC. Must be less or equal to
   * 'EndAtUtc'.
   */
  startAtUtc?: InputMaybe<Scalars['DateTime']['input']>;
  /** Update a possibly multi-line string to display on the mobile app before the appointment gets started. Can be empty. */
  startScreenInformation?: InputMaybe<Scalars['String']['input']>;
  /** Update a team to assign it to the appointment. The specified team must exist. */
  teamIdToAssign?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** Update a team to unassign it from the appointment. The specified team must exist. */
  teamIdToUnassign?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** Update multiple users to assign them to the appointment. The specified users must exist. */
  userIdsToAssign?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** Update multiple users to unassign them from the appointment. The specified users must exist. */
  userIdsToUnassign?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type PatchAppointmentInput = {
  /** The unique identifier of appointment. */
  appointmentId: Scalars['Int']['input'];
  /** Update a branch office to assign it to the team. The specified branch office must exist. */
  branchOfficeId?: InputMaybe<Scalars['Int']['input']>;
  /** Update the comment regarding this appointment. */
  comment?: InputMaybe<Scalars['String']['input']>;
  /**
   * Update the end date and time of this appointment in UTC. Must be greater than or
   * equal to 'StartAtUtc', if specified.
   */
  endAtUtc?: InputMaybe<Scalars['DateTime']['input']>;
  /** Update if the appointment is binding or not. */
  isBinding?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * Update the start date and time of this appointment in UTC. Must be less or equal to
   * 'EndAtUtc'.
   */
  startAtUtc?: InputMaybe<Scalars['DateTime']['input']>;
  /** Update a possibly multi-line string to display on the mobile app before the appointment gets started. Can be empty. */
  startScreenInformation?: InputMaybe<Scalars['String']['input']>;
};

export type PatchBlockerInput = {
  /** The unique identifier of the blocker. */
  blockerId: Scalars['Int']['input'];
  /** The branch office ID associated with the blocker. */
  branchOfficeId?: InputMaybe<Scalars['Int']['input']>;
  /** An optional comment for the blocker. */
  comment?: InputMaybe<Scalars['String']['input']>;
  /** The end date of the blocker. */
  endAtUtc: Scalars['DateTime']['input'];
  /** The partner company ID associated with the blocker. */
  partnerCompanyId?: InputMaybe<Scalars['Int']['input']>;
  /** The unique identifier of the blocker reason. */
  reasonId: Scalars['Int']['input'];
  /** The start date of the blocker. */
  startAtUtc: Scalars['DateTime']['input'];
  /** The team ID associated with the blocker. */
  teamId?: InputMaybe<Scalars['Int']['input']>;
  /** The user ID associated with the blocker. */
  userId?: InputMaybe<Scalars['Int']['input']>;
};

export type PatchCustomerInput = {
  /** The delivery address of this customer, only used if we are creating a new customer. */
  deliveryAddress?: InputMaybe<AddressInput>;
  /** The email of this customer. */
  eMail?: InputMaybe<Scalars['String']['input']>;
  /** The first name of this customer. */
  firstName?: InputMaybe<Scalars['String']['input']>;
  /** The primary key of the customer. */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** The invoice address of this customer, only used if we are creating a new customer. */
  invoiceAddress?: InputMaybe<AddressInput>;
  /** The last name of this customer. */
  lastName?: InputMaybe<Scalars['String']['input']>;
  /** The mobile phone number of this customer. */
  mobilePhoneNumber?: InputMaybe<Scalars['String']['input']>;
  /** The name of this customer. */
  name: Scalars['String']['input'];
  /** The phone number of this customer. */
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  /** The salutation to be used for this customer. */
  salutation: Salutation;
};

export type PatchCustomerPayloadModel = {
  __typename?: 'PatchCustomerPayloadModel';
  /** Contains the current delivery address used for this customer. */
  currentDeliveryAddress?: Maybe<AddressPayloadModel>;
  /** Contains the current invoice address used for this customer. */
  currentInvoiceAddress?: Maybe<AddressPayloadModel>;
  /** Contains the email of the customer or null if not set. */
  eMail?: Maybe<Scalars['String']['output']>;
  /** Contains the firstname of the customer or null if not set. Most likely null if customer is a company. */
  firstName?: Maybe<Scalars['String']['output']>;
  /** Determines the unique identifier for this object. */
  id: Scalars['Int']['output'];
  /** Contains the lastname of the customer or null if not set. Most likely null if customer is a company. */
  lastName?: Maybe<Scalars['String']['output']>;
  /** Contains the mobile phone number of the customer or null if not set. */
  mobilePhoneNumber?: Maybe<Scalars['String']['output']>;
  /** Contains the name of the customer or null if not set. Can be a company name or firstname + lastname if private person. */
  name?: Maybe<Scalars['String']['output']>;
  /** Contains the phone number of the customer or null if not set. */
  phoneNumber?: Maybe<Scalars['String']['output']>;
  /** Contains the powercloud id of the customer or null if not set. */
  powerCloudId?: Maybe<Scalars['String']['output']>;
  /** Contains the salutation to be used for this customer. */
  salutation: Salutation;
};

export enum PatchFieldValueResultType {
  Success = 'SUCCESS',
  ValidationError = 'VALIDATION_ERROR',
}

export type PatchOutboundSyncColumnInput = {
  /** The name of the column in the target system. */
  column: Scalars['String']['input'];
  /**
   * A workflow expression that, when evaluated, yields the
   *  value to be written into the target system column.
   */
  expr: Scalars['String']['input'];
  /**
   * Sets this column to active or inactive. Inactive columns
   *  are excempt from synchronization.
   */
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PatchOutboundSyncDriverInput = {
  /**
   * The type specific configuration object. Must be a JSON
   *  string. Content depends on the type of driver.
   */
  configuration?: InputMaybe<Scalars['String']['input']>;
  /** The type of the driver to use. */
  type: Scalars['String']['input'];
};

export type PatchOutboundSyncInput = {
  /**
   * A list of columns to synchronize for this outbound synchronization. There must be at
   * least one column defined.
   */
  columns?: InputMaybe<Array<PatchOutboundSyncColumnInput>>;
  /** The driver to use and its configuration. */
  driver: PatchOutboundSyncDriverInput;
  /** Set to true if the synchronization should be scheduled or set to false if not. */
  isActive: Scalars['Boolean']['input'];
  /**
   * Gets or sets the name of the key column. If set, a column with that name must also
   *  exist in the Columns list. If set, the system will overwrite a row in the target system when the
   *  value in this column matches the with the source column.
   */
  keyColumn?: InputMaybe<Scalars['String']['input']>;
  /** The name of the outbound synchronization configuration object. */
  name: Scalars['String']['input'];
  /** The amount of days how long to keep log messages. */
  retainingPeriod: Scalars['Int']['input'];
  /**
   * A list of configured triggers for this outbound synchronization. There must be at
   * least one trigger defined.
   */
  triggers: Array<PatchOutboundSyncTriggerInput>;
};

export type PatchOutboundSyncPayloadModel = {
  __typename?: 'PatchOutboundSyncPayloadModel';
  /** Determines the point in time when this object has been created. This is in UTC. */
  createdAtUtc?: Maybe<Scalars['DateTime']['output']>;
  /** The type of driver used for this synchronization object. */
  driver: Scalars['String']['output'];
  /** The driver specific configuration object. Contains a JSON structure that depends on the driver. */
  driverConfiguration?: Maybe<Scalars['String']['output']>;
  /** Determines the unique identifier for this object. */
  id: Scalars['GraphQLLong']['output'];
  /** Determines if this outbound synchronization object is being considered for synchronization or not. */
  isActive: Scalars['Boolean']['output'];
  /** Determines the point in time when this object has been last modified or null if never has been modified. This is in UTC. */
  modifiedAtUtc?: Maybe<Scalars['DateTime']['output']>;
  /** The name of this outbound synchronization object. */
  name: Scalars['String']['output'];
  /** The amount of time (in days) to keep log messages generated during synchronization runs. */
  retainingPeriod: Scalars['Int']['output'];
};

export type PatchOutboundSyncTriggerInput =
  | { workflowEnd: PatchOutboundSyncTriggerWorkflowEndInput; workflowValuePushed?: never }
  | { workflowEnd?: never; workflowValuePushed: PatchOutboundSyncTriggerWorkflowValuePushedInput };

export type PatchOutboundSyncTriggerWorkflowEndInput = {
  workflowDefinition?: InputMaybe<Scalars['String']['input']>;
};

export type PatchOutboundSyncTriggerWorkflowValuePushedInput = {
  workflowDefinition?: InputMaybe<Scalars['String']['input']>;
};

export type PatchProductFolderLayoutFolderInput = {
  /** A list of folders that are supposed to be created for this product folder layout. Each element in that list can have child folders. */
  folders?: InputMaybe<Array<PatchProductFolderLayoutFolderInput>>;
  /** Indicates whether this folder is restricted so that only special roles can upload or overwrite files in it. */
  isRestricted: Scalars['Boolean']['input'];
  /** An optional name of a Monday.com field that will recieve this folder's primary key once a work order is created that uses this folder. */
  mondayFieldNameForFolderId?: InputMaybe<Scalars['String']['input']>;
  /** The name of the folder. Must not be empty. There cannot be two folders with the same name and parent. Naming is case insensitive. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** An optional list of workflow definition names. Craftspeople executing any of these workflows can see the files in this folder. */
  workflowDefinitions?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type PatchProductFolderLayoutInput = {
  /** A list of folders that are supposed to be created for this product folder layout. Each element in that list can have child folders. */
  folders?: InputMaybe<Array<PatchProductFolderLayoutFolderInput>>;
  /** The name of the product for which to update the folder layout. Note that 'product' and 'serviceProvider' are both mandatory properties. */
  product?: InputMaybe<Scalars['String']['input']>;
  /** The name of the service provider for which to update the folder layout. Note that 'product' and 'serviceProvider' are both mandatory properties. */
  serviceProvider?: InputMaybe<Scalars['String']['input']>;
};

export type PostAppointmentInput = {
  /** Optionally sets the branch office responsible for the appointment. */
  branchOfficeId?: InputMaybe<Scalars['Int']['input']>;
  /** Sets an internal comment regarding this appointment. */
  comment?: InputMaybe<Scalars['String']['input']>;
  /** Allow decide whether a new workflow definition instance should be created for an appointment. By default the old one is reused (if exists) for AC-Montagetermin, DC-Montagetermin, their extended versions and VOT-Termin. */
  createNewWorkflowDefinitionInstance?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * Sets the end date and time of this appointment in UTC. Must be greater than or
   * equal to 'StartAtUtc', if specified.
   */
  endAtUtc: Scalars['DateTime']['input'];
  /** Sets if the appointment is binding or not. Default: false */
  isBinding?: InputMaybe<Scalars['Boolean']['input']>;
  /** Optionally sets multiple partner companies to assign it to the team. The specified companies must exist. */
  partnerCompanyIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  /**
   * Sets the start date and time of this appointment in UTC. Must be less or equal to
   * 'EndAtUtc'.
   */
  startAtUtc: Scalars['DateTime']['input'];
  /** Sets a possibly multi-line string to display on the mobile app before the appointment gets started. Can be empty. */
  startScreenInformation?: InputMaybe<Scalars['String']['input']>;
  /**
   * Optionally sets multiple teams that should perform the appointment. If set, all members of
   * the teams will also be added to the appointment. The specified teams must exist.
   */
  teamIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  /**
   * Optionally sets multiple users that should perform the appointment. If the user
   * has already been added to the appointment through 'TeamIds' they will not be added twice. The specified users
   * must exist
   */
  userIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  /**
   * Sets the primary key of the work order this appointment must be assigned to.
   * Must not be 0 or negative. The specified work order must exist and not be deleted.
   */
  workOrderId: Scalars['Int']['input'];
  /**
   * Sets the primary key of the workflow definition to be used for this appointment.
   * Must not be 0 or negative. The specified workflow definition must exist.
   */
  workflowDefinitionId: Scalars['Int']['input'];
};

export type PostBlockerInput = {
  /** The branch office ID associated with the blocker. */
  branchOfficeId?: InputMaybe<Scalars['Int']['input']>;
  /** An optional comment for the blocker. */
  comment?: InputMaybe<Scalars['String']['input']>;
  /** The end date of the blocker. */
  endAtUtc: Scalars['DateTime']['input'];
  /** The partner company ID associated with the blocker. */
  partnerCompanyId?: InputMaybe<Scalars['Int']['input']>;
  /** The unique identifier of the blocker reason. */
  reasonId: Scalars['Int']['input'];
  /** The start date of the blocker. */
  startAtUtc: Scalars['DateTime']['input'];
  /** The team ID associated with the blocker. */
  teamId?: InputMaybe<Scalars['Int']['input']>;
  /** The user ID associated with the blocker. */
  userId?: InputMaybe<Scalars['Int']['input']>;
};

export type ProblemDetailsOfAppointmentErrorType = {
  __typename?: 'ProblemDetailsOfAppointmentErrorType';
  invalidParams?: Maybe<Array<InvalidParam>>;
  title: Scalars['String']['output'];
  type: AppointmentErrorType;
};

export type ProblemDetailsOfBlockerErrorType = {
  __typename?: 'ProblemDetailsOfBlockerErrorType';
  invalidParams?: Maybe<Array<InvalidParam>>;
  title: Scalars['String']['output'];
  type: BlockerErrorType;
};

export type ProblemDetailsOfBranchOfficeErrorType = {
  __typename?: 'ProblemDetailsOfBranchOfficeErrorType';
  invalidParams?: Maybe<Array<InvalidParam>>;
  title: Scalars['String']['output'];
  type: BranchOfficeErrorType;
};

export type ProblemDetailsOfCalendarItemErrorType = {
  __typename?: 'ProblemDetailsOfCalendarItemErrorType';
  invalidParams?: Maybe<Array<InvalidParam>>;
  title: Scalars['String']['output'];
  type: CalendarItemErrorType;
};

export type ProblemDetailsOfCraftCompanyErrorType = {
  __typename?: 'ProblemDetailsOfCraftCompanyErrorType';
  invalidParams?: Maybe<Array<InvalidParam>>;
  title: Scalars['String']['output'];
  type: CraftCompanyErrorType;
};

export type ProblemDetailsOfCustomerErrorType = {
  __typename?: 'ProblemDetailsOfCustomerErrorType';
  invalidParams?: Maybe<Array<InvalidParam>>;
  title: Scalars['String']['output'];
  type: CustomerErrorType;
};

export type ProblemDetailsOfDecideFieldValueEntryErrorType = {
  __typename?: 'ProblemDetailsOfDecideFieldValueEntryErrorType';
  invalidParams?: Maybe<Array<InvalidParam>>;
  title: Scalars['String']['output'];
  type: DecideFieldValueEntryErrorType;
};

export type ProblemDetailsOfDeviceErrorType = {
  __typename?: 'ProblemDetailsOfDeviceErrorType';
  invalidParams?: Maybe<Array<InvalidParam>>;
  title: Scalars['String']['output'];
  type: DeviceErrorType;
};

export type ProblemDetailsOfFieldValueErrorType = {
  __typename?: 'ProblemDetailsOfFieldValueErrorType';
  invalidParams?: Maybe<Array<InvalidParam>>;
  title: Scalars['String']['output'];
  type: FieldValueErrorType;
};

export type ProblemDetailsOfFileErrorType = {
  __typename?: 'ProblemDetailsOfFileErrorType';
  invalidParams?: Maybe<Array<InvalidParam>>;
  title: Scalars['String']['output'];
  type: FileErrorType;
};

export type ProblemDetailsOfGenerateSignedUrlForFileErrorType = {
  __typename?: 'ProblemDetailsOfGenerateSignedUrlForFileErrorType';
  invalidParams?: Maybe<Array<InvalidParam>>;
  title: Scalars['String']['output'];
  type: GenerateSignedUrlForFileErrorType;
};

export type ProblemDetailsOfGenerateUploadSignedUrlsForWorkOrderErrorType = {
  __typename?: 'ProblemDetailsOfGenerateUploadSignedUrlsForWorkOrderErrorType';
  invalidParams?: Maybe<Array<InvalidParam>>;
  title: Scalars['String']['output'];
  type: GenerateUploadSignedUrlsForWorkOrderErrorType;
};

export type ProblemDetailsOfJobErrorType = {
  __typename?: 'ProblemDetailsOfJobErrorType';
  invalidParams?: Maybe<Array<InvalidParam>>;
  title: Scalars['String']['output'];
  type: JobErrorType;
};

export type ProblemDetailsOfOutboundSyncErrorType = {
  __typename?: 'ProblemDetailsOfOutboundSyncErrorType';
  invalidParams?: Maybe<Array<InvalidParam>>;
  title: Scalars['String']['output'];
  type: OutboundSyncErrorType;
};

export type ProblemDetailsOfProductFolderLayoutErrorType = {
  __typename?: 'ProblemDetailsOfProductFolderLayoutErrorType';
  invalidParams?: Maybe<Array<InvalidParam>>;
  title: Scalars['String']['output'];
  type: ProductFolderLayoutErrorType;
};

export type ProblemDetailsOfRoleErrorType = {
  __typename?: 'ProblemDetailsOfRoleErrorType';
  invalidParams?: Maybe<Array<InvalidParam>>;
  title: Scalars['String']['output'];
  type: RoleErrorType;
};

export type ProblemDetailsOfTeamErrorType = {
  __typename?: 'ProblemDetailsOfTeamErrorType';
  invalidParams?: Maybe<Array<InvalidParam>>;
  title: Scalars['String']['output'];
  type: TeamErrorType;
};

export type ProblemDetailsOfUserErrorType = {
  __typename?: 'ProblemDetailsOfUserErrorType';
  invalidParams?: Maybe<Array<InvalidParam>>;
  title: Scalars['String']['output'];
  type: UserErrorType;
};

export type ProblemDetailsOfWorkCategoryErrorType = {
  __typename?: 'ProblemDetailsOfWorkCategoryErrorType';
  invalidParams?: Maybe<Array<InvalidParam>>;
  title: Scalars['String']['output'];
  type: WorkCategoryErrorType;
};

export type ProblemDetailsOfWorkGroupErrorType = {
  __typename?: 'ProblemDetailsOfWorkGroupErrorType';
  invalidParams?: Maybe<Array<InvalidParam>>;
  title: Scalars['String']['output'];
  type: WorkGroupErrorType;
};

export type ProblemDetailsOfWorkItemErrorType = {
  __typename?: 'ProblemDetailsOfWorkItemErrorType';
  invalidParams?: Maybe<Array<InvalidParam>>;
  title: Scalars['String']['output'];
  type: WorkItemErrorType;
};

export type ProblemDetailsOfWorkOrderErrorType = {
  __typename?: 'ProblemDetailsOfWorkOrderErrorType';
  invalidParams?: Maybe<Array<InvalidParam>>;
  title: Scalars['String']['output'];
  type: WorkOrderErrorType;
};

export type ProblemDetailsOfWorkflowDefinitionErrorType = {
  __typename?: 'ProblemDetailsOfWorkflowDefinitionErrorType';
  invalidParams?: Maybe<Array<InvalidParam>>;
  title: Scalars['String']['output'];
  type: WorkflowDefinitionErrorType;
};

export type ProblemDetailsOfWorkflowDefinitionVersionErrorType = {
  __typename?: 'ProblemDetailsOfWorkflowDefinitionVersionErrorType';
  invalidParams?: Maybe<Array<InvalidParam>>;
  title: Scalars['String']['output'];
  type: WorkflowDefinitionVersionErrorType;
};

export type ProblemDetailsOfWorkflowDefinitionsIncludingBlockerReasonsErrorType = {
  __typename?: 'ProblemDetailsOfWorkflowDefinitionsIncludingBlockerReasonsErrorType';
  invalidParams?: Maybe<Array<InvalidParam>>;
  title: Scalars['String']['output'];
  type: WorkflowDefinitionsIncludingBlockerReasonsErrorType;
};

export enum ProductFolderLayoutErrorType {
  None = 'NONE',
  ProductNotFound = 'PRODUCT_NOT_FOUND',
  ServiceProviderNotFound = 'SERVICE_PROVIDER_NOT_FOUND',
  ValidationError = 'VALIDATION_ERROR',
  WorkflowDefinitionNotFound = 'WORKFLOW_DEFINITION_NOT_FOUND',
}

export type ProductPayloadModel = {
  __typename?: 'ProductPayloadModel';
  /** Determines the unique identifier for this object. */
  id: Scalars['Int']['output'];
  /** Contains the name of the product. */
  name?: Maybe<Scalars['String']['output']>;
};

export type PullWorkOrderInput = {
  reason: Scalars['String']['input'];
  workOrderId: Scalars['Int']['input'];
};

export type PullWorkOrderPayloadModel = {
  __typename?: 'PullWorkOrderPayloadModel';
  /** Contains the name of the customer or null if not set. Can be a company name or firstname + lastname if private person. */
  approvalState: ApprovalState;
  /** Contains the point in time when this tuple has been created. */
  createdAtUtc?: Maybe<Scalars['DateTime']['output']>;
  /** Determines the eaasId for this object. */
  eaasId?: Maybe<Scalars['String']['output']>;
  /** Determines the unique identifier for this object. */
  id: Scalars['Int']['output'];
  /** Contains the point in time when this tuple has been modified last or null if it has never been modified. */
  modifiedAtUtc?: Maybe<Scalars['DateTime']['output']>;
  /** Contains the name of the work order. */
  name?: Maybe<Scalars['String']['output']>;
  /** Gets the number of blocking values that have been submitted below this node. Blocking values prevent craftspeople from continuing their work. */
  numberOfBlockedFields: Scalars['Int']['output'];
  /** Contains the number of re-submitted field values entries within this work order. */
  numberOfResubmitted: Scalars['Int']['output'];
  /** Contains the number of newly submitted field values entries within this work order. */
  numberOfSubmitted: Scalars['Int']['output'];
  /** Determines the quality manager. */
  qualityManager?: Maybe<UserPayloadModel>;
};

export type PushFieldValuesFieldValuePayloadModel = {
  __typename?: 'PushFieldValuesFieldValuePayloadModel';
  /**
   * Contains the last value of this field. This either represents the just
   * submitted value (on success) or the value it had before (on failure) or null if the field does not
   * yet have a value.
   */
  fieldValueEntry?: Maybe<FieldValueEntryPayloadModel>;
  /** Contains details for the uploaded files. */
  fileInfo?: Maybe<Array<UploadedFileInfo>>;
  /** Declares, if this field value has been successfully stored in the database. */
  result: PatchFieldValueResultType;
  /**
   * Contains the validation error messages for the field to which data
   * was pushed or null if the push was successful.
   */
  validationErrorMessages?: Maybe<Array<Scalars['String']['output']>>;
};

export type PushFieldValuesInput = {
  /** The Id of the apointment that the update is getting made for. */
  appointmentId: Scalars['Int']['input'];
  /** Additional notes for workitems. */
  comment?: InputMaybe<Scalars['String']['input']>;
  /** The dictionary holding the Names of the fields and their uploadIds. */
  fileUploadIds?: InputMaybe<Array<KeyValuePairOfStringAndInt32__Input>>;
  /** @deprecated Deprecated: use fileUploadIds */
  fileUrls?: InputMaybe<Array<KeyValuePairOfStringAndString__Input>>;
  /** The dictionary holding the Names of the fields for which the file upload is being done with the new . */
  files?: InputMaybe<Array<KeyValuePairOfStringAndIFile__Input>>;
  /** The dictionary holding the Names of the fields for which the upsert is being done with the new values in the dictionary values. */
  values?: InputMaybe<Array<KeyValuePairOfStringAndStringInput>>;
};

export type Query = {
  __typename?: 'Query';
  /**
   * Query to get the workforce assigned to this appointment. It will returns a collection of teams and individually assigned users.
   *         Ref:André Varela. Query Status: $Done
   */
  getAppointmentWorkforce_V1: GetSingleResponsePayloadOfGetAppointmentWorkforcePayloadModelAndAppointmentErrorType;
  /**
   * Query to get an appointment assigned to one craftsperson or their team by Id.
   *         Ref:Adrian Buda. Query Status: $Done
   */
  getAppointment_V1: GetSingleResponsePayloadOfGetAppointmentPayloadModelAndAppointmentErrorType;
  /**
   * Query to get all the appointments that are assigned to one craftsperson.
   *
   * Sortable columns:
   * * Id
   * * Name
   * * Status
   * * StartAtUtc
   * * EndAtUtc
   *
   * Ref:Adrian Buda. Query Status:$Done
   */
  getAppointments_V1: GetManyPagedResponsePayloadOfGetAppointmentsAppointmentPayloadModelAndAppointmentErrorType;
  /**
   * Query to get a blocker by Id.
   *         Ref:Reza Gholam Shazari. Query Status: $Done
   */
  getBlocker_V1: GetSingleResponsePayloadOfBlockerCalendarItemPayloadModelAndBlockerErrorType;
  /**
   * This endpoint returns a list of branch offices. It supports paging, sorting and filtering.
   *
   * Sortable columns:
   * * Name
   * * ServiceProvider
   * * Id
   *
   * Ref:André Varela - Status:Done
   */
  getBranchOffices_V1: GetManyPagedResponsePayloadOfGetBranchOfficesPayloadModelAndBranchOfficeErrorType;
  /**
   * Query to get all calendar items optionally filtered by multiple criteria.
   *
   * The returned list is always sorted by start date (asc) and end date (asc).
   *
   * Ref:Enrico Neidt. Query Status:$Potential Changes
   */
  getCalendarItems_V1: GetManyPagedResponsePayloadOfICalendarItemPayloadModelAndCalendarItemErrorType;
  /**
   * Query to fetch a list of craft companies with pagination and sorting.
   *
   * Supported inputs:
   * - Search: Filters by company name.
   * - Number: Page to retrieve.
   * - Size: Number of items per page.
   * - OrderBy: Sorting columns and directions.
   *
   * Sortable columns:
   * * Id
   * * Name
   *
   * Ref:Reza Gholam Shazari - Status:Done
   */
  getCraftCompanies_V1: GetManyPagedResponsePayloadOfCraftCompanyPayloadModelAndCraftCompanyErrorType;
  /**
   * Query to get the Field Values related to an appointment.
   *
   * The provided appointment must be in one of the STARTED, DONE or ABORTED states. The caller must
   * be assigned to the appointment either directly or indirectly through a team.
   *
   * Please note that not all FieldValue entries returned from this endpoint have to have FieldValuEntries
   * associated with them. If no user ever submitted a FieldValueEntry, the Values array would remain empty.
   *
   * Ref:Enrico Neidt
   */
  getFieldValuesByAppointment_V1: GetManyResponsePayloadOfGetFieldValuesByAppointmentFieldValuePayloadModelAndFieldValueErrorType;
  /**
   * Query to get all field values alongside with work category id and work category name for given work order id.
   * Ref: Mateusz Redynk
   */
  getFieldValuesByWorkOrder_V1: GetManyResponsePayloadOfGetFieldValuesByWorkOrderPayloadModelAndFieldValueErrorType;
  /**
   * Query to get information about a previously started asynchronous job.
   *
   * Use this endpoint to request the status of a previously scheduled job.
   *
   * Author: Enrico Neidt
   */
  getJob_V1: GetSingleResponsePayloadOfJobPayloadModelAndJobErrorType;
  /**
   * Query to get return a list of roles.
   *
   * This endpoint returns a list of roles. It supports paging and sorting.
   *
   * Sortable columns:
   * * Id
   * * Name
   *
   * Ref:Enrico Neidt - Status:Done
   */
  getRoles_V1: GetManyPagedResponsePayloadOfGetRolesRolePayloadModelAndRoleErrorType;
  /**
   * This endpoint returns a list of teams. It supports paging, sorting and filtering.
   *
   *     Sortable columns:
   *     * Name
   *
   *     Ref:André Varela - Status:Done
   */
  getTeams_V1: GetManyPagedResponsePayloadOfGetTeamsPayloadModelAndTeamErrorType;
  /**
   * Query to get information about any user.
   *
   * This endpoint allows to return basic information regarding a specified user. Set the id of that user
   * into UserId. The user must exist. If the requested user id is NULL, information
   * about the user invoking the endpoint (you) is returned.
   *
   * Author: Sebastian Inones
   * Sortable columns: none
   * Filterable columns: none
   * Pagable: no
   */
  getUser_V1: GetSingleResponsePayloadOfGetUserUserPayloadModelAndUserErrorType;
  /**
   * Query to get return a list of users.
   *
   * This endpoint returns a list of users. It supports paging, sorting and filtering.
   *
   * Sortable columns:
   * * Id
   * * LastName
   * * FirstName
   * * EMail
   *
   * Ref:Sebastian Inones - Status:Not Ready
   */
  getUsers_V1: GetManyResponsePayloadOfGetUsersUserPayloadModelAndUserErrorType;
  /**
   * Query to get work categories.
   *
   * Author: Reza Gholam Shazari
   */
  getWorkCategories_V1: GetManyPagedNodeResponsePayloadOfGetWorkCategoryWorkCategoryPayloadModelAndWorkCategoryErrorType;
  /** Query to get the work category by id. Ref: André Varela */
  getWorkCategory_V1: GetSingleResponsePayloadOfGetWorkCategoryWorkCategoryPayloadModelAndWorkCategoryErrorType;
  /** Query to get the work group by id with all work items related. Ref: André Varela */
  getWorkGroup_V1: GetSingleResponsePayloadOfGetWorkGroupPayloadModelAndWorkGroupErrorType;
  /**
   * Query to get all field values including their entries for a specific work item.
   *
   * Specify the work item by its ID. If the user has the 'Quality Manager' all work items can be requested. If the
   * user is a 'Craftsperson' the user must be a member of the associated Appointment other wise 'NotFound' is returned.
   *
   * The endpoint returns all FieldValues associated with that work item. Usually, this is exactly one FieldValue but that
   * is up to the workflow designer.
   *
   * Be prepared that work items may have NO FieldValue associated with them. This may happen when a designer
   * creates a work item that is empty or only has static text on it. In the latter case the endpoint still returns
   * one element with its FieldValue set to null but its AcceptanceCriteria set to a non-null value.
   * As a result, be prepared that FieldValue is null. Another constellation might be that a work item consists
   * of a TextField, StaticField and another TextField. In this case this endpoint returns 3 elements. You
   * may chose to ignore the elements that have null as FieldValue.
   *
   * If an AcceptanceCriteria object is returned, at least one of its properties is not null. Be prepared
   * that at any time, any of these properties might be null. This is up to the workflow designer.
   *
   * AcceptanceCriteria are only returned when requested.
   *
   * If you need the full field history (all values) you can also specify that in the request. This information
   * is not paged.
   *
   * IMPORTANT:
   * ==========
   *
   * FieldValueEntry.Value is a string. The whole story is more complex as this is an escaped JSON string. For
   * example, if the value is of a multi-select text field, it might be ["value1", "value2"]. If the value
   * is a simple string it would be "some_string". For images and signatures the value is an object
   * with the corresponding properties. Note that only text and image fields can be arrays. Here an example
   * for images:
   * [{url:"http://..."},{url:"http://..."}]
   *
   * Ref: Enrico Neidt
   */
  getWorkItemFieldValues_V1: GetManyResponsePayloadOfGetWorkItemFieldValuesPayloadModelAndFieldValueErrorType;
  /**
   * Query to get the work items.
   *
   * Returns a list of work items that satisfy the provided filter criteria.
   *
   * Sortable columns:
   *     * Id
   *     * ApprovalState
   *     * ModifiedAtUtc
   *     * SubmittedBy
   *     * Name
   *
   * Ref: André Varela
   */
  getWorkItems_V1: GetManyPagedNodeResponsePayloadOfGetWorkItemsWorkItemPayloadModelAndWorkItemErrorType;
  /**
   * Query to get appointments of a specific work order.
   *
   * Author: Enrico Neidt
   */
  getWorkOrderAppointments_V1: GetManyPagedResponsePayloadOfGetWorkOrderAppointmentsPayloadModelAndAppointmentErrorType;
  /**
   * Query to get folders and/or files associated with a specified work order.
   *
   * Use the various input properties to control the behavior of this endpoint. It can be used to return all data
   * in one go or selectively only return a subset of the data depending on what input properties are set.
   *
   * Note that - depending on the request parameters - this endpoint may return the root folder for this work order.
   * The root folder is the only folder that does not have a parent ID and it's name is always '<root>'. UI should
   * hide this folder. It merely acts as a container for folders. It may contain files.
   *
   * Author: Enrico Neidt
   */
  getWorkOrderFiles_V1: GetManyResponsePayloadOfGetWorkOrderFilesPayloadModelAndWorkOrderErrorType;
  /**
   * Query to get the status of a specific work order.
   *
   * This method is returning the work order with all the work categories, all the work groups and all the work items inside.
   *
   * Author: André Varela
   */
  getWorkOrderStatus_V1: GetSingleResponsePayloadOfGetWorkOrderStatusPayloadModelAndWorkOrderErrorType;
  /**
   * Query to get work order by id.
   *
   * Work order are one of the main building blocks of the application. A work order translates to 'go there and build something'.
   *
   * Author: Ricardo Santos
   */
  getWorkOrder_V1: GetSingleResponsePayloadOfGetWorkOrderPayloadModelAndWorkOrderErrorType;
  /**
   * Query to get work orders.
   *
   * Work order are one of the main building blocks of the application. A work order translates to 'go there and build something'.
   *
   * The result set can be filtered by:
   *     - Id
   *     - Name
   *     - ModifiedAtUtc
   *     - ApprovalState
   *     - NumberOfIssues
   *     - NumberOfSubmitted
   *     - NumberOfResubmitted
   *
   * Author: André Varela
   */
  getWorkOrders_V1: GetManyPagedNodeResponsePayloadOfGetWorkOrdersWorkOrderPayloadModelAndWorkOrderErrorType;
  /**
   * Query to get appointments of a specific workflow definition instance.
   *
   * Author: Mateusz Redynk
   */
  getWorkflowDefinitionInstanceAppointments_V1: GetManyPagedResponsePayloadOfGetWorkflowDefinitionInstanceAppointmentsPayloadModelAndAppointmentErrorType;
  /** Query to get the workflow definition current version by template definition Id. Ref:Sebastian Inones */
  getWorkflowDefinitionVersion_V1: GetSingleResponsePayloadOfGetWorkflowDefinitionVersionPayloadModelAndWorkflowDefinitionVersionErrorType;
  /**
   * Query to get workflow definitions composite data.
   *
   * Returns a composite object containing:
   * - WorkflowDefinitions: All workflow definitions.
   * - AppointmentTypes: Workflow definitions that are not tied to blocker reasons.
   * - BlockerReasons: All blocker reasons.
   *
   * This query is used when creating blockers or appointments to ensure correct association between data.
   *
   * Ref: Reza Gholam Shazari
   */
  getWorkflowDefinitionsComposite_V1: GetSingleResponsePayloadOfWorkflowDefinitionsCompositePayloadModelAndWorkflowDefinitionsIncludingBlockerReasonsErrorType;
  /**
   * Query to get workflow definitions.
   *
   * Returns a list of workflow definitions. Mostly used by workflow editors.
   *
   * Sortable columns:
   *     * Id
   *     * Name
   *
   * Ref: Enrico Neidt
   */
  getWorkflowDefinitions_V1: GetManyPagedResponsePayloadOfGetWorkflowDefinitionsWorkflowDefinitionPayloadModelAndWorkflowDefinitionErrorType;
};

export type QueryGetAppointmentWorkforce_V1Args = {
  input: GetAppointmentWorkforceInput;
};

export type QueryGetAppointment_V1Args = {
  input: GetAppointmentInput;
};

export type QueryGetAppointments_V1Args = {
  input?: InputMaybe<GetAppointmentsInput>;
};

export type QueryGetBlocker_V1Args = {
  input: GetBlockerInput;
};

export type QueryGetBranchOffices_V1Args = {
  input?: InputMaybe<GetBranchOfficesInput>;
};

export type QueryGetCalendarItems_V1Args = {
  input?: InputMaybe<GetCalendarItemsInput>;
};

export type QueryGetCraftCompanies_V1Args = {
  input?: InputMaybe<GetCraftCompaniesInput>;
};

export type QueryGetFieldValuesByAppointment_V1Args = {
  input: GetFieldValuesByAppointmentInput;
};

export type QueryGetFieldValuesByWorkOrder_V1Args = {
  input: GetFieldValuesByWorkOrderInput;
};

export type QueryGetJob_V1Args = {
  input?: InputMaybe<GetJobInput>;
};

export type QueryGetRoles_V1Args = {
  input?: InputMaybe<GetRolesInput>;
};

export type QueryGetTeams_V1Args = {
  input?: InputMaybe<GetTeamsInput>;
};

export type QueryGetUser_V1Args = {
  input?: InputMaybe<GetUserInput>;
};

export type QueryGetUsers_V1Args = {
  input?: InputMaybe<GetUsersInput>;
};

export type QueryGetWorkCategories_V1Args = {
  input?: InputMaybe<GetWorkCategoriesInput>;
};

export type QueryGetWorkCategory_V1Args = {
  input: GetWorkCategoryInput;
};

export type QueryGetWorkGroup_V1Args = {
  input: GetWorkGroupInput;
};

export type QueryGetWorkItemFieldValues_V1Args = {
  input: GetWorkItemFieldValuesInput;
};

export type QueryGetWorkItems_V1Args = {
  input?: InputMaybe<GetWorkItemsInput>;
};

export type QueryGetWorkOrderAppointments_V1Args = {
  input?: InputMaybe<GetWorkOrderAppointmentsInput>;
};

export type QueryGetWorkOrderFiles_V1Args = {
  input?: InputMaybe<GetWorkOrderFilesInput>;
};

export type QueryGetWorkOrderStatus_V1Args = {
  input: GetWorkOrderStatusInput;
};

export type QueryGetWorkOrder_V1Args = {
  input: GetWorkOrderInput;
};

export type QueryGetWorkOrders_V1Args = {
  input?: InputMaybe<GetWorkOrdersInput>;
};

export type QueryGetWorkflowDefinitionInstanceAppointments_V1Args = {
  input?: InputMaybe<GetWorkflowDefinitionInstanceAppointmentsInput>;
};

export type QueryGetWorkflowDefinitionVersion_V1Args = {
  input: GetWorkflowDefinitionVersionInput;
};

export type QueryGetWorkflowDefinitions_V1Args = {
  input?: InputMaybe<GetWorkflowDefinitionsInput>;
};

export type ReopenAppointmentInput = {
  appointmentId: Scalars['Int']['input'];
};

export enum RoleErrorType {
  None = 'NONE',
  ValidationError = 'VALIDATION_ERROR',
}

export type RolePayloadModel = {
  __typename?: 'RolePayloadModel';
  /** Determines the unique identifier for this object. */
  id: Scalars['Int']['output'];
  /** Contains the name of the role. */
  name?: Maybe<Scalars['String']['output']>;
};

export enum Salutation {
  Female = 'FEMALE',
  Male = 'MALE',
  Unspecified = 'UNSPECIFIED',
}

export type ScheduleAppointmentInput = {
  appointmentId: Scalars['Int']['input'];
  endAtUtc?: InputMaybe<Scalars['DateTime']['input']>;
  isBinding?: InputMaybe<Scalars['Boolean']['input']>;
  startAtUtc?: InputMaybe<Scalars['DateTime']['input']>;
};

export type ServiceProviderPayloadModel = {
  __typename?: 'ServiceProviderPayloadModel';
  /** Determines the unique identifier for this object. */
  id: Scalars['Int']['output'];
  /** Gets the name of this service provider. */
  name?: Maybe<Scalars['String']['output']>;
};

export type SkillPayloadModel = {
  __typename?: 'SkillPayloadModel';
  /** Determines the unique identifier for this object. */
  id: Scalars['Int']['output'];
  /** Determines the Workflow Definition related to this entity, if any. */
  workflowDefinition?: Maybe<WorkflowDefinitionPayloadModel>;
};

export type SortDescriptionInput = {
  /** The direction to sort by. Default is Ascending. */
  direction?: InputMaybe<ListSortDirection>;
  /** The name of the property to sort by. Case sensitive. */
  property?: InputMaybe<Scalars['String']['input']>;
};

export type StartAppointmentAppointmentPayloadModel = {
  __typename?: 'StartAppointmentAppointmentPayloadModel';
  /** Contains the workflow definition version for this appointment. This cannot change. Is only set after the appointment has started. */
  code?: Maybe<Scalars['String']['output']>;
  /** The end date of the appointment. */
  endDateUtc?: Maybe<Scalars['DateTime']['output']>;
  /** The expected duration of this appointment. */
  expectedDuration?: Maybe<Scalars['TimeSpan']['output']>;
  /** Determines the unique identifier for this object. */
  id: Scalars['Int']['output'];
  /** The start date of the appointment. */
  startDateUtc?: Maybe<Scalars['DateTime']['output']>;
  /** Contains a text that is supposed to be displayed on the start-screen of the appointment before it is started. */
  startScreenInformation?: Maybe<Scalars['String']['output']>;
  /** The status of this appointment. */
  status?: Maybe<AppointmentStatus>;
  /** The type of this appointment. */
  type?: Maybe<Scalars['String']['output']>;
};

export type StartAppointmentInput = {
  appointmentId: Scalars['Int']['input'];
};

export enum TeamErrorType {
  BranchOfficeNotFound = 'BRANCH_OFFICE_NOT_FOUND',
  Failed = 'FAILED',
  MembersNotFound = 'MEMBERS_NOT_FOUND',
  None = 'NONE',
  TeamConfigurationAlreadyExists = 'TEAM_CONFIGURATION_ALREADY_EXISTS',
  TeamNotFound = 'TEAM_NOT_FOUND',
  UserNotFound = 'USER_NOT_FOUND',
  ValidationError = 'VALIDATION_ERROR',
  WorkflowDefinitionsNotFound = 'WORKFLOW_DEFINITIONS_NOT_FOUND',
}

export type TeamPayloadModel = {
  __typename?: 'TeamPayloadModel';
  /** Determines the unique identifier for this object. */
  id: Scalars['Int']['output'];
  /** Whether this entity is deleted or not. */
  isDeleted?: Maybe<Scalars['Boolean']['output']>;
  /** Contains the name of the team. */
  name?: Maybe<Scalars['String']['output']>;
};

export type UnassignCraftCompanyFromAppointmentInput = {
  appointmentId: Scalars['Int']['input'];
  partnerCompanyIds: Array<Scalars['Long']['input']>;
};

/** This input receives the ID of the appointment and the ID of the team id. */
export type UnassignTeamFromAppointmentInput = {
  /** Property that indicates the ID of the appointment. */
  appointmentId: Scalars['Int']['input'];
  /** Property that indicates the ID of the team. */
  teamId: Scalars['Int']['input'];
};

/** This input receives the ID of the appointment and the ID of the user id. */
export type UnassignUserFromAppointmentInput = {
  /** Property that indicates the ID of the appointment. */
  appointmentId: Scalars['Int']['input'];
  /** Property that indicates the ID of the user. */
  userId: Scalars['Int']['input'];
};

export type UpdateTeamInput = {
  /** The branch office id related with this entity. */
  branchOfficeId: Scalars['Int']['input'];
  /** Property that indicates the ID of the team. */
  id: Scalars['Int']['input'];
  /** The members ids related with this entity. */
  memberIds: Array<Scalars['Int']['input']>;
  /** The name of this team. */
  name: Scalars['String']['input'];
  /** The workflow definitions ids related with this entity. */
  workflowDefinitionIds: Array<Scalars['Int']['input']>;
};

export type UpdateTeamPayloadModel = {
  __typename?: 'UpdateTeamPayloadModel';
  /** Determines the branch office related to this entity, if any. */
  branchOffice?: Maybe<BranchOfficePayloadModel>;
  /** Determines the unique identifier for this object. */
  id: Scalars['Int']['output'];
  /** Whether this entity is deleted or not. */
  isDeleted: Scalars['Boolean']['output'];
  /** Determines the members related to this entity, if any. */
  members?: Maybe<Array<UserPayloadModel>>;
  /** Contains the name of the team. */
  name?: Maybe<Scalars['String']['output']>;
  /** Determines the skills related to this entity, if any. */
  skills?: Maybe<Array<SkillPayloadModel>>;
};

export type UploadWorkOrderDocumentsInput = {
  /** The bits of the file(s). */
  files?: InputMaybe<Array<Scalars['Upload']['input']>>;
  /** The ID of the folder to put the file(s) into. If not specified, the work orders root folder is used. The folder must be part of that work order. */
  folderId?: InputMaybe<Scalars['Int']['input']>;
  /** The work order the file(s) should be assigned to. */
  workOrderId: Scalars['Int']['input'];
};

export type UploadedFileInfo = {
  __typename?: 'UploadedFileInfo';
  fileName: Scalars['String']['output'];
  fileSize: Scalars['Long']['output'];
  mimeType: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export enum UserErrorType {
  CraftsPeopleNotFound = 'CRAFTS_PEOPLE_NOT_FOUND',
  Failed = 'FAILED',
  None = 'NONE',
  NotFound = 'NOT_FOUND',
  NoTeam = 'NO_TEAM',
  ValidationError = 'VALIDATION_ERROR',
}

export type UserPayloadModel = {
  __typename?: 'UserPayloadModel';
  /** Determines the e-mail address of the user. */
  eMail?: Maybe<Scalars['String']['output']>;
  /** Determines the firstname of the user. */
  firstName?: Maybe<Scalars['String']['output']>;
  /** Determines the unique identifier for this object. */
  id: Scalars['Int']['output'];
  /** Whether this entity is deleted or not. */
  isDeleted?: Maybe<Scalars['Boolean']['output']>;
  /** Determines the lastname of the user. */
  lastName?: Maybe<Scalars['String']['output']>;
};

export type ValidationError = {
  __typename?: 'ValidationError';
  extensions?: Maybe<Scalars['JSON']['output']>;
  message: Scalars['String']['output'];
  path?: Maybe<Array<Scalars['String']['output']>>;
};

export enum ValueType {
  Boolean = 'BOOLEAN',
  DateTime = 'DATE_TIME',
  Float = 'FLOAT',
  Image = 'IMAGE',
  Integer = 'INTEGER',
  Signature = 'SIGNATURE',
  Text = 'TEXT',
  Unknown = 'UNKNOWN',
  Video = 'VIDEO',
}

export enum WorkCategoryErrorType {
  Failed = 'FAILED',
  None = 'NONE',
  NotFound = 'NOT_FOUND',
  ValidationError = 'VALIDATION_ERROR',
}

export type WorkCategoryPayloadModel = {
  __typename?: 'WorkCategoryPayloadModel';
  /** Contains the name of the customer or null if not set. Can be a company name or firstname + lastname if private person. */
  approvalState: ApprovalState;
  /** Contains the point in time when this tuple has been created. */
  createdAtUtc?: Maybe<Scalars['DateTime']['output']>;
  /** Determines the unique identifier for this object. */
  id: Scalars['Int']['output'];
  /** Contains the point in time when this tuple has been modified last or null if it has never been modified. */
  modifiedAtUtc?: Maybe<Scalars['DateTime']['output']>;
  /** Contains the name of the work order. */
  name?: Maybe<Scalars['String']['output']>;
  /** Gets the number of blocking values that have been submitted below this node. Blocking values prevent craftspeople from continuing their work. */
  numberOfBlockedFields: Scalars['Int']['output'];
  /** Contains the number of re-submitted field values entries within this work order. */
  numberOfResubmitted: Scalars['Int']['output'];
  /** Contains the number of newly submitted field values entries within this work order. */
  numberOfSubmitted: Scalars['Int']['output'];
};

export enum WorkGroupErrorType {
  Failed = 'FAILED',
  None = 'NONE',
  NotFound = 'NOT_FOUND',
  ValidationError = 'VALIDATION_ERROR',
}

export type WorkGroupPayloadModel = {
  __typename?: 'WorkGroupPayloadModel';
  /** Contains the name of the customer or null if not set. Can be a company name or firstname + lastname if private person. */
  approvalState: ApprovalState;
  /** Contains the point in time when this tuple has been created. */
  createdAtUtc?: Maybe<Scalars['DateTime']['output']>;
  /** Determines the unique identifier for this object. */
  id: Scalars['Int']['output'];
  /** Contains the point in time when this tuple has been modified last or null if it has never been modified. */
  modifiedAtUtc?: Maybe<Scalars['DateTime']['output']>;
  /** Contains the name of the work order. */
  name?: Maybe<Scalars['String']['output']>;
  /** Gets the number of blocking values that have been submitted below this node. Blocking values prevent craftspeople from continuing their work. */
  numberOfBlockedFields: Scalars['Int']['output'];
  /** Contains the number of re-submitted field values entries within this work order. */
  numberOfResubmitted: Scalars['Int']['output'];
  /** Contains the number of newly submitted field values entries within this work order. */
  numberOfSubmitted: Scalars['Int']['output'];
};

export type WorkGroupWithFieldValuesPayloadModel = {
  __typename?: 'WorkGroupWithFieldValuesPayloadModel';
  /** Contains the FieldValues with their entries (or entry). */
  fieldValues?: Maybe<Array<GetFieldValuesByWorkOrderFieldValuePayloadModel>>;
  workGroupId: Scalars['Int']['output'];
  workGroupName: Scalars['String']['output'];
};

export enum WorkItemErrorType {
  Failed = 'FAILED',
  None = 'NONE',
  ValidationError = 'VALIDATION_ERROR',
  WorkItemsNotFound = 'WORK_ITEMS_NOT_FOUND',
}

export type WorkItemPayloadModel = {
  __typename?: 'WorkItemPayloadModel';
  /** Contains the name of the customer or null if not set. Can be a company name or firstname + lastname if private person. */
  approvalState: ApprovalState;
  /** Contains the point in time when this tuple has been created. */
  createdAtUtc?: Maybe<Scalars['DateTime']['output']>;
  /** Determines the unique identifier for this object. */
  id: Scalars['Long']['output'];
  /** Contains the point in time when this tuple has been modified last or null if it has never been modified. */
  modifiedAtUtc?: Maybe<Scalars['DateTime']['output']>;
  /** Contains the name of the work order. */
  name?: Maybe<Scalars['String']['output']>;
  /** Gets the number of blocking values that have been submitted below this node. Blocking values prevent craftspeople from continuing their work. */
  numberOfBlockedFields: Scalars['Int']['output'];
  /** Contains the number of re-submitted field values entries within this work order. */
  numberOfResubmitted: Scalars['Int']['output'];
  /** Contains the number of newly submitted field values entries within this work order. */
  numberOfSubmitted: Scalars['Int']['output'];
};

export type WorkOrderCustomerPayloadModelOfCustomerPayloadModel = {
  __typename?: 'WorkOrderCustomerPayloadModelOfCustomerPayloadModel';
  /** Contains the customer. */
  customer?: Maybe<CustomerPayloadModel>;
  /** Determines the unique identifier for this object. */
  id: Scalars['GraphQLLong']['output'];
};

export enum WorkOrderErrorType {
  AlreadyClosed = 'ALREADY_CLOSED',
  Failed = 'FAILED',
  None = 'NONE',
  NotFound = 'NOT_FOUND',
  ValidationError = 'VALIDATION_ERROR',
}

export type WorkOrderPayloadModel = {
  __typename?: 'WorkOrderPayloadModel';
  /** Contains the name of the customer or null if not set. Can be a company name or firstname + lastname if private person. */
  approvalState: ApprovalState;
  /** Contains the point in time when this tuple has been created. */
  createdAtUtc?: Maybe<Scalars['DateTime']['output']>;
  /** Determines the eaasId for this object. */
  eaasId?: Maybe<Scalars['String']['output']>;
  /** Determines the unique identifier for this object. */
  id: Scalars['Int']['output'];
  /** Contains the point in time when this tuple has been modified last or null if it has never been modified. */
  modifiedAtUtc?: Maybe<Scalars['DateTime']['output']>;
  /** Contains the name of the work order. */
  name?: Maybe<Scalars['String']['output']>;
  /** Gets the number of blocking values that have been submitted below this node. Blocking values prevent craftspeople from continuing their work. */
  numberOfBlockedFields: Scalars['Int']['output'];
  /** Contains the number of re-submitted field values entries within this work order. */
  numberOfResubmitted: Scalars['Int']['output'];
  /** Contains the number of newly submitted field values entries within this work order. */
  numberOfSubmitted: Scalars['Int']['output'];
};

export enum WorkOrderStatus {
  Commisioning = 'COMMISIONING',
  ConstructionFinished = 'CONSTRUCTION_FINISHED',
  Coordination = 'COORDINATION',
  DigitalerVot = 'DIGITALER_VOT',
  Finished = 'FINISHED',
  Montage = 'MONTAGE',
  SettingElectricityMeter = 'SETTING_ELECTRICITY_METER',
  TechnicalCommisioning = 'TECHNICAL_COMMISIONING',
  UnknownStatus = 'UNKNOWN_STATUS',
  VotCoordination = 'VOT_COORDINATION',
  VotDocumentation = 'VOT_DOCUMENTATION',
}

export enum WorkflowDefinitionErrorType {
  FieldNotFound = 'FIELD_NOT_FOUND',
  None = 'NONE',
  SelectionListNotFound = 'SELECTION_LIST_NOT_FOUND',
  SyntaxError = 'SYNTAX_ERROR',
  ValidationError = 'VALIDATION_ERROR',
}

export type WorkflowDefinitionPayloadModel = {
  __typename?: 'WorkflowDefinitionPayloadModel';
  /** Determines the unique identifier for this object. */
  id: Scalars['Int']['output'];
  /** Determines the unique identifier for this object. */
  name?: Maybe<Scalars['String']['output']>;
};

export enum WorkflowDefinitionVersionErrorType {
  Failed = 'FAILED',
  None = 'NONE',
  NotFound = 'NOT_FOUND',
  ValidationError = 'VALIDATION_ERROR',
}

export type WorkflowDefinitionVersionPayloadModel = {
  __typename?: 'WorkflowDefinitionVersionPayloadModel';
  /** Determines the point in time when this object has been created. This is in UTC. */
  createdAtUtc?: Maybe<Scalars['DateTime']['output']>;
  /** Determines the unique identifier for this object. */
  id: Scalars['Int']['output'];
};

export type WorkflowDefinitionsCompositePayloadModel = {
  __typename?: 'WorkflowDefinitionsCompositePayloadModel';
  /** The list of appointment types. */
  appointmentTypes?: Maybe<Array<AppointmentTypePayloadModel>>;
  /** The list of blocker reasons. */
  blockerReasons?: Maybe<Array<BlockerReasonPayloadModel>>;
  /** The list of workflow definitions. */
  workflowDefinitions?: Maybe<Array<WorkflowDefinitionPayloadModel>>;
};

export enum WorkflowDefinitionsIncludingBlockerReasonsErrorType {
  None = 'NONE',
  ValidationError = 'VALIDATION_ERROR',
}

export type GetAppointments_V1QueryVariables = Exact<{
  notBeforeUtc?: InputMaybe<Scalars['DateTime']['input']>;
  notAfterUtc?: InputMaybe<Scalars['DateTime']['input']>;
  branch?: InputMaybe<Scalars['Int']['input']>;
  team?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  appointmentType?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  page?: InputMaybe<PageInput>;
  orderBy?: InputMaybe<Array<SortDescriptionInput> | SortDescriptionInput>;
}>;

export type GetAppointments_V1Query = {
  __typename?: 'Query';
  getAppointments_V1: {
    __typename?: 'GetManyPagedResponsePayloadOfGetAppointmentsAppointmentPayloadModelAndAppointmentErrorType';
    totalItems: number;
    error: AppointmentErrorType;
    data?: Array<{
      __typename?: 'GetAppointmentsAppointmentPayloadModel';
      id: number;
      type?: string | null;
      status?: AppointmentStatus | null;
      startDateUtc?: any | null;
      endDateUtc?: any | null;
      expectedDuration?: any | null;
      startScreenInformation?: string | null;
      isBinding: boolean;
      constructedByTeams?: Array<{
        __typename?: 'AppointmentConstructionTeamPayloadModel';
        id: number;
        team?: { __typename?: 'TeamPayloadModel'; id: number; name?: string | null } | null;
      }> | null;
      constructedByCraftsmen?: Array<{
        __typename?: 'AppointmentConstructionCraftsmenPayloadModel';
        id: number;
        craftsman?: {
          __typename?: 'UserPayloadModel';
          id: number;
          firstName?: string | null;
          lastName?: string | null;
        } | null;
      }> | null;
      workOrder?: {
        __typename?: 'GetAppointmentsWorkOrderPayloadModel';
        id: number;
        eaasId?: string | null;
        name?: string | null;
        approvalState: ApprovalState;
        numberOfSubmitted: number;
        numberOfResubmitted: number;
        modifiedAtUtc?: any | null;
        readOnlyAddress?: {
          __typename?: 'AddressPayloadModel';
          id: number;
          isReadOnly: boolean;
          street?: string | null;
          number?: string | null;
          zipCode?: string | null;
          city?: string | null;
        } | null;
      } | null;
    }> | null;
  };
};

export type UnassignUserFromAppointmentMutationVariables = Exact<{
  appointmentId: Scalars['Int']['input'];
  userId: Scalars['Int']['input'];
}>;

export type UnassignUserFromAppointmentMutation = {
  __typename?: 'Mutation';
  unassignUserFromAppointment_V1: {
    __typename?: 'GetNoItemResponsePayloadOfAppointmentErrorType';
    error: AppointmentErrorType;
  };
};

export type GetAppointmentWorkforce_V1QueryVariables = Exact<{
  appointmentId: Scalars['Int']['input'];
}>;

export type GetAppointmentWorkforce_V1Query = {
  __typename?: 'Query';
  getAppointmentWorkforce_V1: {
    __typename?: 'GetSingleResponsePayloadOfGetAppointmentWorkforcePayloadModelAndAppointmentErrorType';
    error: AppointmentErrorType;
    data?: {
      __typename?: 'GetAppointmentWorkforcePayloadModel';
      craftsmen?: Array<{
        __typename?: 'GetAppointmentWorkforceUserPayloadModel';
        id: number;
        eMail?: string | null;
        firstName?: string | null;
        lastName?: string | null;
        defaultTeamId?: number | null;
      }> | null;
      teams?: Array<{
        __typename?: 'GetAppointmentWorkforceTeamPayloadModel';
        id: number;
        name?: string | null;
        branchOffice?: { __typename?: 'BranchOfficePayloadModel'; id: number; name?: string | null } | null;
      }> | null;
    } | null;
  };
};

export type AttachUserToAppointment_V1MutationVariables = Exact<{
  appointmentId: Scalars['Int']['input'];
  userIds: Array<Scalars['Int']['input']> | Scalars['Int']['input'];
}>;

export type AttachUserToAppointment_V1Mutation = {
  __typename?: 'Mutation';
  attachUserToAppointment_V1: {
    __typename?: 'GetSingleResponsePayloadOfAttachUserToAppointmentPayloadModelAndAppointmentErrorType';
    error: AppointmentErrorType;
    data?: {
      __typename?: 'AttachUserToAppointmentPayloadModel';
      assignments: Array<{
        __typename?: 'AttachUserToAppointmentAssignmentPayloadModel';
        userId: number;
        assignment: boolean;
      }>;
    } | null;
  };
};

export type AttachTeamToAppointment_V1MutationVariables = Exact<{
  input: AttachTeamToAppointmentInput;
}>;

export type AttachTeamToAppointment_V1Mutation = {
  __typename?: 'Mutation';
  attachTeamToAppointment_V1: {
    __typename?: 'GetSingleResponsePayloadOfAttachTeamToAppointmentPayloadModelAndAppointmentErrorType';
    error: AppointmentErrorType;
    data?: {
      __typename?: 'AttachTeamToAppointmentPayloadModel';
      users?: Array<{ __typename?: 'UserPayloadModel'; id: number }> | null;
    } | null;
  };
};

export type UnassignTeamFromAppointmentMutationVariables = Exact<{
  input: UnassignTeamFromAppointmentInput;
}>;

export type UnassignTeamFromAppointmentMutation = {
  __typename?: 'Mutation';
  unassignTeamFromAppointment_V1: {
    __typename?: 'GetNoItemResponsePayloadOfAppointmentErrorType';
    error: AppointmentErrorType;
  };
};

export type GetUsers_V1QueryVariables = Exact<{
  roleId?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<PageInput>;
}>;

export type GetUsers_V1Query = {
  __typename?: 'Query';
  getUsers_V1: {
    __typename?: 'GetManyResponsePayloadOfGetUsersUserPayloadModelAndUserErrorType';
    error: UserErrorType;
    data?: Array<{
      __typename?: 'GetUsersUserPayloadModel';
      jobTitle?: string | null;
      id: number;
      isDeleted: boolean;
      firstName?: string | null;
      lastName?: string | null;
      eMail?: string | null;
      roles?: Array<{ __typename?: 'RolePayloadModel'; id: number; name?: string | null }> | null;
      employer?: { __typename?: 'ServiceProviderPayloadModel'; name?: string | null; id: number } | null;
    }> | null;
  };
};

export type GetAppointment_V1QueryVariables = Exact<{
  input: GetAppointmentInput;
}>;

export type GetAppointment_V1Query = {
  __typename?: 'Query';
  getAppointment_V1: {
    __typename?: 'GetSingleResponsePayloadOfGetAppointmentPayloadModelAndAppointmentErrorType';
    error: AppointmentErrorType;
    data?: {
      __typename?: 'GetAppointmentPayloadModel';
      appointment?: {
        __typename?: 'GetAppointmentAppointmentPayloadModel';
        isBinding: boolean;
        comment?: string | null;
        id: number;
        type?: string | null;
        status?: AppointmentStatus | null;
        startDateUtc?: any | null;
        endDateUtc?: any | null;
        expectedDuration?: any | null;
        startScreenInformation?: string | null;
        workOrder?: {
          __typename?: 'GetAppointmentWorkOrderPayloadModel';
          id: number;
          eaasId?: string | null;
          name?: string | null;
        } | null;
        constructedByTeams?: Array<{
          __typename?: 'AppointmentConstructionTeamPayloadModel';
          id: number;
          team?: { __typename?: 'TeamPayloadModel'; id: number; name?: string | null } | null;
        }> | null;
        constructedByCraftsmen?: Array<{
          __typename?: 'AppointmentConstructionCraftsmenPayloadModel';
          id: number;
          craftsman?: {
            __typename?: 'UserPayloadModel';
            id: number;
            eMail?: string | null;
            firstName?: string | null;
            lastName?: string | null;
          } | null;
        }> | null;
        workflowDefinition?: { __typename?: 'WorkflowDefinitionPayloadModel'; id: number; name?: string | null } | null;
        branchOffice?: { __typename?: 'BranchOfficePayloadModel'; id: number } | null;
        partnerCompanies?: Array<{
          __typename?: 'PartnerCompanyPayloadModel';
          id: number;
          name?: string | null;
        }> | null;
      } | null;
    } | null;
  };
};

export type ScheduleAppointment_V1MutationVariables = Exact<{
  input: ScheduleAppointmentInput;
}>;

export type ScheduleAppointment_V1Mutation = {
  __typename?: 'Mutation';
  scheduleAppointment_V1: {
    __typename?: 'GetSingleResponsePayloadOfAppointmentPayloadModelAndAppointmentErrorType';
    error: AppointmentErrorType;
    data?: { __typename?: 'AppointmentPayloadModel'; id: number } | null;
  };
};

export type PostAppointment_V1MutationVariables = Exact<{
  input: PostAppointmentInput;
}>;

export type PostAppointment_V1Mutation = {
  __typename?: 'Mutation';
  postAppointment_V1: {
    __typename?: 'GetSingleResponsePayloadOfAppointmentCalendarItemPayloadModelAndAppointmentErrorType';
    error: AppointmentErrorType;
    data?: {
      __typename?: 'AppointmentCalendarItemPayloadModel';
      id: number;
      startAtUtc?: any | null;
      endAtUtc?: any | null;
      isBinding?: boolean | null;
      teams?: Array<{ __typename?: 'TeamPayloadModel'; id: number; name?: string | null }> | null;
      workOrder?: { __typename?: 'WorkOrderPayloadModel'; id: number; name?: string | null } | null;
      workflowDefinition?: { __typename?: 'WorkflowDefinitionPayloadModel'; id: number; name?: string | null } | null;
    } | null;
  };
};

export type PatchAppointmentComposite_V1MutationVariables = Exact<{
  input: PatchAppointmentCompositeInput;
}>;

export type PatchAppointmentComposite_V1Mutation = {
  __typename?: 'Mutation';
  patchAppointmentComposite_V1: {
    __typename?: 'GetNoItemResponsePayloadOfAppointmentErrorType';
    error: AppointmentErrorType;
  };
};

export type PostBlocker_V1MutationVariables = Exact<{
  input: PostBlockerInput;
}>;

export type PostBlocker_V1Mutation = {
  __typename?: 'Mutation';
  postBlocker_V1: {
    __typename?: 'GetSingleResponsePayloadOfBlockerCalendarItemPayloadModelAndBlockerErrorType';
    error: BlockerErrorType;
    data?: {
      __typename?: 'BlockerCalendarItemPayloadModel';
      id: number;
      startAtUtc?: any | null;
      endAtUtc?: any | null;
      reason?: { __typename?: 'BlockerReasonPayloadModel'; id: number; title?: string | null } | null;
    } | null;
  };
};

export type PatchBlocker_V1MutationVariables = Exact<{
  input: PatchBlockerInput;
}>;

export type PatchBlocker_V1Mutation = {
  __typename?: 'Mutation';
  patchBlocker_V1: {
    __typename?: 'GetSingleResponsePayloadOfBlockerCalendarItemPayloadModelAndBlockerErrorType';
    error: BlockerErrorType;
    data?: {
      __typename?: 'BlockerCalendarItemPayloadModel';
      id: number;
      startAtUtc?: any | null;
      endAtUtc?: any | null;
      reason?: { __typename?: 'BlockerReasonPayloadModel'; id: number; title?: string | null } | null;
    } | null;
  };
};

export type GetBlocker_V1QueryVariables = Exact<{
  input: GetBlockerInput;
}>;

export type GetBlocker_V1Query = {
  __typename?: 'Query';
  getBlocker_V1: {
    __typename?: 'GetSingleResponsePayloadOfBlockerCalendarItemPayloadModelAndBlockerErrorType';
    error: BlockerErrorType;
    data?: {
      __typename?: 'BlockerCalendarItemPayloadModel';
      comment?: string | null;
      endAtUtc?: any | null;
      id: number;
      startAtUtc?: any | null;
      branchOffice?: { __typename?: 'BranchOfficePayloadModel'; id: number } | null;
      reason?: { __typename?: 'BlockerReasonPayloadModel'; id: number; title?: string | null } | null;
      teams?: Array<{ __typename?: 'TeamPayloadModel'; id: number; name?: string | null }> | null;
      users?: Array<{
        __typename?: 'UserPayloadModel';
        id: number;
        firstName?: string | null;
        lastName?: string | null;
      }> | null;
      partnerCompanies?: Array<{ __typename?: 'PartnerCompanyPayloadModel'; id: number; name?: string | null }> | null;
    } | null;
  };
};

export type GetCalendarItems_V1QueryVariables = Exact<{
  input: GetCalendarItemsInput;
}>;

export type GetCalendarItems_V1Query = {
  __typename?: 'Query';
  getCalendarItems_V1: {
    __typename?: 'GetManyPagedResponsePayloadOfICalendarItemPayloadModelAndCalendarItemErrorType';
    totalItems: number;
    data?: Array<
      | {
          __typename?: 'AppointmentCalendarItemPayloadModel';
          startAtUtc?: any | null;
          endAtUtc?: any | null;
          id: number;
          isBinding?: boolean | null;
          teams?: Array<{ __typename?: 'TeamPayloadModel'; id: number; name?: string | null }> | null;
          users?: Array<{
            __typename?: 'UserPayloadModel';
            id: number;
            eMail?: string | null;
            firstName?: string | null;
            lastName?: string | null;
          }> | null;
          partnerCompanies?: Array<{
            __typename?: 'PartnerCompanyPayloadModel';
            id: number;
            name?: string | null;
          }> | null;
          workOrder?: {
            __typename?: 'WorkOrderPayloadModel';
            id: number;
            name?: string | null;
            approvalState: ApprovalState;
            numberOfSubmitted: number;
            numberOfResubmitted: number;
            modifiedAtUtc?: any | null;
            numberOfBlockedFields: number;
          } | null;
          workflowDefinition?: {
            __typename?: 'WorkflowDefinitionPayloadModel';
            id: number;
            name?: string | null;
          } | null;
          branchOffice?: { __typename?: 'BranchOfficePayloadModel'; id: number; name?: string | null } | null;
        }
      | {
          __typename?: 'BlockerCalendarItemPayloadModel';
          id: number;
          startAtUtc?: any | null;
          endAtUtc?: any | null;
          users?: Array<{
            __typename?: 'UserPayloadModel';
            id: number;
            eMail?: string | null;
            firstName?: string | null;
            lastName?: string | null;
          }> | null;
          teams?: Array<{ __typename?: 'TeamPayloadModel'; id: number; name?: string | null }> | null;
          reason?: { __typename?: 'BlockerReasonPayloadModel'; id: number; title?: string | null } | null;
          branchOffice?: { __typename?: 'BranchOfficePayloadModel'; id: number; name?: string | null } | null;
          partnerCompanies?: Array<{
            __typename?: 'PartnerCompanyPayloadModel';
            id: number;
            name?: string | null;
          }> | null;
        }
    > | null;
  };
};

export type GetCraftCompanies_V1QueryVariables = Exact<{
  input?: InputMaybe<GetCraftCompaniesInput>;
}>;

export type GetCraftCompanies_V1Query = {
  __typename?: 'Query';
  getCraftCompanies_V1: {
    __typename?: 'GetManyPagedResponsePayloadOfCraftCompanyPayloadModelAndCraftCompanyErrorType';
    totalItems: number;
    error: CraftCompanyErrorType;
    data?: Array<{ __typename?: 'CraftCompanyPayloadModel'; name?: string | null; id: number }> | null;
  };
};

export type GetWorkOrders_V1_PmQueryVariables = Exact<{
  input?: InputMaybe<GetWorkOrdersInput>;
}>;

export type GetWorkOrders_V1_PmQuery = {
  __typename?: 'Query';
  getWorkOrders_V1: {
    __typename?: 'GetManyPagedNodeResponsePayloadOfGetWorkOrdersWorkOrderPayloadModelAndWorkOrderErrorType';
    totalItems: number;
    data?: Array<{
      __typename?: 'GetWorkOrdersWorkOrderPayloadModel';
      id: number;
      eaasId?: string | null;
      modifiedAtUtc?: any | null;
      name?: string | null;
      paused: boolean;
      status: WorkOrderStatus;
      approvalState: ApprovalState;
      qualityManager?: {
        __typename?: 'UserPayloadModel';
        id: number;
        firstName?: string | null;
        lastName?: string | null;
      } | null;
      customers?: Array<{
        __typename?: 'WorkOrderCustomerPayloadModelOfCustomerPayloadModel';
        id: any;
        customer?: { __typename?: 'CustomerPayloadModel'; name?: string | null } | null;
      }> | null;
      branchOffice?: { __typename?: 'BranchOfficePayloadModel'; id: number; name?: string | null } | null;
      product?: { __typename?: 'ProductPayloadModel'; id: number; name?: string | null } | null;
    }> | null;
  };
};

export type DeleteAppointment_V1MutationVariables = Exact<{
  input: DeleteAppointmentInput;
}>;

export type DeleteAppointment_V1Mutation = {
  __typename?: 'Mutation';
  deleteAppointment_V1: { __typename?: 'GetNoItemResponsePayloadOfAppointmentErrorType'; error: AppointmentErrorType };
};

export type DeleteBlocker_V1MutationVariables = Exact<{
  input: DeleteBlockerInput;
}>;

export type DeleteBlocker_V1Mutation = {
  __typename?: 'Mutation';
  deleteBlocker_V1: { __typename?: 'GetNoItemResponsePayloadOfBlockerErrorType'; error: BlockerErrorType };
};

export type GetBranchesQueryVariables = Exact<{
  page?: InputMaybe<PageInput>;
}>;

export type GetBranchesQuery = {
  __typename?: 'Query';
  getBranchOffices_V1: {
    __typename?: 'GetManyPagedResponsePayloadOfGetBranchOfficesPayloadModelAndBranchOfficeErrorType';
    totalItems: number;
    error: BranchOfficeErrorType;
    data?: Array<{
      __typename?: 'GetBranchOfficesPayloadModel';
      id: number;
      isDeleted: boolean;
      name?: string | null;
    }> | null;
  };
};

export type GetWorkOrderFiles_V1QueryVariables = Exact<{
  input: GetWorkOrderFilesInput;
}>;

export type GetWorkOrderFiles_V1Query = {
  __typename?: 'Query';
  getWorkOrderFiles_V1: {
    __typename?: 'GetManyResponsePayloadOfGetWorkOrderFilesPayloadModelAndWorkOrderErrorType';
    error: WorkOrderErrorType;
    data?: Array<{
      __typename?: 'GetWorkOrderFilesPayloadModel';
      parentId?: number | null;
      id: number;
      name: string;
      files?: Array<{
        __typename?: 'GetWorkOrderFilesMediaPayloadModel';
        id: number;
        uri?: string | null;
        fileName?: string | null;
        mimeType?: string | null;
        fileSize?: any | null;
        isSafe: boolean;
        virusScanResult?: string | null;
        createdAtUtc?: any | null;
        createdBy?: {
          __typename?: 'UserPayloadModel';
          id: number;
          eMail?: string | null;
          firstName?: string | null;
          lastName?: string | null;
        } | null;
      }> | null;
    }> | null;
  };
};

export type GetRoles_V1QueryVariables = Exact<{ [key: string]: never }>;

export type GetRoles_V1Query = {
  __typename?: 'Query';
  getRoles_V1: {
    __typename?: 'GetManyPagedResponsePayloadOfGetRolesRolePayloadModelAndRoleErrorType';
    totalItems: number;
    error: RoleErrorType;
    data?: Array<{ __typename?: 'GetRolesRolePayloadModel'; id: number; name?: string | null }> | null;
  };
};

export type GetTeamsQueryVariables = Exact<{
  input?: InputMaybe<GetTeamsInput>;
}>;

export type GetTeamsQuery = {
  __typename?: 'Query';
  getTeams_V1: {
    __typename?: 'GetManyPagedResponsePayloadOfGetTeamsPayloadModelAndTeamErrorType';
    totalItems: number;
    error: TeamErrorType;
    data?: Array<{
      __typename?: 'GetTeamsPayloadModel';
      id: number;
      isDeleted: boolean;
      name?: string | null;
      branchOffice?: { __typename?: 'GetTeamsBranchOfficePayloadModel'; name?: string | null } | null;
    }> | null;
  };
};

export type GetTeams_V1QueryVariables = Exact<{
  input?: InputMaybe<GetTeamsInput>;
}>;

export type GetTeams_V1Query = {
  __typename?: 'Query';
  getTeams_V1: {
    __typename?: 'GetManyPagedResponsePayloadOfGetTeamsPayloadModelAndTeamErrorType';
    totalItems: number;
    error: TeamErrorType;
    data?: Array<{
      __typename?: 'GetTeamsPayloadModel';
      id: number;
      name?: string | null;
      isDeleted: boolean;
      branchOffice?: {
        __typename?: 'GetTeamsBranchOfficePayloadModel';
        id: number;
        name?: string | null;
        serviceProvider?: { __typename?: 'ServiceProviderPayloadModel'; id: number; name?: string | null } | null;
      } | null;
      skills?: Array<{
        __typename?: 'GetTeamsSkillPayloadModel';
        id: number;
        workflowDefinition?: { __typename?: 'WorkflowDefinitionPayloadModel'; id: number; name?: string | null } | null;
      }> | null;
      members?: Array<{
        __typename?: 'UserPayloadModel';
        id: number;
        firstName?: string | null;
        lastName?: string | null;
        eMail?: string | null;
      }> | null;
    }> | null;
  };
};

export type CreateTeam_V1MutationVariables = Exact<{
  input: CreateTeamInput;
}>;

export type CreateTeam_V1Mutation = {
  __typename?: 'Mutation';
  createTeam_V1: {
    __typename?: 'GetSingleResponsePayloadOfCreateTeamPayloadModelAndTeamErrorType';
    error: TeamErrorType;
    data?: {
      __typename?: 'CreateTeamPayloadModel';
      id: number;
      name?: string | null;
      branchOffice: { __typename?: 'BranchOfficePayloadModel'; id: number; name?: string | null };
      skills?: Array<{
        __typename?: 'SkillPayloadModel';
        id: number;
        workflowDefinition?: { __typename?: 'WorkflowDefinitionPayloadModel'; id: number; name?: string | null } | null;
      }> | null;
      members?: Array<{
        __typename?: 'UserPayloadModel';
        id: number;
        firstName?: string | null;
        lastName?: string | null;
        eMail?: string | null;
      }> | null;
    } | null;
  };
};

export type UpdateTeam_V1MutationVariables = Exact<{
  input: UpdateTeamInput;
}>;

export type UpdateTeam_V1Mutation = {
  __typename?: 'Mutation';
  updateTeam_V1: {
    __typename?: 'GetSingleResponsePayloadOfUpdateTeamPayloadModelAndTeamErrorType';
    error: TeamErrorType;
    data?: {
      __typename?: 'UpdateTeamPayloadModel';
      id: number;
      name?: string | null;
      branchOffice?: { __typename?: 'BranchOfficePayloadModel'; id: number; name?: string | null } | null;
      skills?: Array<{
        __typename?: 'SkillPayloadModel';
        id: number;
        workflowDefinition?: { __typename?: 'WorkflowDefinitionPayloadModel'; id: number; name?: string | null } | null;
      }> | null;
      members?: Array<{
        __typename?: 'UserPayloadModel';
        id: number;
        firstName?: string | null;
        lastName?: string | null;
        eMail?: string | null;
      }> | null;
    } | null;
  };
};

export type UploadWorkOrderDocuments_V1MutationVariables = Exact<{
  input: UploadWorkOrderDocumentsInput;
}>;

export type UploadWorkOrderDocuments_V1Mutation = {
  __typename?: 'Mutation';
  uploadWorkOrderDocuments_V1: {
    __typename?: 'GetManyResponsePayloadOfMediaPayloadModelAndFileErrorType';
    error: FileErrorType;
    data?: Array<{
      __typename?: 'MediaPayloadModel';
      id: number;
      uri?: string | null;
      fileName?: string | null;
      mimeType?: string | null;
      fileSize?: any | null;
      isSafe: boolean;
      virusScanResult?: string | null;
    }> | null;
  };
};

export type GetFieldValuesByWorkOrder_V1QueryVariables = Exact<{
  input: GetFieldValuesByWorkOrderInput;
}>;

export type GetFieldValuesByWorkOrder_V1Query = {
  __typename?: 'Query';
  getFieldValuesByWorkOrder_V1: {
    __typename?: 'GetManyResponsePayloadOfGetFieldValuesByWorkOrderPayloadModelAndFieldValueErrorType';
    error: FieldValueErrorType;
    data?: Array<{
      __typename?: 'GetFieldValuesByWorkOrderPayloadModel';
      type: string;
      workGroups?: Array<{
        __typename?: 'WorkGroupWithFieldValuesPayloadModel';
        workGroupId: number;
        workGroupName: string;
        fieldValues?: Array<{
          __typename?: 'GetFieldValuesByWorkOrderFieldValuePayloadModel';
          id: any;
          fieldName?: string | null;
          isApprovalRequired?: boolean | null;
          fieldDefinition?: {
            __typename?: 'GetWorkItemFieldValuesFieldDefinitionPayloadModel';
            id: number;
            name?: string | null;
          } | null;
          workItemInfo?: {
            __typename?: 'GetFieldValuesByWorkOrderWorkItemPayloadModel';
            id?: any | null;
            name?: string | null;
          } | null;
          values?: Array<{
            __typename?: 'FieldValueEntryPayloadModel';
            id: any;
            value?: string | null;
            type: ValueType;
            isArray: boolean;
            approvalState: ApprovalState;
            createdAtUtc?: any | null;
            lastSubmitAtUtc: any;
            decisionMadeAtUtc?: any | null;
            rejectReason?: string | null;
            createdBy?: {
              __typename?: 'UserPayloadModel';
              id: number;
              firstName?: string | null;
              lastName?: string | null;
            } | null;
            lastSubmitBy?: {
              __typename?: 'UserPayloadModel';
              id: number;
              firstName?: string | null;
              lastName?: string | null;
            } | null;
            decisionMadeBy?: {
              __typename?: 'UserPayloadModel';
              id: number;
              firstName?: string | null;
              lastName?: string | null;
            } | null;
          }> | null;
        }> | null;
      }> | null;
    }> | null;
  };
};

export type GetWorkflowDefinitions_V1QueryVariables = Exact<{ [key: string]: never }>;

export type GetWorkflowDefinitions_V1Query = {
  __typename?: 'Query';
  getWorkflowDefinitions_V1: {
    __typename?: 'GetManyPagedResponsePayloadOfGetWorkflowDefinitionsWorkflowDefinitionPayloadModelAndWorkflowDefinitionErrorType';
    totalItems: number;
    error: WorkflowDefinitionErrorType;
    data?: Array<{
      __typename?: 'GetWorkflowDefinitionsWorkflowDefinitionPayloadModel';
      id: number;
      name?: string | null;
    }> | null;
  };
};

export type GetWorkflowDefinitionsComposite_V1QueryVariables = Exact<{ [key: string]: never }>;

export type GetWorkflowDefinitionsComposite_V1Query = {
  __typename?: 'Query';
  getWorkflowDefinitionsComposite_V1: {
    __typename?: 'GetSingleResponsePayloadOfWorkflowDefinitionsCompositePayloadModelAndWorkflowDefinitionsIncludingBlockerReasonsErrorType';
    error: WorkflowDefinitionsIncludingBlockerReasonsErrorType;
    data?: {
      __typename?: 'WorkflowDefinitionsCompositePayloadModel';
      appointmentTypes?: Array<{ __typename?: 'AppointmentTypePayloadModel'; id: number; name?: string | null }> | null;
      blockerReasons?: Array<{ __typename?: 'BlockerReasonPayloadModel'; id: number; title?: string | null }> | null;
      workflowDefinitions?: Array<{
        __typename?: 'WorkflowDefinitionPayloadModel';
        id: number;
        name?: string | null;
      }> | null;
    } | null;
  };
};

export type DecideFieldValueEntry_V1MutationVariables = Exact<{
  input: DecideFieldValueEntryInput;
}>;

export type DecideFieldValueEntry_V1Mutation = {
  __typename?: 'Mutation';
  decideFieldValueEntry_V1: {
    __typename?: 'GetSingleResponsePayloadOfFieldValueEntryPayloadModelAndDecideFieldValueEntryErrorType';
    error: DecideFieldValueEntryErrorType;
    data?: { __typename?: 'FieldValueEntryPayloadModel'; id: any; approvalState: ApprovalState } | null;
  };
};

export type DecideFieldValueItems_V1MutationVariables = Exact<{
  input: DecideFieldValueItemsInput;
}>;

export type DecideFieldValueItems_V1Mutation = {
  __typename?: 'Mutation';
  decideFieldValueItems_V1: {
    __typename?: 'GetSingleResponsePayloadOfFieldValueEntryPayloadModelAndDecideFieldValueEntryErrorType';
    error: DecideFieldValueEntryErrorType;
    data?: { __typename?: 'FieldValueEntryPayloadModel'; id: any; approvalState: ApprovalState } | null;
  };
};

export type GetWorkItemFieldValues_V1QueryVariables = Exact<{
  input: GetWorkItemFieldValuesInput;
}>;

export type GetWorkItemFieldValues_V1Query = {
  __typename?: 'Query';
  getWorkItemFieldValues_V1: {
    __typename?: 'GetManyResponsePayloadOfGetWorkItemFieldValuesPayloadModelAndFieldValueErrorType';
    error: FieldValueErrorType;
    data?: Array<{
      __typename?: 'GetWorkItemFieldValuesPayloadModel';
      fieldValue?: {
        __typename?: 'GetWorkItemFieldValuesFieldValuePayloadModel';
        id: any;
        isApprovalRequired?: boolean | null;
        fieldDefinition?: {
          __typename?: 'GetWorkItemFieldValuesFieldDefinitionPayloadModel';
          id: number;
          name?: string | null;
        } | null;
        values?: Array<{
          __typename?: 'FieldValueEntryPayloadModel';
          id: any;
          createdAtUtc?: any | null;
          value?: string | null;
          approvalState: ApprovalState;
          comment?: string | null;
          decisionMadeAtUtc?: any | null;
          rejectReason?: string | null;
          isArray: boolean;
          type: ValueType;
          lastSubmitAtUtc: any;
          itemDecisions?: Array<{
            __typename?: 'FieldValueEntryItemDecisionPayload';
            approvalState: ApprovalState;
            arrayIndex: number;
            decisionMadeAtUtc?: any | null;
            decisionMadeById?: number | null;
            mediaId?: number | null;
            rejectReason?: string | null;
          }> | null;
          decisionMadeBy?: {
            __typename?: 'UserPayloadModel';
            id: number;
            eMail?: string | null;
            firstName?: string | null;
            lastName?: string | null;
          } | null;
          lastSubmitBy?: {
            __typename?: 'UserPayloadModel';
            id: number;
            eMail?: string | null;
            firstName?: string | null;
            lastName?: string | null;
          } | null;
          createdBy?: {
            __typename?: 'UserPayloadModel';
            id: number;
            eMail?: string | null;
            firstName?: string | null;
            lastName?: string | null;
          } | null;
        }> | null;
      } | null;
      acceptanceCriteria?: {
        __typename?: 'FieldAcceptanceCriteriaPayloadModel';
        title?: string | null;
        headline?: string | null;
        description?: string | null;
        bulletPoints?: Array<string> | null;
        exampleImages?: Array<{ __typename?: 'ExampleImagePayloadModel'; imageUrl?: string | null }> | null;
      } | null;
    }> | null;
  };
};

export type GenerateAppointmentReport_V1MutationVariables = Exact<{
  input: GenerateAppointmentReportInput;
}>;

export type GenerateAppointmentReport_V1Mutation = {
  __typename?: 'Mutation';
  generateAppointmentReport_V1: {
    __typename?: 'GetSingleResponsePayloadOfJobPayloadModelAndAppointmentErrorType';
    error: AppointmentErrorType;
    data?: {
      __typename?: 'JobPayloadModel';
      id?: string | null;
      state?: string | null;
      results?: Array<{ __typename?: 'KeyValuePairOfStringAndString'; key: string; value: string }> | null;
    } | null;
  };
};

export type GenerateZipAppointmentPictures_V1MutationVariables = Exact<{
  input: GenerateZipAppointmentPicturesInput;
}>;

export type GenerateZipAppointmentPictures_V1Mutation = {
  __typename?: 'Mutation';
  generateZipAppointmentPictures_V1: {
    __typename?: 'GetSingleResponsePayloadOfJobPayloadModelAndAppointmentErrorType';
    error: AppointmentErrorType;
    data?: {
      __typename?: 'JobPayloadModel';
      id?: string | null;
      state?: string | null;
      results?: Array<{ __typename?: 'KeyValuePairOfStringAndString'; key: string; value: string }> | null;
    } | null;
  };
};

export type GetJob_V1QueryVariables = Exact<{
  input: GetJobInput;
}>;

export type GetJob_V1Query = {
  __typename?: 'Query';
  getJob_V1: {
    __typename?: 'GetSingleResponsePayloadOfJobPayloadModelAndJobErrorType';
    error: JobErrorType;
    data?: {
      __typename?: 'JobPayloadModel';
      id?: string | null;
      state?: string | null;
      results?: Array<{ __typename?: 'KeyValuePairOfStringAndString'; key: string; value: string }> | null;
    } | null;
  };
};

export type GetWorkGroup_V1QueryVariables = Exact<{
  input: GetWorkGroupInput;
}>;

export type GetWorkGroup_V1Query = {
  __typename?: 'Query';
  getWorkGroup_V1: {
    __typename?: 'GetSingleResponsePayloadOfGetWorkGroupPayloadModelAndWorkGroupErrorType';
    error: WorkGroupErrorType;
    data?: {
      __typename?: 'GetWorkGroupPayloadModel';
      id: number;
      name?: string | null;
      approvalState: ApprovalState;
      items?: Array<{
        __typename?: 'GetWorkItemWorkGroupPayloadModel';
        id: any;
        name?: string | null;
        approvalState: ApprovalState;
        modifiedAtUtc?: any | null;
      }> | null;
      workCategory?: { __typename?: 'GetWorkGroupWorkCategoryPayloadModel'; id: number; name?: string | null } | null;
    } | null;
  };
};

export type GetWorkItems_V1QueryVariables = Exact<{
  page?: InputMaybe<PageInput>;
  orderBy?: InputMaybe<Array<SortDescriptionInput> | SortDescriptionInput>;
  states?: InputMaybe<Array<ApprovalState> | ApprovalState>;
  startDateUtc?: InputMaybe<Scalars['DateTime']['input']>;
  endDateUtc?: InputMaybe<Scalars['DateTime']['input']>;
  qualityManagerId?: InputMaybe<Scalars['Int']['input']>;
  workOrderId?: InputMaybe<Scalars['Int']['input']>;
  workCategoryNames?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;

export type GetWorkItems_V1Query = {
  __typename?: 'Query';
  getWorkItems_V1: {
    __typename?: 'GetManyPagedNodeResponsePayloadOfGetWorkItemsWorkItemPayloadModelAndWorkItemErrorType';
    totalNumberOfSubmitted?: number | null;
    totalNumberOfResubmitted?: number | null;
    totalItems: number;
    data?: Array<{
      __typename?: 'GetWorkItemsWorkItemPayloadModel';
      id: any;
      name?: string | null;
      approvalState: ApprovalState;
      modifiedAtUtc?: any | null;
      numberOfResubmitted: number;
      numberOfSubmitted: number;
      workOrder: {
        __typename?: 'WorkOrderPayloadModel';
        approvalState: ApprovalState;
        id: number;
        name?: string | null;
      };
      submittedBy?: { __typename?: 'UserPayloadModel'; firstName?: string | null; lastName?: string | null } | null;
      workGroup: { __typename?: 'WorkGroupPayloadModel'; id: number; name?: string | null };
      workCategory: { __typename?: 'WorkCategoryPayloadModel'; name?: string | null };
      qualityManager?: { __typename?: 'UserPayloadModel'; firstName?: string | null; lastName?: string | null } | null;
    }> | null;
  };
};

export type ReopenAppointment_V1MutationVariables = Exact<{
  input: ReopenAppointmentInput;
}>;

export type ReopenAppointment_V1Mutation = {
  __typename?: 'Mutation';
  reopenAppointment_V1: { __typename?: 'GetNoItemResponsePayloadOfAppointmentErrorType'; error: AppointmentErrorType };
};

export type CloseAppointment_V1MutationVariables = Exact<{
  input: CloseAppointmentInput;
}>;

export type CloseAppointment_V1Mutation = {
  __typename?: 'Mutation';
  closeAppointment_V1: { __typename?: 'GetNoItemResponsePayloadOfAppointmentErrorType'; error: AppointmentErrorType };
};

export type GetWorkOrderAppointments_V1QueryVariables = Exact<{
  input?: InputMaybe<GetWorkOrderAppointmentsInput>;
}>;

export type GetWorkOrderAppointments_V1Query = {
  __typename?: 'Query';
  getWorkOrderAppointments_V1: {
    __typename?: 'GetManyPagedResponsePayloadOfGetWorkOrderAppointmentsPayloadModelAndAppointmentErrorType';
    error: AppointmentErrorType;
    data?: Array<{
      __typename?: 'GetWorkOrderAppointmentsPayloadModel';
      id: number;
      type?: string | null;
      status?: AppointmentStatus | null;
      startDateUtc?: any | null;
      endDateUtc?: any | null;
      expectedDuration?: any | null;
      startScreenInformation?: string | null;
      workflowDefinition?: { __typename?: 'WorkflowDefinitionPayloadModel'; id: number; name?: string | null } | null;
      workCategory?: {
        __typename?: 'GetWorkOrderAppointmentsWorkCategoryPayloadModel';
        id: number;
        name?: string | null;
        description?: string | null;
        approvalState: ApprovalState;
        numberOfSubmitted: number;
        numberOfResubmitted: number;
        modifiedAtUtc?: any | null;
        numberOfBlockedFields: number;
        workGroups?: Array<{
          __typename?: 'GetWorkOrderAppointmentsWorkGroupPayloadModel';
          id: number;
          name?: string | null;
          description?: string | null;
          approvalState: ApprovalState;
          numberOfSubmitted: number;
          numberOfResubmitted: number;
          modifiedAtUtc?: any | null;
          numberOfBlockedFields: number;
        }> | null;
      } | null;
      qualityManager?: {
        __typename?: 'UserPayloadModel';
        id: number;
        eMail?: string | null;
        firstName?: string | null;
        lastName?: string | null;
      } | null;
      teams?: Array<{ __typename?: 'TeamPayloadModel'; id: number; name?: string | null }> | null;
    }> | null;
  };
};

export type GetWorkOrderStatus_V1QueryVariables = Exact<{
  input: GetWorkOrderStatusInput;
}>;

export type GetWorkOrderStatus_V1Query = {
  __typename?: 'Query';
  getWorkOrderStatus_V1: {
    __typename?: 'GetSingleResponsePayloadOfGetWorkOrderStatusPayloadModelAndWorkOrderErrorType';
    error: WorkOrderErrorType;
    data?: {
      __typename?: 'GetWorkOrderStatusPayloadModel';
      id: number;
      name?: string | null;
      approvalState: ApprovalState;
      appointments?: Array<{
        __typename?: 'GetWorkOrderStatusAppointmentPayloadModel';
        id: number;
        status?: AppointmentStatus | null;
        constructedByTeams?: Array<{ __typename?: 'TeamPayloadModel'; id: number; name?: string | null }> | null;
        workCategory?: {
          __typename?: 'GetWorkOrderStatusWorkCategoryPayloadModel';
          description?: string | null;
          id: number;
          name?: string | null;
          modifiedAtUtc?: any | null;
          workGroups?: Array<{
            __typename?: 'GetWorkOrderStatusWorkGroupPayloadModel';
            id: number;
            name?: string | null;
            approvalState: ApprovalState;
            workItems?: Array<{ __typename?: 'WorkItemPayloadModel'; id: any; approvalState: ApprovalState }> | null;
          }> | null;
        } | null;
      }> | null;
      qualityManager?: {
        __typename?: 'UserPayloadModel';
        id: number;
        eMail?: string | null;
        firstName?: string | null;
        lastName?: string | null;
      } | null;
    } | null;
  };
};

export type GetWorkCategories_V1QueryVariables = Exact<{
  input?: InputMaybe<GetWorkCategoriesInput>;
}>;

export type GetWorkCategories_V1Query = {
  __typename?: 'Query';
  getWorkCategories_V1: {
    __typename?: 'GetManyPagedNodeResponsePayloadOfGetWorkCategoryWorkCategoryPayloadModelAndWorkCategoryErrorType';
    data?: Array<{ __typename?: 'GetWorkCategoryWorkCategoryPayloadModel'; name?: string | null }> | null;
  };
};

export type GetWorkOrder_V1QueryVariables = Exact<{
  workOrderId: Scalars['Int']['input'];
}>;

export type GetWorkOrder_V1Query = {
  __typename?: 'Query';
  getWorkOrder_V1: {
    __typename?: 'GetSingleResponsePayloadOfGetWorkOrderPayloadModelAndWorkOrderErrorType';
    error: WorkOrderErrorType;
    data?: {
      __typename?: 'GetWorkOrderPayloadModel';
      id: number;
      eaasId?: string | null;
      name?: string | null;
      approvalState: ApprovalState;
      numberOfSubmitted: number;
      numberOfResubmitted: number;
      modifiedAtUtc?: any | null;
      branchOffice?: { __typename?: 'BranchOfficePayloadModel'; id: number; name?: string | null } | null;
      address?: {
        __typename?: 'AddressPayloadModel';
        id: number;
        isReadOnly: boolean;
        street?: string | null;
        number?: string | null;
        zipCode?: string | null;
        city?: string | null;
        state?: string | null;
        country?: string | null;
        coordinates?: { __typename?: 'Coordinates'; latitude: number; longitude: number } | null;
      } | null;
      qualityManager?: {
        __typename?: 'UserPayloadModel';
        id: number;
        eMail?: string | null;
        firstName?: string | null;
        lastName?: string | null;
      } | null;
      projectManager?: {
        __typename?: 'UserPayloadModel';
        id: number;
        eMail?: string | null;
        firstName?: string | null;
        lastName?: string | null;
      } | null;
      product?: { __typename?: 'ProductPayloadModel'; id: number; name?: string | null } | null;
      customers?: Array<{
        __typename?: 'WorkOrderCustomerPayloadModelOfCustomerPayloadModel';
        id: any;
        customer?: {
          __typename?: 'CustomerPayloadModel';
          id: number;
          name?: string | null;
          firstName?: string | null;
          lastName?: string | null;
          mobilePhoneNumber?: string | null;
          phoneNumber?: string | null;
          eMail?: string | null;
        } | null;
      }> | null;
    } | null;
  };
};

export type GetWorkOrders_V1QueryVariables = Exact<{
  page?: InputMaybe<PageInput>;
  orderBy?: InputMaybe<Array<SortDescriptionInput> | SortDescriptionInput>;
  status?: InputMaybe<Array<ApprovalState> | ApprovalState>;
  hasSubmitted?: InputMaybe<Scalars['Boolean']['input']>;
  hasResubmitted?: InputMaybe<Scalars['Boolean']['input']>;
  startDateUtc?: InputMaybe<Scalars['DateTime']['input']>;
  endDateUtc?: InputMaybe<Scalars['DateTime']['input']>;
  qualityManagerId?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  onlyWithAppointments?: InputMaybe<Scalars['Boolean']['input']>;
  workCategoryNames?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;

export type GetWorkOrders_V1Query = {
  __typename?: 'Query';
  getWorkOrders_V1: {
    __typename?: 'GetManyPagedNodeResponsePayloadOfGetWorkOrdersWorkOrderPayloadModelAndWorkOrderErrorType';
    totalNumberOfSubmitted?: number | null;
    totalNumberOfResubmitted?: number | null;
    totalItems: number;
    data?: Array<{
      __typename?: 'GetWorkOrdersWorkOrderPayloadModel';
      id: number;
      eaasId?: string | null;
      numberOfResubmitted: number;
      numberOfSubmitted: number;
      modifiedAtUtc?: any | null;
      name?: string | null;
      approvalState: ApprovalState;
      qualityManager?: {
        __typename?: 'UserPayloadModel';
        id: number;
        firstName?: string | null;
        lastName?: string | null;
      } | null;
      product?: { __typename?: 'ProductPayloadModel'; id: number; name?: string | null } | null;
    }> | null;
  };
};

export type PullWorkOrder_V1MutationVariables = Exact<{
  input: PullWorkOrderInput;
}>;

export type PullWorkOrder_V1Mutation = {
  __typename?: 'Mutation';
  pullWorkOrder_V1: {
    __typename?: 'GetSingleResponsePayloadOfPullWorkOrderPayloadModelAndWorkOrderErrorType';
    error: WorkOrderErrorType;
    data?: {
      __typename?: 'PullWorkOrderPayloadModel';
      id: number;
      name?: string | null;
      approvalState: ApprovalState;
      numberOfSubmitted: number;
      numberOfResubmitted: number;
      modifiedAtUtc?: any | null;
    } | null;
  };
};

export type GetMyselfQueryVariables = Exact<{ [key: string]: never }>;

export type GetMyselfQuery = {
  __typename?: 'Query';
  getUser_V1: {
    __typename?: 'GetSingleResponsePayloadOfGetUserUserPayloadModelAndUserErrorType';
    data?: {
      __typename?: 'GetUserUserPayloadModel';
      id: number;
      firstName?: string | null;
      lastName?: string | null;
      roles?: Array<{ __typename?: 'RolePayloadModel'; name?: string | null }> | null;
      defaultTeam?: {
        __typename?: 'GetUserTeamPayloadModel';
        id: number;
        name?: string | null;
        branchOffice?: { __typename?: 'GetUserBranchOfficePayloadModel'; id: number; name?: string | null } | null;
      } | null;
    } | null;
  };
};

export type GetUsersQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<PageInput>;
}>;

export type GetUsersQuery = {
  __typename?: 'Query';
  getUsers_V1: {
    __typename?: 'GetManyResponsePayloadOfGetUsersUserPayloadModelAndUserErrorType';
    error: UserErrorType;
    data?: Array<{
      __typename?: 'GetUsersUserPayloadModel';
      salutation?: Salutation | null;
      phone?: string | null;
      mobilePhone?: string | null;
      jobTitle?: string | null;
      id: number;
      eMail?: string | null;
      firstName?: string | null;
      lastName?: string | null;
      roles?: Array<{ __typename?: 'RolePayloadModel'; id: number; name?: string | null }> | null;
    }> | null;
  };
};

export type GetSingleWorkOrderQueryVariables = Exact<{
  input: GetWorkOrderInput;
}>;

export type GetSingleWorkOrderQuery = {
  __typename?: 'Query';
  getWorkOrder_V1: {
    __typename?: 'GetSingleResponsePayloadOfGetWorkOrderPayloadModelAndWorkOrderErrorType';
    error: WorkOrderErrorType;
    data?: {
      __typename?: 'GetWorkOrderPayloadModel';
      eaasId?: string | null;
      id: number;
      name?: string | null;
      branchOffice?: { __typename?: 'BranchOfficePayloadModel'; id: number; name?: string | null } | null;
      projectManager?: {
        __typename?: 'UserPayloadModel';
        id: number;
        eMail?: string | null;
        firstName?: string | null;
        lastName?: string | null;
      } | null;
    } | null;
  };
};

export type GetWorkOrderAppointmentsPmQueryVariables = Exact<{
  input: GetWorkOrderAppointmentsInput;
}>;

export type GetWorkOrderAppointmentsPmQuery = {
  __typename?: 'Query';
  getWorkOrderAppointments_V1: {
    __typename?: 'GetManyPagedResponsePayloadOfGetWorkOrderAppointmentsPayloadModelAndAppointmentErrorType';
    totalItems: number;
    error: AppointmentErrorType;
    data?: Array<{
      __typename?: 'GetWorkOrderAppointmentsPayloadModel';
      id: number;
      type?: string | null;
      status?: AppointmentStatus | null;
      startDateUtc?: any | null;
      endDateUtc?: any | null;
      expectedDuration?: any | null;
      startScreenInformation?: string | null;
      isBinding: boolean;
      comment?: string | null;
      teams?: Array<{ __typename?: 'TeamPayloadModel'; id: number; name?: string | null }> | null;
      branchOffice?: { __typename?: 'BranchOfficePayloadModel'; id: number; name?: string | null } | null;
      craftsmen?: Array<{
        __typename?: 'UserPayloadModel';
        id: number;
        firstName?: string | null;
        lastName?: string | null;
      }> | null;
      partnerCompanies?: Array<{ __typename?: 'PartnerCompanyPayloadModel'; id: number; name?: string | null }> | null;
    }> | null;
  };
};

export const GetAppointments_V1Document = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getAppointments_V1' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'notBeforeUtc' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'DateTime' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'notAfterUtc' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'DateTime' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'branch' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'team' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'query' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'appointmentType' } },
          type: {
            kind: 'ListType',
            type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'page' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'PageInput' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'orderBy' } },
          type: {
            kind: 'ListType',
            type: {
              kind: 'NonNullType',
              type: { kind: 'NamedType', name: { kind: 'Name', value: 'SortDescriptionInput' } },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getAppointments_V1' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'notBeforeUtc' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'notBeforeUtc' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'notAfterUtc' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'notAfterUtc' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'branchOfficeId' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'branch' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'teamId' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'team' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'search' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'query' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'workflowDefinitions' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'appointmentType' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'isBinding' },
                      value: { kind: 'BooleanValue', value: true },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'page' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'page' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'onlyReturnMyAssginedAppointments' },
                      value: { kind: 'BooleanValue', value: false },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'orderBy' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'orderBy' } },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'totalItems' } },
                { kind: 'Field', name: { kind: 'Name', value: 'error' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'data' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'startDateUtc' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'endDateUtc' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'expectedDuration' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'startScreenInformation' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'isBinding' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'constructedByTeams' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'team' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'constructedByCraftsmen' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'craftsman' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'workOrder' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'eaasId' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'approvalState' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'numberOfSubmitted' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'numberOfResubmitted' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'modifiedAtUtc' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'readOnlyAddress' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'isReadOnly' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'street' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'number' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'zipCode' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetAppointments_V1Query, GetAppointments_V1QueryVariables>;
export const UnassignUserFromAppointmentDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UnassignUserFromAppointment' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'appointmentId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'userId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'unassignUserFromAppointment_V1' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'appointmentId' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'appointmentId' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'userId' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'userId' } },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'error' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UnassignUserFromAppointmentMutation, UnassignUserFromAppointmentMutationVariables>;
export const GetAppointmentWorkforce_V1Document = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetAppointmentWorkforce_V1' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'appointmentId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getAppointmentWorkforce_V1' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'appointmentId' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'appointmentId' } },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'error' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'data' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'craftsmen' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'eMail' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'defaultTeamId' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'teams' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'branchOffice' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetAppointmentWorkforce_V1Query, GetAppointmentWorkforce_V1QueryVariables>;
export const AttachUserToAppointment_V1Document = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'AttachUserToAppointment_V1' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'appointmentId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'userIds' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'ListType',
              type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'attachUserToAppointment_V1' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'appointmentId' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'appointmentId' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'userIds' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'userIds' } },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'data' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'assignments' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'userId' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'assignment' } },
                          ],
                        },
                      },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'error' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AttachUserToAppointment_V1Mutation, AttachUserToAppointment_V1MutationVariables>;
export const AttachTeamToAppointment_V1Document = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'AttachTeamToAppointment_V1' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'AttachTeamToAppointmentInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'attachTeamToAppointment_V1' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'data' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'users' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
                        },
                      },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'error' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AttachTeamToAppointment_V1Mutation, AttachTeamToAppointment_V1MutationVariables>;
export const UnassignTeamFromAppointmentDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UnassignTeamFromAppointment' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UnassignTeamFromAppointmentInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'unassignTeamFromAppointment_V1' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'error' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UnassignTeamFromAppointmentMutation, UnassignTeamFromAppointmentMutationVariables>;
export const GetUsers_V1Document = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetUsers_V1' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'roleId' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'search' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'page' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'PageInput' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getUsers_V1' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'roleId' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'roleId' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'search' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'search' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'page' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'page' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'includeDeleted' },
                      value: { kind: 'BooleanValue', value: true },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'error' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'data' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'jobTitle' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'isDeleted' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'roles' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'employer' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'eMail' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetUsers_V1Query, GetUsers_V1QueryVariables>;
export const GetAppointment_V1Document = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getAppointment_V1' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'GetAppointmentInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getAppointment_V1' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'error' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'data' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'appointment' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'isBinding' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'comment' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'startDateUtc' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'endDateUtc' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'expectedDuration' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'startScreenInformation' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'workOrder' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'eaasId' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'constructedByTeams' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'team' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'constructedByCraftsmen' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'craftsman' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'eMail' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'workflowDefinition' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'branchOffice' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'partnerCompanies' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetAppointment_V1Query, GetAppointment_V1QueryVariables>;
export const ScheduleAppointment_V1Document = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'scheduleAppointment_V1' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ScheduleAppointmentInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'scheduleAppointment_V1' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'error' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'data' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ScheduleAppointment_V1Mutation, ScheduleAppointment_V1MutationVariables>;
export const PostAppointment_V1Document = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'postAppointment_V1' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'PostAppointmentInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'postAppointment_V1' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'error' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'data' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'startAtUtc' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'endAtUtc' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'isBinding' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'teams' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'workOrder' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'workflowDefinition' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<PostAppointment_V1Mutation, PostAppointment_V1MutationVariables>;
export const PatchAppointmentComposite_V1Document = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'patchAppointmentComposite_V1' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'PatchAppointmentCompositeInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'patchAppointmentComposite_V1' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'error' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<PatchAppointmentComposite_V1Mutation, PatchAppointmentComposite_V1MutationVariables>;
export const PostBlocker_V1Document = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'postBlocker_V1' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'PostBlockerInput' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'postBlocker_V1' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'error' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'data' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'startAtUtc' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'endAtUtc' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'reason' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<PostBlocker_V1Mutation, PostBlocker_V1MutationVariables>;
export const PatchBlocker_V1Document = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'patchBlocker_V1' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'PatchBlockerInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'patchBlocker_V1' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'error' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'data' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'startAtUtc' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'endAtUtc' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'reason' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<PatchBlocker_V1Mutation, PatchBlocker_V1MutationVariables>;
export const GetBlocker_V1Document = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getBlocker_V1' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'GetBlockerInput' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getBlocker_V1' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'error' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'data' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'branchOffice' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'comment' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'endAtUtc' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'reason' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'startAtUtc' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'teams' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'users' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'partnerCompanies' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetBlocker_V1Query, GetBlocker_V1QueryVariables>;
export const GetCalendarItems_V1Document = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getCalendarItems_V1' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'GetCalendarItemsInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getCalendarItems_V1' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'totalItems' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'data' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'InlineFragment',
                        typeCondition: {
                          kind: 'NamedType',
                          name: { kind: 'Name', value: 'BlockerCalendarItemPayloadModel' },
                        },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'startAtUtc' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'endAtUtc' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'users' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'eMail' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'teams' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'reason' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'branchOffice' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'partnerCompanies' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: {
                          kind: 'NamedType',
                          name: { kind: 'Name', value: 'AppointmentCalendarItemPayloadModel' },
                        },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'startAtUtc' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'endAtUtc' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'isBinding' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'teams' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'users' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'eMail' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'partnerCompanies' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'workOrder' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'approvalState' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'numberOfSubmitted' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'numberOfResubmitted' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'modifiedAtUtc' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'numberOfBlockedFields' } },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'workflowDefinition' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'branchOffice' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetCalendarItems_V1Query, GetCalendarItems_V1QueryVariables>;
export const GetCraftCompanies_V1Document = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetCraftCompanies_V1' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'GetCraftCompaniesInput' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getCraftCompanies_V1' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'totalItems' } },
                { kind: 'Field', name: { kind: 'Name', value: 'error' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'data' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetCraftCompanies_V1Query, GetCraftCompanies_V1QueryVariables>;
export const GetWorkOrders_V1_PmDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getWorkOrders_V1_PM' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'GetWorkOrdersInput' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getWorkOrders_V1' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'totalItems' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'data' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'eaasId' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'qualityManager' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'modifiedAtUtc' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'customers' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'customer' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [{ kind: 'Field', name: { kind: 'Name', value: 'name' } }],
                              },
                            },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'paused' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'approvalState' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'branchOffice' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'product' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetWorkOrders_V1_PmQuery, GetWorkOrders_V1_PmQueryVariables>;
export const DeleteAppointment_V1Document = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'deleteAppointment_V1' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'DeleteAppointmentInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'deleteAppointment_V1' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'error' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DeleteAppointment_V1Mutation, DeleteAppointment_V1MutationVariables>;
export const DeleteBlocker_V1Document = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'deleteBlocker_V1' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'DeleteBlockerInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'deleteBlocker_V1' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'error' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DeleteBlocker_V1Mutation, DeleteBlocker_V1MutationVariables>;
export const GetBranchesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetBranches' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'page' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'PageInput' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getBranchOffices_V1' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'page' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'page' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'includeDeleted' },
                      value: { kind: 'BooleanValue', value: true },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'totalItems' } },
                { kind: 'Field', name: { kind: 'Name', value: 'error' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'data' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'isDeleted' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetBranchesQuery, GetBranchesQueryVariables>;
export const GetWorkOrderFiles_V1Document = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetWorkOrderFiles_V1' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'GetWorkOrderFilesInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getWorkOrderFiles_V1' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'error' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'data' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'parentId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'files' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'uri' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'fileName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'mimeType' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'fileSize' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'isSafe' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'virusScanResult' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'createdBy' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'eMail' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                                ],
                              },
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'createdAtUtc' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetWorkOrderFiles_V1Query, GetWorkOrderFiles_V1QueryVariables>;
export const GetRoles_V1Document = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetRoles_V1' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getRoles_V1' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'page' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'size' },
                            value: { kind: 'IntValue', value: '100' },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'totalItems' } },
                { kind: 'Field', name: { kind: 'Name', value: 'error' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'data' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetRoles_V1Query, GetRoles_V1QueryVariables>;
export const GetTeamsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetTeams' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'GetTeamsInput' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getTeams_V1' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'totalItems' } },
                { kind: 'Field', name: { kind: 'Name', value: 'error' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'data' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'isDeleted' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'branchOffice' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'name' } }],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetTeamsQuery, GetTeamsQueryVariables>;
export const GetTeams_V1Document = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetTeams_V1' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'GetTeamsInput' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getTeams_V1' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'totalItems' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'data' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'isDeleted' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'branchOffice' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'serviceProvider' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'skills' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'workflowDefinition' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'members' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'eMail' } },
                          ],
                        },
                      },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'error' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetTeams_V1Query, GetTeams_V1QueryVariables>;
export const CreateTeam_V1Document = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'createTeam_V1' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'CreateTeamInput' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createTeam_V1' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'data' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'branchOffice' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'skills' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'workflowDefinition' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'members' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'eMail' } },
                          ],
                        },
                      },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'error' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CreateTeam_V1Mutation, CreateTeam_V1MutationVariables>;
export const UpdateTeam_V1Document = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'updateTeam_V1' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'UpdateTeamInput' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateTeam_V1' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'data' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'branchOffice' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'skills' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'workflowDefinition' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'members' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'eMail' } },
                          ],
                        },
                      },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'error' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateTeam_V1Mutation, UpdateTeam_V1MutationVariables>;
export const UploadWorkOrderDocuments_V1Document = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UploadWorkOrderDocuments_V1' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UploadWorkOrderDocumentsInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'uploadWorkOrderDocuments_V1' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'error' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'data' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'uri' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'fileName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'mimeType' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'fileSize' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'isSafe' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'virusScanResult' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UploadWorkOrderDocuments_V1Mutation, UploadWorkOrderDocuments_V1MutationVariables>;
export const GetFieldValuesByWorkOrder_V1Document = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getFieldValuesByWorkOrder_V1' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'GetFieldValuesByWorkOrderInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getFieldValuesByWorkOrder_V1' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'error' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'data' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'workGroups' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'workGroupId' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'workGroupName' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'fieldValues' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'fieldName' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'isApprovalRequired' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'fieldDefinition' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'workItemInfo' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'values' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'isArray' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'approvalState' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'createdAtUtc' } },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'createdBy' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                                            ],
                                          },
                                        },
                                        { kind: 'Field', name: { kind: 'Name', value: 'lastSubmitAtUtc' } },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'lastSubmitBy' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                                            ],
                                          },
                                        },
                                        { kind: 'Field', name: { kind: 'Name', value: 'decisionMadeAtUtc' } },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'decisionMadeBy' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                                            ],
                                          },
                                        },
                                        { kind: 'Field', name: { kind: 'Name', value: 'rejectReason' } },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetFieldValuesByWorkOrder_V1Query, GetFieldValuesByWorkOrder_V1QueryVariables>;
export const GetWorkflowDefinitions_V1Document = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getWorkflowDefinitions_V1' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getWorkflowDefinitions_V1' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'page' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'number' },
                            value: { kind: 'IntValue', value: '0' },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'size' },
                            value: { kind: 'IntValue', value: '100' },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'totalItems' } },
                { kind: 'Field', name: { kind: 'Name', value: 'error' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'data' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetWorkflowDefinitions_V1Query, GetWorkflowDefinitions_V1QueryVariables>;
export const GetWorkflowDefinitionsComposite_V1Document = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getWorkflowDefinitionsComposite_V1' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getWorkflowDefinitionsComposite_V1' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'error' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'data' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'appointmentTypes' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'blockerReasons' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'workflowDefinitions' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetWorkflowDefinitionsComposite_V1Query, GetWorkflowDefinitionsComposite_V1QueryVariables>;
export const DecideFieldValueEntry_V1Document = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'decideFieldValueEntry_V1' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'DecideFieldValueEntryInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'decideFieldValueEntry_V1' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'data' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'approvalState' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'error' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DecideFieldValueEntry_V1Mutation, DecideFieldValueEntry_V1MutationVariables>;
export const DecideFieldValueItems_V1Document = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'decideFieldValueItems_V1' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'DecideFieldValueItemsInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'decideFieldValueItems_V1' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'data' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'approvalState' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'error' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DecideFieldValueItems_V1Mutation, DecideFieldValueItems_V1MutationVariables>;
export const GetWorkItemFieldValues_V1Document = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getWorkItemFieldValues_V1' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'GetWorkItemFieldValuesInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getWorkItemFieldValues_V1' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'error' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'data' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'fieldValue' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'isApprovalRequired' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'fieldDefinition' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'values' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'createdAtUtc' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'approvalState' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'comment' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'decisionMadeAtUtc' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'rejectReason' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'isArray' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'lastSubmitAtUtc' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'itemDecisions' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'approvalState' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'arrayIndex' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'decisionMadeAtUtc' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'decisionMadeById' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'mediaId' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'rejectReason' } },
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'decisionMadeBy' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'eMail' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'lastSubmitBy' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'eMail' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'createdBy' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'eMail' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'acceptanceCriteria' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'headline' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'bulletPoints' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'exampleImages' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [{ kind: 'Field', name: { kind: 'Name', value: 'imageUrl' } }],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'error' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetWorkItemFieldValues_V1Query, GetWorkItemFieldValues_V1QueryVariables>;
export const GenerateAppointmentReport_V1Document = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'GenerateAppointmentReport_V1' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'GenerateAppointmentReportInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'generateAppointmentReport_V1' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'error' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'data' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'state' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'results' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'key' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GenerateAppointmentReport_V1Mutation, GenerateAppointmentReport_V1MutationVariables>;
export const GenerateZipAppointmentPictures_V1Document = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'GenerateZipAppointmentPictures_V1' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'GenerateZipAppointmentPicturesInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'generateZipAppointmentPictures_V1' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'error' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'data' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'state' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'results' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'key' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GenerateZipAppointmentPictures_V1Mutation,
  GenerateZipAppointmentPictures_V1MutationVariables
>;
export const GetJob_V1Document = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getJob_V1' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'GetJobInput' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getJob_V1' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'error' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'data' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'state' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'results' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'key' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetJob_V1Query, GetJob_V1QueryVariables>;
export const GetWorkGroup_V1Document = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetWorkGroup_V1' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'GetWorkGroupInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getWorkGroup_V1' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'error' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'data' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'approvalState' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'items' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'approvalState' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'modifiedAtUtc' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'workCategory' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetWorkGroup_V1Query, GetWorkGroup_V1QueryVariables>;
export const GetWorkItems_V1Document = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getWorkItems_V1' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'page' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'PageInput' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'orderBy' } },
          type: {
            kind: 'ListType',
            type: {
              kind: 'NonNullType',
              type: { kind: 'NamedType', name: { kind: 'Name', value: 'SortDescriptionInput' } },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'states' } },
          type: {
            kind: 'ListType',
            type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ApprovalState' } } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'startDateUtc' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'DateTime' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'endDateUtc' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'DateTime' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'qualityManagerId' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'workOrderId' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'workCategoryNames' } },
          type: {
            kind: 'ListType',
            type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getWorkItems_V1' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'page' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'page' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'orderBy' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'orderBy' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'states' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'states' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'startDateUtc' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'startDateUtc' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'endDateUtc' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'endDateUtc' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'qualityManagerId' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'qualityManagerId' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'workOrderId' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'workOrderId' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'includeStatistics' },
                      value: { kind: 'BooleanValue', value: true },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'workCategoryNames' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'workCategoryNames' } },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'totalNumberOfSubmitted' } },
                { kind: 'Field', name: { kind: 'Name', value: 'totalNumberOfResubmitted' } },
                { kind: 'Field', name: { kind: 'Name', value: 'totalItems' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'data' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'workOrder' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'approvalState' } }],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'approvalState' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'modifiedAtUtc' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'numberOfResubmitted' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'numberOfSubmitted' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'submittedBy' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'workGroup' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'workCategory' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'name' } }],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'workOrder' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'qualityManager' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                          ],
                        },
                      },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'totalItems' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetWorkItems_V1Query, GetWorkItems_V1QueryVariables>;
export const ReopenAppointment_V1Document = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'reopenAppointment_V1' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ReopenAppointmentInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'reopenAppointment_V1' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'error' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ReopenAppointment_V1Mutation, ReopenAppointment_V1MutationVariables>;
export const CloseAppointment_V1Document = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'closeAppointment_V1' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'CloseAppointmentInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'closeAppointment_V1' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'error' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CloseAppointment_V1Mutation, CloseAppointment_V1MutationVariables>;
export const GetWorkOrderAppointments_V1Document = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getWorkOrderAppointments_V1' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'GetWorkOrderAppointmentsInput' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getWorkOrderAppointments_V1' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'error' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'data' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'startDateUtc' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'endDateUtc' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'expectedDuration' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'workflowDefinition' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'startScreenInformation' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'workCategory' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'approvalState' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'numberOfSubmitted' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'numberOfResubmitted' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'modifiedAtUtc' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'numberOfBlockedFields' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'workGroups' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'approvalState' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'numberOfSubmitted' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'numberOfSubmitted' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'numberOfResubmitted' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'modifiedAtUtc' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'numberOfBlockedFields' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'qualityManager' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'eMail' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'teams' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetWorkOrderAppointments_V1Query, GetWorkOrderAppointments_V1QueryVariables>;
export const GetWorkOrderStatus_V1Document = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getWorkOrderStatus_V1' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'GetWorkOrderStatusInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getWorkOrderStatus_V1' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'error' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'data' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'approvalState' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'appointments' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'constructedByTeams' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'workCategory' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'modifiedAtUtc' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'workGroups' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'approvalState' } },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'workItems' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'approvalState' } },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'qualityManager' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'eMail' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetWorkOrderStatus_V1Query, GetWorkOrderStatus_V1QueryVariables>;
export const GetWorkCategories_V1Document = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getWorkCategories_V1' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'GetWorkCategoriesInput' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getWorkCategories_V1' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'data' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'name' } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetWorkCategories_V1Query, GetWorkCategories_V1QueryVariables>;
export const GetWorkOrder_V1Document = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getWorkOrder_V1' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'workOrderId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getWorkOrder_V1' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'workOrderId' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'workOrderId' } },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'error' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'data' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'eaasId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'approvalState' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'numberOfSubmitted' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'numberOfResubmitted' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'modifiedAtUtc' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'branchOffice' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'address' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'isReadOnly' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'street' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'number' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'zipCode' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'state' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'country' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'coordinates' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'latitude' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'longitude' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'qualityManager' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'eMail' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'projectManager' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'eMail' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'product' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'customers' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'customer' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'mobilePhoneNumber' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'phoneNumber' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'eMail' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetWorkOrder_V1Query, GetWorkOrder_V1QueryVariables>;
export const GetWorkOrders_V1Document = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getWorkOrders_V1' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'page' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'PageInput' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'orderBy' } },
          type: {
            kind: 'ListType',
            type: {
              kind: 'NonNullType',
              type: { kind: 'NamedType', name: { kind: 'Name', value: 'SortDescriptionInput' } },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'status' } },
          type: {
            kind: 'ListType',
            type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ApprovalState' } } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'hasSubmitted' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'hasResubmitted' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'startDateUtc' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'DateTime' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'endDateUtc' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'DateTime' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'qualityManagerId' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'search' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'onlyWithAppointments' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'workCategoryNames' } },
          type: {
            kind: 'ListType',
            type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getWorkOrders_V1' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'page' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'page' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'orderBy' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'orderBy' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'status' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'status' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'hasSubmitted' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'hasSubmitted' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'hasResubmitted' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'hasResubmitted' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'startDateUtc' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'startDateUtc' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'endDateUtc' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'endDateUtc' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'qualityManagerId' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'qualityManagerId' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'includeStatistics' },
                      value: { kind: 'BooleanValue', value: true },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'search' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'search' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'onlyWithAppointments' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'onlyWithAppointments' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'workCategoryNames' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'workCategoryNames' } },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'totalNumberOfSubmitted' } },
                { kind: 'Field', name: { kind: 'Name', value: 'totalNumberOfResubmitted' } },
                { kind: 'Field', name: { kind: 'Name', value: 'totalItems' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'data' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'eaasId' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'qualityManager' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'numberOfResubmitted' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'numberOfSubmitted' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'modifiedAtUtc' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'approvalState' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'product' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetWorkOrders_V1Query, GetWorkOrders_V1QueryVariables>;
export const PullWorkOrder_V1Document = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'PullWorkOrder_V1' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'PullWorkOrderInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'pullWorkOrder_V1' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'error' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'data' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'approvalState' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'numberOfSubmitted' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'numberOfResubmitted' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'modifiedAtUtc' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<PullWorkOrder_V1Mutation, PullWorkOrder_V1MutationVariables>;
export const GetMyselfDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getMyself' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getUser_V1' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'data' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'roles' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'name' } }],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'defaultTeam' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'branchOffice' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetMyselfQuery, GetMyselfQueryVariables>;
export const GetUsersDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getUsers' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'search' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'page' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'PageInput' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getUsers_V1' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'roleId' },
                      value: { kind: 'IntValue', value: '4' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'page' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'page' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'search' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'search' } },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'error' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'data' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'salutation' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'phone' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'mobilePhone' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'jobTitle' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'eMail' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'roles' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetUsersQuery, GetUsersQueryVariables>;
export const GetSingleWorkOrderDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getSingleWorkOrder' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'GetWorkOrderInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getWorkOrder_V1' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'error' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'data' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'eaasId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'branchOffice' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'projectManager' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'eMail' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetSingleWorkOrderQuery, GetSingleWorkOrderQueryVariables>;
export const GetWorkOrderAppointmentsPmDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetWorkOrderAppointmentsPM' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'GetWorkOrderAppointmentsInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getWorkOrderAppointments_V1' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'totalItems' } },
                { kind: 'Field', name: { kind: 'Name', value: 'error' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'data' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'startDateUtc' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'endDateUtc' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'expectedDuration' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'startScreenInformation' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'isBinding' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'teams' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'branchOffice' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'comment' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'craftsmen' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'partnerCompanies' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetWorkOrderAppointmentsPmQuery, GetWorkOrderAppointmentsPmQueryVariables>;
